module.exports = {
  BusinessNo: 'หมายเลขธุรกิจ',
  WarehouseNo: 'หมายเลขขาเข้า',
  MasterBillNo: 'หมายเลขเดี่ยวหลัก',
  HBL: 'HBL',
  FileNo: 'หมายเลขไฟล์',
  BookingNo: 'หมายเลขการจอง',
  ItemNo: 'หมายเลขสินค้า',
  BusinessReferenceNo: 'หมายเลขอ้างอิงธุรกิจ',
  BillNo: 'หมายเลขบิล',
  PreBookingNo: 'หมายเลขการจองห้องโดยสาร',
  CBANumber: 'หมายเลขประกาศศุลกากร',
  CustomsStatus: 'สถานะศุลกากร',
  CustomsStatusUpdateTime: 'เวลาต่ออายุสถานะศุลกากร',
  ReceiptDetails: 'รายละเอียดการตอบกลับ',
  CustomsBrokerStatus: 'สถานะตัวแทนออกของ',
  CustomsReceiptRecord: 'บันทึกการกลับมาของศุลกากร',
  CustomsTime: 'เวลาศุลกากร',
  CustomsCode2: 'รหัสศุลกากร',
  CustomsDescription: 'ศุลกากร Description',
  UnifiedCoding: 'การเข้ารหัสแบบครบวงจร',
  HBLSplitCombineNo: 'HBL คะแนนและหมายเลขเดี่ยว',
  MBLSplitCombineNo: 'MBL คะแนนและหมายเลขเดี่ยว',
  ConsignationCompany: 'หน่วยงานหลัก',
  BookingAgent: 'ตัวแทนการจองห้องพัก',
  BookingOrExchangeAgent: 'ตัวแทนรับจองห้องพัก / ตัวแทนแลกเปลี่ยนเงินตรา',
  CarrierAgent: 'เรือนำเที่ยว',
  DestinationAgent: 'ตัวแทนท่าเรือปลายทาง',
  ShippingCompany: 'บริษัท เรือ',
  OperateCarrier: 'สายเรือหลัก',
  VSACarrier: 'สายเรือร่วมเดินเรือ',
  InternalVoy: 'เที่ยวเรือภายใน',
  CopyShip: 'คัดลอกข้อมูลสายเรือหลักไปยังสายเรือร่วม',
  ContainerNo: 'หมายเลขกล่อง',
  BoxController: 'กล่องควบคุม Man',
  LFD: 'LFD',
  CarNumber: 'หมายเลขตัวถัง',
  ContainerNoOutOfRange: 'จำนวนกล่อง ความยาวเกินขีด จำกัด',
  PortOfLoading: 'ท่าเรือขนส่งสินค้า (POL)',
  PortOfLoadingPOR: 'ท่าเรือขนส่งสินค้า (POR)',
  TransitPort: 'พอร์ตการขนส่ง',
  PortOfDestination: 'ท่าเรือปลายทาง',
  PortOfDestinationPod: 'ท่าเรือปลายทาง (POD)',
  PortOfDischarge: 'ท่าเรือขนถ่ายสินค้า (POD)',
  PortOfDischargeSeaAndComprehensive: 'ท่าเรือขนถ่าย (ทะเล / รวม)',
  DischargingPortCountry: 'ประเทศ / ภูมิภาคของท่าเรือขนถ่าย',
  DestinationPortCountry: 'ปลายทาง ประเทศ / ภูมิภาค',
  dischargingPort: 'ท่าเรือขนถ่ายสินค้า',
  FirstPortOfDischarge: 'ท่าเรือขนถ่ายสินค้าหนึ่ง',
  branchLineDateOfDeparture: 'วันที่ออกเดินทาง',
  branchLineDateOfArrival: 'สาขา ท่าเรือ วันที่',
  DateOfDeparture: 'วันที่ออกเดินทาง',
  DateOfDeparture2: 'วันออก(ETD)',
  BookingDate: 'วันที่จอง',
  BargeDateOfDeparture: 'วันที่ออกเดินทางของเรือ',
  BargeCYCutOffDate2: 'กำหนดเวลาเดินเรือ',
  BargePortOfLoading: 'ท่าเรือขนส่งสินค้า (POL)',
  BargeVessel: 'ชื่อเรือบรรทุกสินค้า',
  BargeVoyage: 'เรือบรรทุกสินค้า',
  BargePOL: 'เรือ POL',
  SecondDateOfDeparture: 'วันที่ออกเดินทาง 2',
  DeliveryCompletionDate: 'เวลาจัดส่งเสร็จสิ้น',
  DateOfArrival: 'วันที่มาถึงท่าเรือ',
  DateOfArrival2: 'วันที่มาถึงท่าเรือ (ETA)',
  DateOfArrival3: 'วันที่มาถึงท่าเรือ (ETA)',
  DateOfCreation: 'วันที่สร้าง',
  CYCutOffDate2: 'วันที่ปิดรับสมัคร',
  DocCutOffDate: 'วันที่ตัดตอน',
  DeclareCutOffDate: 'วันที่สิ้นสุดการประกาศ',
  LoadingDate: 'วันที่บรรจุ',
  PreAuditTime: 'เวลาตรวจสอบก่อนการพิจารณาคดี',
  CallSignOfBookingShip: 'หมายเลขโทรจองเรือ',
  MasterBLFreightTerm: 'เงื่อนไขการจัดส่งสินค้าสำหรับคำสั่งซื้อหลัก',
  MasterBLFreightTermTootip: 'เงื่อนไขการจัดส่งสินค้าสำหรับคำสั่งซื้อหลัก',
  OrderChannels: 'ช่องทางการสั่งซื้อ',
  CargoType: 'ประเภทสินค้า',
  Shipper: 'จัดส่งโดย',
  ShipperCode: 'รหัสของผู้จัดส่ง',
  Consignee: 'ผู้รับสินค้า',
  ConsigneeCode: 'รหัสผู้รับ',
  SONO: 'SO NO.',
  ShippingCompanyContractNo: 'เกี่ยวกับ บริษัท เรือ',
  InnerContractNo: 'หมายเลขภายใน',
  HBLRemarks: 'หมายเหตุ HBL B / L',
  quotationNum: 'หมายเลขใบเสนอราคา',
  Vessel: 'ชื่อเรือ',
  Voyage: 'เที่ยวบิน',
  CarrierVoyage: 'การเดินทางภายในกองเรือ',
  OperationDepartment: 'ฝ่ายปฏิบัติการ',
  SalesDepartment: 'ฝ่ายขาย',
  FLCLType: 'ประเภทการสะกดทั้งหมด',
  ExportControlledProducts: 'ผลิตภัณฑ์ท่อส่งออก',
  LocalService: 'บริการท้องถิ่น',
  NotLocalService: 'ไม่มีบริการในพื้นที่',
  SolicitationType: 'ประเภทของแพ็คเกจ',
  SO_NO1: 'S/O No.',
  MBL_NO: 'MB/L No.',
  ServiceProduct: 'ผลิตภัณฑ์บริการ',
  WoodOrNotWood: 'ไม้ / Non-wood',
  handlingInformation: 'Handling Information',
  HazardousGoodsOption: 'ตัวเลือกสินค้าอันตราย',
  ContractRateProperty: 'คุณสมบัติของราคาโดยประมาณ',
  IsNac: 'เป็น NAC หรือไม่',
  ApplicableProductName: 'ชื่อสินค้าที่ใช้ได้',
  PleaseEnterNAC: 'กรุณากรอก NAC',
  PleaseEnterTheShippingCompanyContractNumber: 'กรุณากรอกหมายเลขสัญญาของบริษัทเรือ',
  CargoInsuranceQuantity: 'จำนวนประกันภัยสินค้า',
  CargoInsuranceUnit: 'หน่วยประกันภัยสินค้า',
  ValidityStartDate: 'วันที่เริ่มมีผลบังคับใช้',
  ValidityEndDate: 'วันที่สิ้นสุดผลบังคับใช้',
  CargoInsurance: 'ประกันภัยขนส่ง',
  ShutOut: 'การผ่านด่านศุลกากร',
  ShutOutDate: 'เวลาการผ่านด่านศุลกากร',
  CancelShutOut: 'การยกเลิกพิธีการศุลกากร',
  ABargeOrNot: 'ไม่ว่าจะเป็นเรือบรรทุกสินค้า',
  yes: 'ใช่',
  no: 'ไม่',
  Operation: 'การดำเนินงาน',
  Sales: 'ฝ่ายขาย',
  CustomerService: 'ฝ่ายบริการลูกค้า',
  Documents: 'เอกสารประกอบ',
  Airline: 'เส้นทางบิน',
  PreAuditPerson: 'ผู้ตรวจสอบก่อนการพิจารณาคดี',
  Creator: 'สร้างโดย',
  Code: 'CODE',
  Accrued: 'นับแล้ว',
  AirlineCode: 'LINE CODE',
  ShowRelevantBusiness: 'แสดงธุรกิจที่เกี่ยวข้อง',
  CustomsBroker: 'ตัวแทนออกของ',
  AdvancePayment: 'ไม่ว่าจะเป็นการผ่อนชำระค่าอากร',
  HasPrintBooking: 'พิมพ์ใบจอง',
  PaymentTime: 'เวลาชำระภาษี',
  CustomsDutyAmount: 'จำนวนภาษีศุลกากร',
  VatAmount: 'จำนวนภาษีมูลค่าเพิ่ม',
  TaxRemarks: 'หมายเหตุภาษี',
  Warehouse: 'คลังสินค้า',
  HaulageCompany: 'บริษัท ขนส่ง',
  CarryingCmpAdjustBlockedTip: 'มีคำสั่งที่เลือกซึ่งไม่ได้ติ๊กบรรจุ/ส่งถึงหน้างาน ไม่สามารถปรับเปลี่ยนบริษัทขนส่งได้',
  AbnormalBusinessNo: 'เลขธุรกิจผิดปกติ',
  TradeTerms2: 'เงื่อนไขการค้า',
  BusinessStatus: 'สถานะธุรกิจ',
  StatusTracking: 'ติดตามสถานะ',
  AuditStatus: 'สถานะการตรวจสอบ',
  Display: 'แสดง',
  EstimatedArrivalTime: 'เวลาโดยประมาณ',
  EstimatedPortArrivalTime: 'เวลาถึงท่าเรือ/เวลาถึงที่คาดการณ์',
  ArrivalTime: 'เวลามาถึงท่าเรือจริง',
  CustomsClearance: 'ท่าเรือปลายทาง',
  ActualCustomsReleaseTime: 'เวลาปล่อยจริง',
  DeliveryTime: 'เวลาจัดส่ง',
  ReturnTime: 'เวลาคืนกล่อง',
  DeliveryTime2: 'เวลาส่งโพซิชั่น',
  DeliveryDate: 'วันที่จัดส่ง',
  Query: 'สอบถาม',
  Return: 'กลับ',
  Prompt1: 'กรุณากรอกหมายเลขธุรกิจ',
  ResetFilter: 'รีเซ็ตเงื่อนไข',
  Tip1: 'คลิกสองครั้งเพื่อแสดงสถานะ SOP',
  TipCharge: 'คลิกเพื่อแสดงข้อมูลพื้นฐานของธุรกิจ',
  MBLIssueBillLading: 'สถานะการออกใบตราส่งสินค้า MBL',
  HBLIssueBillLading: 'สถานะการออกใบตราส่งสินค้า HBL',
  ConsignationRelationNumber: 'หมายเลขพันธมิตรที่ได้รับมอบหมาย',
  BusinessCommissionedRelationNumber: 'หมายเลขติดต่อกลับ',
  ChannelNo: 'หมายเลขช่อง',
  Customer: 'ลูกค้า',
  ConsignationStatus: 'สถานะการมอบหมาย',
  ConsignationStatusTime: 'เวลาสถานะการมอบหมาย',
  PlaceOfDelivery: 'สถานที่จัดส่ง',
  FinalPlaceOfDelivery: 'สถานที่ส่งมอบขั้นสุดท้าย',
  DeliveryCountry: 'ประเทศที่จัดส่ง',
  AirlineArea: 'เส้นทาง (พื้นที่)',
  SequenceNumber: 'หมายเลขซีเรียล',
  Tip2: 'แบบสอบถามบันทึกข้อมูล Push',
  View: 'ดู',
  Edit: 'บรรณาธิการ',
  Cancel: 'การยกเลิก',
  SaveTheDefaultValues: 'บันทึกค่าปริยาย',
  NominatedAgent: 'ตัวแทนจัดส่งสินค้า',
  NominatedAgentCount: 'ระบุจำนวนตัวแทนจัดส่งสินค้า',
  ActualQuantity: 'จำนวนชิ้นจริง',
  ActualWeight: 'น้ำหนักรวมที่แท้จริง',
  ActualVolume: 'ปริมาณจริง',
  ChargedWeight: 'น้ำหนักการเรียกเก็บเงิน',
  VolumetricWeight: 'ผลิตภัณฑ์วัสดุ',
  ChargedWeightRT: 'น้ำหนักการเรียกเก็บเงิน RT',
  BookingProperty: 'คุณสมบัติการจองห้องพัก',
  IssueMethod: 'ทางออกเดียว',
  TradeMethod: 'รูปแบบการค้า',
  HBLFreightClause: 'เงื่อนไขการจัดส่งสินค้าแบบแยกส่วน',
  HBLFreightClauseTootip: 'เงื่อนไขการจัดส่งสินค้าแบบแยกส่วน',
  MBLTransportationClause: 'เงื่อนไขการจัดส่งสินค้า',
  MBLTransportationClauseTootip: 'เงื่อนไขการจัดส่งสินค้า',
  HBLTransportationClause: 'เงื่อนไขการจัดส่งสินค้าแบบแยกส่วน',
  HBLTransportationClauseTootip: 'เงื่อนไขการจัดส่งสินค้าแบบแยกส่วน',
  ContainerDescription: 'ปริมาณกล่อง ลักษณะ',
  FeeCreationDate: 'วันที่สร้างค่าธรรมเนียม',
  MBLSplitNo: 'ถอดหมายเลขเดี่ยวหลัก',
  HBLSplitNo: 'แยกหมายเลขเดี่ยว',
  HarborDistrict: 'เขตท่าเรือ',
  SOPStatus: 'สถานะ SOP',
  HDS: 'HDS',
  TEU: 'TEU',
  AirlinePerson: 'เส้นทางบิน (รับผิดชอบ)',
  AirlinePerson2: 'หัวหน้าเส้นทางบิน',
  AirlineOffice: 'บริษัท เส้นทาง',
  AirlineDepartment: 'แผนกเส้นทางบิน',
  BusinessCreator: 'ผู้สร้างธุรกิจ',
  Status: 'สถานะ',
  HblNo: 'HBL NO',
  RelevanceSoNo: 'สมาคม SO NO',
  DangerousGoodsClassification: 'การจำแนกประเภทสินค้าอันตราย',
  DangerousGoodsUNNo: 'วัตถุอันตราย UN',
  FinalDestination: 'ปลายทางสุดท้าย',
  HBLShipper: 'ผู้ส่งสินค้า',
  HBLConsignee: 'ผู้รับใบสั่งย่อย',
  Add: 'เพิ่มใหม่',
  mergeHblData: 'รวมข้อมูลการรื้อถอน HB/L',
  Delete: 'ลบ',
  AddHbl: 'เพิ่มตั๋วหลัก',
  SplitHbl: 'แยกตั๋วหลัก',
  ExportToExcel: 'ส่งออก Excel',
  OverseasAgentEDI: 'ตัวแทนในต่างประเทศ EDI',
  EditSopStatus: 'แก้ไขสถานะ',
  BatchPrint: 'พิมพ์จำนวนมาก',
  BatchVessel: 'การถ่ายโอนแบทช์',
  BatchUpdateType: 'แก้ไขแบทช์ประเภทการสะกดทั้งหมด',
  Statistics: 'สถิติ',
  BatchCommit: 'ส่งเป็นกลุ่ม',
  AddCharges: 'เพิ่มค่าธรรมเนียม',
  EditCharges: 'ค่าธรรมเนียมการแก้ไข',
  DeleteCharges: 'ค่าธรรมเนียมการลบ',
  print: 'การพิมพ์',
  PrintFclProfit: 'การพิมพ์กำไร FCL',
  PrintLclProfit: 'การพิมพ์กำไร LCL',
  PreSubmission: 'ส่งล่วงหน้า',
  BatchPreSubmission: 'การส่งล่วงหน้าเป็นกลุ่ม',
  BatchCancellation: 'โมฆะแบทช์',
  Submission: 'ส่ง',
  SubmissionDateTime: 'เวลาส่ง',
  AuditDateTime: 'เวลาตรวจสอบ',
  Consignation: 'การมอบหมาย',
  FreightStation: 'สถานีขนส่งสินค้า',
  SignBill: 'ลายเซ็น',
  ConsignationSI: 'ส่งออกไปนำเข้า',
  CrossTenantSeToSiEtaMustNoNull: 'กรุณากรอกข้อมูลในฟิลด์: วันที่โดยประมาณของการมาถึงของท่าเรือฟิลด์นี้จำเป็นที่ฝ่ายนำเข้า!',
  ReturnAction: 'การดำเนินการส่งคืน',
  PrintReturn: 'การถอนเงิน',
  AssociationBusinessInformation: 'ข้อมูลธุรกิจที่เกี่ยวข้อง',
  AssociationBusinessInformationSI: 'ข้อมูลธุรกิจนำเข้าที่เกี่ยวข้อง',
  ShowAssociationBusinessInformationSI: 'ดูข้อมูลธุรกิจนำเข้าทางทะเลที่เกี่ยวข้อง',
  Basic: 'พื้นฐาน',
  Booking: 'การจองห้องพัก',
  EnterTheCabin: 'เข้าห้องโดยสาร',
  DataTracking: 'การติดตามข้อมูล',
  AirDataTracking: 'ติดตามการจัดส่งสินค้า',
  CustomsDeclaration: 'ประกาศศุลกากร',
  InsureInfo: 'การประกันภัย',
  Mbl: 'MBL',
  Hbl: 'HBL',
  HouseBillOfLading: 'HB/L',
  FormalHbl: 'แบบฟอร์ม',
  Vgm: 'VGM',
  AmsEns: 'AMS/ENS',
  Hds: 'HDS',
  CommodityInspection: 'การตรวจสอบสินค้า',
  Fumigation: 'การรมควัน',
  ForeignTrade: 'การค้าต่างประเทศ',
  ConsignInfo: 'ข้อมูลการมอบอำนาจ',
  RequiredItem: 'รายการที่ต้องบันทึก',
  CustomerProperty: 'คุณสมบัติของลูกค้า',
  ContactPerson: 'ติดต่อ',
  CustomerContactPerson: 'ติดต่อลูกค้า',
  ContactPhone: 'เบอร์ติดต่อลูกค้า',
  ContactMobile: 'ติดต่อลูกค้า โทรศัพท์มือถือ',
  Detail: 'รายละเอียด',
  OperationDate: 'วันที่ดำเนินการ',
  ManageAuditStatus: 'สถานะการตรวจสอบกำไร',
  PlaceOfDelivery2: 'สถานที่รับสินค้า',
  Transit: 'กถ.',
  PleaseSelectShippingCompany: 'กรุณาเลือก บริษัท เรือ',
  AdditionalInformation: 'ข้อมูลเพิ่มเติม',
  WarehouseLoadingStorage: 'บจภน/คส',
  DoorLoadingDelivery: 'DDC/รถกระบะ',
  NotResponsibleForTruckingAndLoading: 'ตนเองดึง self-feed',
  AutoDistribution: 'การจัดส่งอัตโนมัติ',
  ObtainTheWarehouseNo: 'รับหมายเลขโพซิชั่นขาเข้า',
  MblNo3: 'หมายเลขบัตรหลัก',
  MasterBusinessNo: 'หมายเลขธุรกิจตั๋วหลัก',
  PleaseTickCustomsDeclarationOption: 'กรุณาเลือกตัวเลือก 【ประกาศศุลกากร】',
  PleaseTickDoorLoadingDeliveryOption: 'กรุณาเลือกตัวเลือก 【Door Dot Cartoning / รถกระบะ】',
  PleaseSelectWarehouse: 'กรุณาเลือกตัวเลือก 【กล่องภายใน / คลังสินค้า】',
  PleaseCheckWarehouses: 'กรุณาเลือกตัวเลือก 【คลังสินค้า】',
  PlaceOfMblPayment: 'สถานที่ชำระเงินหลัก',
  PlaceOfHblPayment: 'จุดชำระเงิน',
  CargoSize: 'ขนาดของสินค้า',
  SpecialPriceInstructions: 'หมายเหตุพิเศษ',
  DirectBusiness: 'เดี่ยวตรง',
  Transport: 'การขนส่ง',
  InBatches: 'แบทช์',
  SpecialPrice: 'ราคาพิเศษ',
  ContainerInfo: 'ข้อมูลการบรรจุ',
  QuantityConsignActual: 'จำนวนชิ้น (คณะกรรมการ / ความจริง)',
  WeightConsignActual: 'น้ำหนักรวม (คณะกรรมการ / จริง)',
  CubageConsignActual: 'ปริมาณ (คณะกรรมการ / จริง)',
  VolumetricWeightConsignActual: 'วัสดุ (คณะกรรมการ / จริง)',
  ChargeWeightConsignActual: 'น้ำหนักการเรียกเก็บเงิน (ต่อครั้ง / จริง)',
  Package: 'การบรรจุ',
  Pieces: 'จำนวนชิ้นเล็ก ๆ',
  PiecesType: 'แพคเกจชิ้นเล็ก ๆ',
  Copy2: 'สำเนา',
  EnglishDescriptionOfGoods: 'ชื่อภาษาอังกฤษ',
  Marks: 'เครื่องหมายจัดส่ง',
  NCReferenceNo: 'ระบุหมายเลขอ้างอิงสินค้า',
  SendProxyForecasts: 'ไม่ว่าจะเป็นการส่งการคาดการณ์ของตัวแทน',
  SerialNumber: 'หมายเลขผลิตภัณฑ์ S / N',
  Brand: 'ยี่ห้อ ยี่ห้อ',
  ProductiveYear: 'ปีที่ผลิต',
  CustomsValue: 'ประกาศมูลค่าศุลกากร',
  UnitType: 'รุ่นอุปกรณ์',
  DeviceType: 'ประเภทอุปกรณ์ CATEGORY',
  CountryOrigin1: 'ประเทศต้นกำเนิด',
  DeviceStatus: 'สถานะอุปกรณ์ (เก่าและใหม่)',
  HsCode: 'หมายเลข HS',
  bookingNotes: 'หมายเหตุการจองห้องพัก',
  DangerousGoodsRemarks: 'หมายเหตุ สินค้าอันตราย',
  BootHelperPage: 'หน้าช่วยเหลือการบูต',
  ChineseDescriptionOfGoods: 'ชื่อภาษาจีน',
  OperationInfo: 'ข้อมูลการดำเนินงาน',
  SalesCompany: 'บริษัท ขาย',
  OperationCompany: 'บริษัท ปฏิบัติการ',
  OperationRequirements: 'ข้อกำหนดการดำเนินงาน',
  DoubleClickToAddOperationRequirements: 'เพิ่มข้อกำหนดการดำเนินการด้วยการคลิกสองครั้ง',
  OperationTips: 'เคล็ดลับการทำงาน',
  ExtraChargeClause: 'เงื่อนไขค่าธรรมเนียมเพิ่มเติม',
  DoubleClickToAddExtraChargeClause: 'คลิกสองครั้งเพื่อเพิ่มเงื่อนไขค่าธรรมเนียมเพิ่มเติม',
  WarehousingInfo: 'ข้อมูลการเข้าคลัง',
  Remarks: 'หมายเหตุ',
  BasicRemarks: 'หมายเหตุ (พื้นฐาน)',
  manifestInformation: 'ข้อมูลพื้นฐานของรายการสินค้า',
  manifestChannel: 'ช่องรายการ Manifold',
  CustomerDeliveryInfo: 'ข้อมูลการจัดส่งลูกค้า',
  CodeSearching: 'การดึงรหัส',
  CopyToSeller: 'คัดลอกไปยังผู้ขาย',
  CopyToBuyer: 'คัดลอกไปยังผู้ซื้อ',
  ExpandSellerBuyer: 'ขยาย ผู้ขาย / ผู้ซื้อ',
  NoHouseNumber: 'ไม่มีเลขที่',
  NotifyParty: 'แจ้งโดย',
  NotifyPartyCode: 'แจ้งรหัส',
  MblShipperLine1: 'จัดส่งโดย MBL',
  MblConsigneeLine1: 'ผู้รับ MBL',
  MblNotifyLine1: 'แจ้งโดย MBL',
  DocDispatchingPlace: 'สถานที่จัดส่ง B / L',
  SecondNotifyParty: 'ประกาศฉบับที่ 2',
  PleaseSelect: 'กรุณาเลือก',
  Add2: 'เพิ่มใหม่',
  WhetherDeclarations: 'ไม่ว่าจะเป็นการประกาศศุลกากร',
  InBatchesOrNot: 'ไม่ว่าจะเป็นแบทช์',
  BookingInfo: 'ข้อมูลการจอง',
  MultiJourneyAirline: 'สายการบินหลายสายการบิน',
  NumberPasses: 'จำนวนขั้นตอน',
  MergingTickets: 'รวมตั๋วขนาดเล็ก',
  TicketsInfo: 'ข้อมูลตั๋วขนาดเล็ก',
  TotalTickets: 'คะแนนโหวตทั้งหมด',
  NewTickets: 'เพิ่มตั๋วขนาดเล็ก',
  EditTickets: 'แก้ไขตั๋วขนาดเล็ก',
  AddTickets: 'เข้าร่วม Small Ticket',
  RemoveTickets: 'การถอดบัตรโดยสารขนาดเล็ก',
  DeleteTickets: 'ลบตั๋วขนาดเล็ก',
  Etd: 'ETD',
  SoNo: '[แปลล้มเหลว: หมายเลขปิด]',
  FunctionalOperation: 'ฟังก์ชันการทำงาน',
  MblNo2: 'MB/L NO',
  BookingShipCallSign: 'หมายเลขโทรเรือ',
  USAirlineInfo: 'ข้อมูลเมย์ไลน์',
  PortInfo: 'ข้อมูล Minato Area',
  PolPortInfo: 'ข้อมูลท่าเรือต้นทาง',
  PolAirPortInfo: 'ท่าอากาศยานต้นทาง ข้อมูลสนามบิน',
  PodPortInfo: 'ข้อมูลท่าเรือปลายทาง',
  PodAirPortInfo: 'ข้อมูลสนามบินปลายทาง',
  LocalTime: '(ข้อมูลกลับมาตามเวลาท้องถิ่น)',
  TopLocalTime: 'เคล็ดลับที่อบอุ่น: เวลาแสดงเวลาท้องถิ่น',
  CYOpeningDate: 'วันที่เปิดท่าเรือ',
  PolPortInfoPrompt: 'ช่องสีส้มสามารถรองรับการเขียนข้อมูลย้อนกลับหลังจากเปิดบริการข้อมูล',
  CYOpeningTime: 'เวลาเปิดท่าเรือ',
  CYCutOffDate: 'วันที่สิ้นสุด',
  PortAreaCYCutOffTime: 'เวลาตัดท่าเรือในเขตท่าเรือ',
  CarrierCyCutOffTime: 'บริษัท เรือตัดท่าเรือเวลา',
  PlannedDateOfBerthing: 'กำหนดวันเทียบท่า',
  PlannedDateOfLeavingBerth: 'กำหนดวันออกเดินทาง',
  ActualDateOfBerthing: 'วันที่จอดเรือจริง',
  ActualDateOfLeavingBerth: 'วันที่ออกเดินทางจริง',
  PlannedDockingBerths: 'ท่าเทียบเรือที่วางแผนไว้',
  TheActualDockingBerths: 'ท่าเทียบเรือที่จอดเทียบท่าจริง',
  ActualTimeOfArrivalThePort: 'วันที่เข้าจริง',
  EquipmentEstimatedReturnTime: 'คาดว่าในช่วงคืนคณะรัฐมนตรี',
  EquipmentEstimatedReturnTimeTootip: 'คาดว่าในช่วงคืนคณะรัฐมนตรี',
  To: 'ถึง',
  OtherInfo: 'ข้อมูลอื่นๆ',
  CyCode: 'รหัสลาน',
  PortCodeOfDischarge: 'รหัสพอร์ตการปลดปล่อย',
  EquipmentReceiptAddress: '/ ที่อยู่',
  EquipmentReceiptContactPerson: 'P ติดต่อ',
  EquipmentReceiptContactWay: 'P รายละเอียดการติดต่อ',
  CustomerCyCutOffDate: 'วันที่ปิดรับลูกค้า',
  CustomerShutOutDate: 'วันที่ยกเลิกศุลกากร',
  AmsEnsCyCutOffDate: 'AMS/ENS วันที่ปิดรับสมัคร',
  FreeDetension: 'ระยะเวลาการเช่าตู้ฟรี',
  SecondVesselInfo: 'ข้อมูลการขนส่งทางทะเลครั้งที่สอง',
  AirSecondVesselInfo: 'ข้อมูลการเดินทางที่สองทางอากาศ',
  SecondVoyage: 'เที่ยวที่สอง',
  BargeInfo: 'ข้อมูลเรือสาขา',
  ServiceCode: 'รหัสเส้นทางเรือ',
  ModulesInfo: 'ข้อมูลห้องโดยสาร',
  ShippingAdviceRemark: 'หมายเหตุ SHIPPINGADVICE',
  BookingConfirmationRemarks: 'หมายเหตุ หนังสือแจ้งการจัดเตรียมห้องโดยสาร',
  InviteToChecktheBL: 'จดหมายเชิญคู่',
  ConfirmChecking: 'ยืนยันใบสั่งคู่',
  IdentificationList: 'ระบุคู่',
  ChecktheBLBySmart: 'คู่สมาร์ท',
  ViewCheckingFile: 'ดูไฟล์คู่เดียว',
  CheckingHistory: 'ประวัติคู่โสด',
  UploadGuarantee: 'อัพโหลดหนังสือค้ำประกัน',
  ReceiptHistory: 'ประวัติการตอบกลับ',
  CopyTheDataBy: 'การคัดลอกข้อมูล',
  CopyFromTheLastTime: 'คัดลอกล่าสุด',
  CopyFromOtherBill: 'สำเนาหมายเลขเดียว',
  CopyFromHbl: 'ถอดความ HBL',
  CompleteTheDetails: 'เสร็จสิ้นการเสริม',
  Printed: 'พิมพ์แล้ว',
  Locked: 'ล็อคแล้ว',
  ShipperLocked: 'ล็อคการจัดส่ง',
  BlBeReleased: 'วางแผ่นนอกสถานที่',
  BlEdi: 'ใบตราส่ง EDI',
  ManifestEdi: 'รายการ Manifests EDI',
  ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS: 'หมายเลขซีลกล่อง จำนวนส้นเท้า น้ำหนักรวม ปริมาณ',
  PrintBargeVesselAndVoyage: 'พิมพ์ชื่อเรือเที่ยว',
  ConsigneeShipperAndNotifyInfo: 'รับ-ส่งข้อมูล',
  Reset: 'ล้าง',
  CopyTheConsignee: 'คัดลอกผู้รับ',
  CargoInfo: 'ข้อมูลสินค้า',
  SyncContainerInfoTotal: 'หยิบกล่องข้อมูล ชิ้น Trichomes',
  SyncContainerInfoContent: 'ข้อมูล Cartoning ชิ้น trichomes ครอบคลุม MBL ครอบคลุมหรือไม่?',
  SyncContainerInfoQuantity: 'จำนวนชิ้น (กล่อง): {0} ----- -> จำนวนชิ้น (MBL): {1}',
  SyncContainerInfoWeight: 'น้ำหนักรวม (กล่อง): {0} ----- -> น้ำหนักรวม (MBL): {1}',
  SyncContainerInfoCubage: 'ปริมาณ (บรรจุในกล่อง): {0} ----- -> ปริมาณ (MBL): {1}',
  NumberOfPackagesOnBl: 'จำนวนชิ้น B / L',
  Pieces2: 'จำนวนชิ้นเล็ก',
  PiecesType2: 'แพคเกจชิ้นเล็ก',
  Weight: 'น้ำหนักรวม',
  WeightUnit: 'น้ำหนักรวม หน่วย',
  Cubage: 'ปริมาณ',
  CubageUnit: 'หน่วยปริมาณ',
  CopyEnglishDescriptionOfGoodsFromReceipt: 'ชื่อภาษาอังกฤษ (ใบเสร็จ)',
  CopyEnglishDescriptionOfGoodsFromHBL: 'ชื่อภาษาอังกฤษ (HBL)',
  CopyMarksFromHbl: 'ใช้เครื่องหมายการจัดส่ง HBL',
  CapitalizedNumbersOfPackages: 'จำนวนชิ้น ตัวพิมพ์ใหญ่',
  TransportInfo: 'ข้อมูลการขนส่ง',
  VesselAndVoyage: 'ชื่อเรือ เที่ยวบิน',
  PlaceOfReceipt: 'สถานที่จัดส่ง',
  PlaceOfReceiptOnBl: 'สถานที่จัดส่ง B / L',
  PlaceOfReceiptCodeOnBl: 'สถานที่จัดส่ง (รหัส)',
  PlaceHolderPOR: 'โปรดเลือกรหัสสถานที่จัดส่ง BL',
  PlaceOfReceiptOnBlTootip: 'สถานที่จัดส่ง B / L',
  PortOfLoadingOnBl: 'ท่าเรือเริ่มต้นของ B / L',
  PortOfDischargeOnBl: 'ท่าเรือขนส่งสินค้า B / L',
  PlaceOfDeliveryOnBl: 'สถานที่จัดส่ง B / L',
  BlFinalDestination: 'ปลายทางสุดท้ายของ B / L',
  MethodOfMblPayment: 'วิธีการชำระเงิน MBL',
  PlaceOfMblPayment2: 'สถานที่ชำระเงิน MBL',
  TransportationClause: 'เงื่อนไขการจัดส่ง',
  NoOfOriginalBls: 'จำนวนสำเนา B / L',
  NoOfCopyBls: 'จำนวนสำเนา',
  PlaceOfIssue: 'สถานที่ออก',
  DateOfIssue: 'วันที่ออก',
  HBLDateOfIssue: 'วันที่ออก HBL',
  BlRemarks: 'หมายเหตุ B / L',
  BlType: 'วิธี B / L',
  HBLBlType: 'วิธี B / L ของ HBL',
  MBLBlType: 'วิธี B / L MBL',
  MBLBlProperty: 'ประเภทของ B / L MBL',
  HBLBlProperty: 'ประเภท B / L ของ HBL',
  LastEntryPort: 'พอร์ตขาเข้าล่าสุด',
  BlProperty: 'ประเภทของ B / L',
  CheckingStatus: 'ยืนยันสถานะ B / L',
  BillLadingIssued: 'สถานะการออก B / L',
  HBLCheckingStatus: 'สถานะ B / L ของ HBL',
  MBLCheckingStatus: 'สถานะ B / L MBL',
  ReleasingStatus: 'ใส่สถานะการตรวจสอบแผ่น',
  HBLReleasingStatus: 'สถานะการวาง HBL',
  MBLReleasingStatus: 'สถานะการวาง MBL',
  ReleaseEligibleStatus: 'Release Eligibility',
  ReleaseEligibleYes: 'Releasable',
  ReleaseEligibleNo: 'Not Releasable',
  FormalHblReleaseType: 'แบบฟอร์ม แยกทางเดียว',
  FormalHblStatus: 'แบบฟอร์ม แยกสถานะ',
  FormalHblIssuedStatus: 'แบบฟอร์ม สถานะการออกใบสั่งย่อย',
  FormalHblType: 'แบบฟอร์ม แยกประเภทเดียว',
  FormalHblCombineNo: 'แบบฟอร์ม แยกแผ่นและหมายเลข',
  fields: 'ฟิลด์กับ',
  tab: 'ลายเซ็นหน้า',
  hint: 'ฟิลด์ไม่ตรงกัน ยืนยันจะส่งหรือไม่',
  Audit: 'รีวิว',
  Payable: 'ชำระเงินได้',
  CargoDetention: 'สินค้าหัวเข็มขัด',
  PaymentDate: 'วันที่โอนเงิน',
  PaymentDate2: 'วันที่โอนเงิน',
  DateOfCargoDetention: 'วันที่หัก',
  BlReleasingNo: 'ใส่หมายเลขเดียว',
  BlReleasingApplicationTime: 'ใส่เวลาการสมัคร',
  BlReleasingApplicationPerson: 'ใส่ผู้สมัคร',
  ParamRemark: 'หมายเหตุการลงลายมือชื่อ',
  ShippingCompanySCAC: 'บริษัท เรือ SCAC',
  OverseasAgentSCAC: 'ตัวแทนในต่างประเทศ SCAC',
  ShipperType: 'ประเภทการจัดส่ง',
  ManifestDescriptionOfGoods: 'ชื่อรายการ',
  ReasonOfCargoDetention: 'เหตุผลของการหักเงิน',
  HblNo2: 'หมายเลข HBL',
  MblNo: 'หมายเลข MBL',
  Quantity: 'จำนวนชิ้น',
  WeightKg: 'น้ำหนักรวม (กก.)',
  CubageCbm: 'ปริมาณ (CBM)',
  ContainerAmount: 'ปริมาณกล่อง',
  CNTRNOSSEALNOS: 'ข้อมูลซีลกล่อง',
  BillOfLadingPackingInfo: 'ข้อมูลการบรรจุ B / L',
  CopyMblConsignee: 'รับรายการหลักผู้รับ',
  CopyNominatedAgentInfo: 'ข้อมูลตัวแทนการสั่งซื้อ',
  PrintTheOriginalBl: 'การพิมพ์ต้นฉบับ',
  TelexRelease: 'การพิมพ์',
  Unlock: 'ปลดล็อค',
  AntiTerroristFormattedAddress: 'รูปแบบต่อต้านก่อการร้าย',
  BlBeReleasedElsewhereOrNot: 'ไม่ว่าจะเป็นการวางแผ่นนอกสถานที่',
  ClauseOfNoWoodPackingMaterial: 'เงื่อนไขการบรรจุที่ไม่ใช่ไม้',
  AFRTheLastBill: 'AFR โหวตสุดท้าย',
  CopyEnglishDescriptionOfGoodsFromMbl: 'ใช้ชื่อภาษาอังกฤษของ MBL',
  CopyMarksFromMbl: 'รับเครื่องหมายการจัดส่ง MBL',
  BillOfLadingNumber: 'หมายเลขการประกอบ B / L',
  HBLBillOfLadingNumber: 'HBL B / L หมายเลขการประกอบ',
  MethodOfHblPayment: 'วิธีการชำระเงิน HBL',
  PlaceOfHblPayment2: 'HBL สถานที่ชำระเงิน',
  CheckingQuestions: 'สำหรับคำถามเดียว',
  BlType2: 'ประเภท B / L',
  HBLBlType2: 'HBL ประเภท B / L',
  DataSent: 'ข้อมูลที่ส่งแล้ว',
  Completed: 'เสร็จสิ้น',
  paste: 'วางเอกสารแนบ',
  V3remind: 'กรุณาคัดลอกไฟล์แนบก่อน',
  DateOfcompletion: 'วันที่เสร็จสิ้น',
  GenerationOfABillOfLading: 'ใบตราส่งสินค้า',
  GenerationOfABillOfLading2: 'ใบตราส่งสินค้า',
  ShipperContactTelNo: 'เบอร์ติดต่อผู้ส่งสินค้า',
  ConsigneeContactTelNo: 'หมายเลขโทรศัพท์ติดต่อผู้รับ',
  NotifyPartyTelNo: 'หมายเลขโทรศัพท์ติดต่อผู้แจ้ง',
  ChargeClause: 'เงื่อนไขการชำระเงิน',
  Amount: 'จำนวนเงิน',
  CopyCargoDescriptionAndMarks: 'เครื่องหมายการจัดส่งสินค้า การคัดลอกชื่อสินค้า',
  CopyMbl: 'ถอดความ MBL',
  RelatedMbl: 'รายการหลักพันธมิตร',
  Add3: 'เข้าร่วม',
  Copy: 'สำเนา',
  Send: 'ส่ง',
  CheckStatus: 'สถานะการสอบถาม',
  ImportButNotSend: 'นำเข้าไม่ส่ง',
  CapitalizedNumbersOfEquipmentWeight: 'น้ำหนักกล่อง ตัวพิมพ์ใหญ่',
  AmsSplitNo: 'AMS ย่อยเดียว',
  AmsNo: 'หมายเลข AMS',
  EManifestSplitNo: 'eManifest หมายเลขย่อย',
  EManifestNo: 'หมายเลข eManifest',
  BlSplitList: 'รายการแยกเดี่ยว',
  sendStatusAMS: 'สถานะการส่ง (AMS)',
  sendStatusISF: 'สถานะการส่ง (ISF)',
  sendStatus: 'สถานะการส่ง',
  SealNoChangeAdfterInspection: 'ตรวจสอบการเปลี่ยนแปลงซีล',
  AutoAllocation: 'กล่องอัตโนมัติ',
  AutoAllocationContract: 'กล่องอัตโนมัติ (มอบหมาย)',
  CleanOutTheLoadingRecord: 'ล้างบันทึกการบรรจุ',
  DeleteTheLoadingRecord: 'ลบบันทึกกล่อง',
  CargoQuantityDescription: 'ปริมาณสินค้า Description',
  TotalNumberOfPackages: 'จำนวนชิ้นทั้งหมด',
  ContainerSize: 'ประเภทกล่อง',
  ContainerType: 'ชนิดของกล่อง',
  ContainerWeight: 'น้ำหนักกล่อง',
  SealNo: 'หมายเลขซีล',
  TravelTrajectory: 'เส้นทางการเดินทาง',
  DrivingState: 'สถานะการขับขี่ปัจจุบัน',
  CurrentVehicleLocation: 'ตำแหน่งรถปัจจุบัน',
  GetContainerNo: 'รับหมายเลขกล่อง',
  TotalWeight: 'น้ำหนักรวม',
  TotalCubage: 'ปริมาณรวม',
  Soc: 'กล่องเจ้าของสินค้า',
  Inspection: 'การตรวจสอบ',
  ApproachDate: 'เวลาเข้า',
  PlayDate: 'เวลาปรากฏตัว',
  LoadingPort: 'กำลังโหลดพอร์ต',
  TheArrivalOfPacketsSent: 'การจัดส่งเอกสารมาถึง เวลาส่ง',
  CustomsClearanceInfo: 'ข้อมูลการเปิดตัวศุลกากร',
  DataTrackingBlHasNotContainer: 'หมายเลข B / L {0} โปรดไปที่หน้าข้อมูลการบรรจุหีบห่อเพื่อลงนามฟังก์ชั่นการเปรียบเทียบข้อมูลจะสัมพันธ์กัน หน้านี้จะแสดงรายละเอียดของกล่อง',
  WharfReleaseInfo: 'ข้อมูลการเปิดตัวท่าเทียบเรือ',
  ContainerAscription: 'ประเภทของกล่อง',
  PlateNumber: 'หมายเลขหัวรถ',
  plateApproachDate: 'เวลารับบัตร',
  platePlayDate: 'เวลาเก็บบัตร',
  PackageType: 'ประเภทบรรจุภัณฑ์',
  NumberOfVotes: 'จำนวนโหวต',
  EmptyContainerWeight: 'น้ำหนักกล่องที่ว่างเปล่า',
  VgmWeight: 'น้ำหนัก VGM',
  VgmWeighingMethod: 'วิธีการชั่งน้ำหนัก VGM',
  VgmWeighingTime: 'เวลาในการชั่งน้ำหนัก VGM',
  WeightTime: 'เวลาชั่งน้ำหนัก',
  VgmWeighingPlace: 'สถานที่ชั่งน้ำหนัก VGM',
  WeighingPartyAddress: 'ที่อยู่ฝ่ายชั่งน้ำหนัก',
  StationStatus: 'สถานะสถานี',
  CargosGrossWeight: 'น้ำหนักสุทธิของสินค้า',
  VgmContactPerson: 'ติดต่อ VGM',
  VgmContactEmailAddress: 'กล่องจดหมายติดต่อ VGM',
  VgmContactWay: 'ติดต่อเรา VGM',
  VgmResponsiblePerson: 'VGM หัวหน้า',
  ContactEmailAddress: 'ติดต่อกล่องจดหมาย',
  ContactWay: 'รายละเอียดการติดต่อ',
  ContactAddress: 'ที่อยู่ติดต่อ',
  ResponsiblePerson: 'ผู้รับผิดชอบ',
  Name: 'ชื่อ',
  Warehouse2: 'คลังสินค้าติดตั้งภายใน',
  WarehouseLoading: 'โหลดภายในคลังสินค้า',
  LoadingCharge: 'ค่าธรรมเนียมการบรรจุ',
  LoadingCharge2: 'ค่าธรรมเนียมการบรรจุ',
  BoxOwner: 'เจ้าของคดี',
  RmbNumberOfDamagedAndDamp: 'จำนวนชิ้นที่เสียหายและได้รับความชื้น',
  RmbNumberOfDamagedAndDamp2: 'จำนวนชิ้นที่เสียหายและได้รับความชื้น',
  Tel: 'โทรศัพท์',
  CargosExpectedArrivalDate: 'วันที่คาดว่าจะมาถึง',
  WarehouseAddress: 'ที่อยู่คลังสินค้า',
  LoadingRemarks: 'หมายเหตุอุปกรณ์ภายใน',
  DoorToDoorLoading: 'ประตูสู่ประตูบรรจุภัณฑ์',
  MultiDoors: 'หลายจุด',
  HaulageNo: 'หมายเลขส่งรถ',
  HaulageCharge: 'ค่ารถพ่วง',
  AuditMoney: 'ยืนยันจำนวนเงิน',
  AuditState: 'สถานะค่าใช้จ่าย',
  HaulageContactPerson: 'ติดต่อ Fleet',
  Door: 'จุดประตู',
  AddDoor: 'เพิ่มจุดประตู',
  DestinationGatewayCity: 'จุดปลายทาง เมือง',
  DoorContactPerson: 'จุดเชื่อมต่อประตู',
  DoorAddress: 'ที่อยู่ Doorpoint',
  DispatchVehiclesAtDestinationDoorAddress: 'ท่าเรือปลายทาง จุดรับส่งประตู ที่อยู่',
  DoorCity: 'เกตพอยท์ ซิตี้',
  Driver: 'คนขับรถ',
  ComprehensiveLogisticsOrderType: 'ประเภทการสั่งซื้อโลจิสติกส์แบบบูรณาการ',
  ComprehensiveLogisticsTransportationType: 'ประเภทของการขนส่งโลจิสติกส์แบบบูรณาการ',
  TransportType: 'ประเภทการขนส่ง',
  SameTransportationCompany: 'บริษัท ขนส่งเดียวกัน',
  SameDoorPoint: 'ประตูจุดเดียวกัน',
  ReturnYard: 'ลานเก็บของกล่อง',
  DriverIDCard: 'บัตรประจำตัวผู้ขับขี่',
  DestinationGatePoint: 'จุดปลายทาง',
  DepartureGatePoint: 'จุดประตูฝั่งขาออก',
  AddressOfDestinationGatePoint: 'ที่อยู่ประตูปลายทาง',
  DestinationGateCity: 'จุดหมายปลายทาง Door Point เมือง',
  CarryingCaseYard: 'ลานเก็บสัมภาระ',
  EstimatedPackingDate: 'วันที่บรรจุโดยประมาณ (ถึงโรงงาน)',
  ActualPackingDate: 'วันที่บรรจุจริง (ถึงโรงงาน)',
  EstPackingDate: 'วันที่บรรจุโดยประมาณ (ถึงคลังสินค้า)',
  ActPackingDate: 'วันที่บรรจุจริง (ไปยังไซโล)',
  ExpectedArrivalDate2: 'วันที่คาดว่าจะมาถึง',
  ActualArrivalDate: 'วันที่มาถึงจริง',
  GatheringTrailer: 'รถบรรทุกพ่วง',
  WholeVehicleLessThanCarload: 'รถบรรทุกทั้งศูนย์แขน',
  TruckCustomerService: 'ฝ่ายบริการลูกค้ารถบรรทุก',
  DtdDTWWTD: 'ประตูสู่ประตู / ประตูสู่ไซโล / ไซโลไปยังประตู',
  DoorToDoor: 'ประตูสู่ประตู',
  DoorToWarehouse: 'ประตูสู่ไซโล',
  WarehouseToDoor: 'ไซโลไปยังประตู',
  AdditionalNotes: 'คำแนะนำเพิ่มเติม',
  AssociatedPackingInfo: 'ข้อมูลบรรจุภัณฑ์ที่เกี่ยวข้อง',
  RemoveAssociations: 'ลบความสัมพันธ์',
  DispatchTuckOrder: 'แผ่นพาย',
  ModifyTuckOrder: 'เปลี่ยนแผ่น',
  TuckStatusDescription: 'รายละเอียดการส่งรถ',
  ManualDistribution: 'การจัดส่งสินค้าด้วยตนเอง',
  Unlock2: 'การยกเลิก',
  Size: 'ขนาด',
  WhetherOrNotBroken: 'ไม่ว่าจะเป็นการแตกหัก',
  BrokenDesc: 'การสูญเสียสินค้า Description',
  BangPic: 'รูปภาพการเข้าคลัง',
  WareHouseName: 'ชื่อคลังสินค้า',
  WarehouseSupplier: 'ผู้จัดจำหน่ายคลังสินค้า',
  WareHouseMarks: 'เครื่องหมายการจัดส่งสินค้าคลังสินค้า',
  CustomsDeclarationInfo: 'ข้อมูลการประกาศศุลกากร',
  OnwardInfo: 'ข้อมูลการต่ออายุ',
  TheActualFlight: 'เที่ยวบินจริง',
  NewCustomsDeclaration: 'เพิ่มประกาศศุลกากร',
  EditCustomsDeclaration: 'แก้ไขประกาศศุลกากร',
  DeleteCustomsDeclaration: 'ลบประกาศศุลกากร',
  BlNo: 'หมายเลขใบตราส่งสินค้า',
  OperatingCompany: 'หน่วยธุรกิจ',
  CustomsCode: 'รหัสสิบหลักสำหรับการประกาศศุลกากร',
  DateOfCustomsDeclaration: 'วันที่ประกาศศุลกากร',
  StatusOfCustomsDeclaration: 'สถานะการประกาศศุลกากร',
  CommodityInspectionOrNot: 'ไม่ว่าจะเป็นการตรวจสอบสินค้า',
  CustomsInspectionOrNot: 'ไม่ว่าจะเป็นการตรวจสอบ',
  UploadFile: 'อัปโหลดไฟล์',
  CustomsFile: 'เอกสารประกาศศุลกากร',
  Chargeback: 'การคืนเงิน',
  TemplateDownload: 'ดาวน์โหลดแม่แบบ',
  ExcelImport: 'การนำเข้า Excel',
  ExcelExport: 'การส่งออก Excel',
  OrderNo: 'ORDER NO _ หมายเลขการสั่งซื้อ',
  CaseNo: 'CASE NO _ หมายเลขลำดับ',
  Item: 'ITEM _ รหัสสินค้า',
  Sub: 'SUB _ หมายเลขล็อต',
  Size2: 'สเปค',
  CommodityClassification: 'หมวดหมู่ ชื่อเกรด',
  Qty: 'QTY _ จำนวนชิ้น',
  BillingQTY: 'จำนวนการเรียกเก็บเงิน',
  UnitOfMeasurement: 'หน่วยวัด',
  NetWeight: 'น้ำหนักสุทธิ',
  CustomsDutyRate: 'อัตราภาษีศุลกากร',
  CustomsDuties: 'ภาษีศุลกากร',
  IncrementValueDutyRate: 'อัตราภาษีมูลค่าเพิ่ม',
  IncrementValueDuty: 'ภาษีมูลค่าเพิ่ม',
  ConsumptionDutyRate: 'อัตราภาษีสรรพสามิต',
  ConsumptionDuty: 'ภาษีสรรพสามิต',
  ConsolidatedTax: 'ภาษีรวม',
  Currency: 'สกุลเงิน',
  ExchangeRate: 'อัตราแลกเปลี่ยน',
  CargoPrice: 'ราคาสินค้า',
  Tax: 'ภาษีอากร',
  TaxRate: 'อัตราภาษี',
  BigBagNo: 'กระเป๋าใบใหญ่',
  BigBagWeight: 'น้ำหนักกระเป๋าใหญ่',
  BigBagWeightUnit: 'หน่วยน้ำหนัก',
  BigBagLength: 'ห่อใหญ่ยาว',
  BigBagWidth: 'แพคเกจขนาดใหญ่กว้าง',
  BigBagHeight: 'แพคเกจขนาดใหญ่สูง',
  BigBagDimensionUnit: 'หน่วยความยาวถุงใหญ่',
  BigBagGoodsType: 'ประเภทสินค้าบิ๊กแพ็ค',
  FulfillmentLabel: 'ประเภทการใช้สิทธิ',
  LandingPort: 'ท่าเรือเชื่อมโยงไปถึง',
  PackageQuantity: 'ปริมาณบรรจุภัณฑ์ขนาดเล็ก',
  ExpectPickupStartTime: 'คาดว่าจะเริ่มเก็บเกี่ยวได้ภายในเวลา',
  ExpectPickupEndTime: 'คาดว่าจะใช้เวลาสิ้นสุดการเก็บเกี่ยว',
  PreviousCarrierCode: 'รหัสผู้ให้บริการก่อนหน้า',
  PreviousResourceCode: 'รหัสทรัพยากรก่อนหน้า',
  NextCarrierCode: 'รหัสผู้ให้บริการถัดไป',
  NextResourceCode: 'รหัสทรัพยากรถัดไป',
  SortCode: 'รหัสคัดแยกถุงใหญ่',
  BuyerRegion: 'ประเทศปลายทาง',
  AddressL0: 'ที่อยู่ระดับ L0',
  AddressL1: 'ที่อยู่ระดับ L1',
  AddressL2: 'ที่อยู่ระดับ L2',
  AddressL3: 'ที่อยู่ระดับ L3',
  AddressL4: 'ที่อยู่ระดับ L4',
  DetailsAddressMore: 'รายละเอียดที่อยู่ 2',
  PickupFirstName: 'นามสกุลของผู้รับ',
  PickupLastName: 'ชื่อผู้รับ',
  PickupCompany: 'ชื่อบริษัท',
  PickupZip: 'รหัสไปรษณีย์',
  PickupPhone: 'หมายเลขโทรศัพท์มือถือ',
  TtOrderCode: 'หมายเลขบอร์ด tt',
  MwbNo: 'หมายเลขบัตรกำนัลของผู้ให้บริการ',
  Export9610File: 'ส่งออกไฟล์ 9610',
  BatchChangeCompany: 'บริษัท เปลี่ยนชุด',
  OnlyCheckOneData: 'อนุญาตให้ติ๊กข้อมูลได้เพียงรายการเดียว',
  NoteUseNumLast: 'หมายเหตุ: หมายเลขเดียวจะไม่ถูกสร้างขึ้นใหม่หลังจากเปลี่ยน บริษัท และยังคงใช้หมายเลขเดียวที่มีอยู่',
  OrderNo2: 'หมายเลขการสั่งซื้อ',
  SupportSales: 'การสนับสนุนการขาย',
  OrderAmount: 'จำนวนการสั่งซื้อ',
  ServiceFeeDiscountRate: 'อัตราค่าบริการส่วนลด',
  OperatingInstructions: 'คำแนะนำการใช้งาน',
  OrderCurrency: 'สกุลเงินการสั่งซื้อ',
  TheAmountOfWriteOffs: 'ยอดการสั่งซื้อ',
  TheFirstBusinessOrNot: 'ไม่ว่าจะเป็นการสั่งซื้อครั้งแรก',
  Salesman: 'พนักงานธุรกิจ',
  OrderExchangeRate: 'อัตราแลกเปลี่ยนการสั่งซื้อ',
  Difference: 'ความแตกต่าง',
  FrameContractNumber: 'หมายเลขสัญญาเฟรม',
  PaymentNo: 'หมายเลขการโอนเงิน',
  PaymentAmount: 'จำนวนเงินโอน',
  ThePrePayment: 'การชำระเงินล่วงหน้า',
  PaymentExchangeRate: 'อัตราแลกเปลี่ยนเงินตราต่างประเทศ',
  ActualPaymentAmount: 'จำนวนเงินที่จ่ายตามจริง',
  ServiceCharge: 'ค่าธรรมเนียมการจัดการ',
  PostalCharges: 'ค่าไปรษณีย์และค่าไฟฟ้า',
  AcceptanceFee: 'ค่าธรรมเนียมการดำเนินการ',
  RetreatMoreFillLessAmount: 'เงินคืนมาก เงินชดเชยน้อย',
  Total: 'สรุป',
  UnpaidAmount: 'จำนวนเงินที่ยังไม่ได้ชำระ',
  No: 'ไม่',
  Yes: 'ใช่',
  New: 'สร้างใหม่',
  Clone: 'คัดลอก',
  Send2: 'ส่งออก',
  Back: 'การรับคืน',
  ExpressInfo: 'จัดส่งด่วน',
  PrintReceipt: 'พิมพ์ใบตอบรับ',
  FileType: 'ประเภทไฟล์',
  FileType2: 'ประเภท',
  FileCategory: 'ประเภทไฟล์',
  CustomsNo: 'หมายเลขศุลกากร',
  SendingDate: 'วันที่จัดส่ง',
  SendingExpressNumber: 'ส่งหมายเลขด่วน',
  ReceivingDate: 'วันที่รับคืน',
  Receiver: 'รับคืน',
  ReturnDate: 'วันที่คืนเงิน',
  ReturnExpressNumber: 'การคืนหมายเลขด่วน',
  DateOfDeclaration: 'วันที่ประกาศ',
  FileStatus: 'สถานะไฟล์',
  TenBitCode: 'รหัสสิบหลัก',
  ReceiverCompanyName: 'หน่วยรับ',
  Receiver2: 'ผู้รับ',
  CustomsDeclarationPages: 'จำนวนหน้าประกาศศุลกากร',
  CustomsTransitOrNot: 'ไม่ว่าจะเป็นการผ่านด่านศุลกากร',
  TakeByCustomsBroker: 'นายหน้าศุลกากรรับเอง',
  ExpressAddress: 'ที่อยู่จัดส่ง',
  PrintChargebackList: 'พิมพ์ (รายการคืนเงิน)',
  ViewFile: 'ดูแฟ้ม',
  ChargebackFile: 'เอกสารการคืนเงิน',
  CheckPreRecordedCustomsDeclaration: 'สอบถามล่วงหน้าเกี่ยวกับการประกาศศุลกากร',
  CheckStatusOfCustomsDeclaration: 'สอบถามสถานะพิธีการศุลกากร',
  All: 'ทั้งหมด',
  GeneralTrade: 'การค้าทั่วไป',
  Processing: 'การประมวลผลวัสดุที่เข้ามา',
  FeedingCounterparts: 'ป้อนเข้าปาก',
  SamplesOfAdvertisingProducts: 'สินค้าโฆษณาตัวอย่าง',
  OtherImportsFree: 'การนำเข้าอื่น ๆ ฟรี',
  CustomerName: 'ชื่อลูกค้า',
  CustomerAddress: 'ที่อยู่ของลูกค้า',
  Confirm: 'ยืนยัน',
  DangerousGoods: 'สินค้าอันตราย',
  DangerousGoodsRequired: '"กล่องจดหมายติดต่อวัตถุอันตราย", "แฟกซ์ติดต่อวัตถุอันตราย" จำเป็น',
  DangerousGoodsLabel: 'ฉลากสินค้าอันตราย',
  MedicalEmergencyGuideNo: 'หมายเลขคู่มือฉุกเฉินทางการแพทย์',
  SetTemperature: 'ตั้งค่าอุณหภูมิ',
  MinimumTemperature: 'อุณหภูมิต่ำสุด',
  MaximumTemperature: 'อุณหภูมิสูงสุด',
  PortForReturningContainer: 'เขตท่าเรือส่งกล่อง',
  NonStandardContainer: 'เพิ่มกล่องที่ไม่ได้มาตรฐาน',
  OverFront: 'อดีตอัลตร้า',
  OverBack: 'โพสต์อัลตร้า',
  OverHeight: 'สูงพิเศษ',
  OverLeft: 'ซ้ายอัลตร้า',
  OverRight: 'ขวาอัลตร้า',
  EditionStatus: 'แก้ไขสถานะ',
  UpdateExternalState: 'อัปเดตสถานะภายนอก',
  Refresh: 'รีเฟรช',
  Save: 'บันทึก',
  ShowAllPoints: 'แสดงโหนดทั้งหมด',
  SopStateNote: '* หมายเหตุ: โหนดที่ปิดจะไม่ส่งการเตือนล่วงหน้าโหนดและการแจ้งเตือนการเปลี่ยนแปลงสถานะ SOP อีกต่อไป',
  PaymentInformationImport: 'การนำเข้าข้อมูลการชำระเงิน',
  Invalid: 'โมฆะ',
  QueryContainerInfo: 'สอบถามข้อมูลการบรรจุหีบห่อ',
  Hbl2: 'หมายเลขย่อย',
  Mbl2: 'หมายเลขเดี่ยวหลัก',
  PortOfLoadingAgent: 'ตัวแทนพอร์ตการจัดส่งสินค้า',
  TheFirstVessel: 'ชื่อเรือ 1 เที่ยว',
  CustomerReferenceNumber: 'หมายเลขอ้างอิงของลูกค้า',
  BusinessType: 'ประเภทธุรกิจ',
  BillExchange: 'ไม่ว่าจะเป็นการเปลี่ยนใบสั่ง',
  Storage: 'คลังสินค้า',
  Devanning: 'แกะกล่อง',
  DeliveryToDoor: 'Door Point การจัดส่งสินค้า',
  MblNo4: 'หมายเลขบัตรหลัก',
  InternationalTransport: 'การขนส่งระหว่างประเทศ',
  ActualNotifyParty: 'ผู้แจ้งจริง',
  ActualNotifyPartyHeader: 'การแจ้งเตือนที่เกิดขึ้นจริง',
  ConsignationCompanyHeader: 'หัวหน้าหน่วย',
  Fax: 'แฟกซ์',
  BillExchangeAgent: 'ตัวแทนแลกเปลี่ยนเงิน',
  CustomsHblNo: 'หมายเลขย่อยศุลกากร',
  SecondCheck: 'การเดินทางที่สอง',
  SecondVessel: 'ชื่อเรือที่สอง',
  AutoRetrieve: 'รับอัตโนมัติ',
  AccordingToVesselVoyageGets: 'ได้รับตามเที่ยวบินชื่อเรือ',
  ActualDateOfArrival: 'วันที่มาถึงจริง',
  ActualDateOfArrival2: 'วันที่มาถึงจริง (ATA)',
  AtaImport: 'ATA (นำเข้า)',
  DateOfDelivery: 'วันที่รับสินค้า',
  DateOfArrivalTheWarehouse: 'วันที่ห้องสมุด',
  Code2: 'รหัส',
  Region: 'รหัสพื้นที่',
  CountryOrigin: 'สถานที่กำเนิด',
  PartyIDType: 'ประเภทของเอกสาร',
  PartyID: 'หมายเลขเอกสาร',
  BillsOfLadingDoubleClickEject: 'B/L เพิ่ม - ดับเบิลคลิกที่ป๊อปอัพ',
  TradeTerms: 'เงื่อนไขการซื้อขาย',
  PreCollection: 'การเก็บเงินล่วงหน้า',
  HblCargoReleaseWay: 'วิธีการจัดจำหน่ายแบบแยกส่วน',
  MblCargoReleaseWay: 'วิธีการจัดส่งเดี่ยวหลัก',
  VesselCode: 'รหัสเรือ',
  BillExchangeDate: 'วันที่แลกเงิน',
  Department: 'แผนก',
  PolOperation: 'การดำเนินงานพอร์ตการจัดส่งสินค้า',
  PodOperation: 'การดำเนินการท่าเรือปลายทาง',
  VesselOfChineseName: 'ชื่อเรือจีน',
  TotalWeight2: 'น้ำหนักรวม',
  TotalWeightUnit: 'หน่วยน้ำหนักรวม',
  NumberOfDamagedAndDamp: 'จำนวนชิ้นที่เสียหายและได้รับความชื้น',
  EstimatedDateOfArrivalTheWarehouse: 'วันที่คาดว่าจะเข้าคลังสินค้า',
  EstimatedDateOfPickingUpTheContainer: 'วันที่รับฝากโดยประมาณ',
  DateOfReturningTheContainer: 'วันที่คืนกล่อง',
  SanitaryAndPhytosanitaryStandard: 'การตรวจสอบสุขาภิบาลแบบไดนามิก',
  PriceCalculation: 'การคำนวณราคาขาย',
  Down: 'เลื่อนลง',
  Up: 'เลื่อนขึ้น',
  Total2: 'รวม',
  PrintBooking: 'การพิมพ์ห้องโดยสาร',
  FirstLegNo: 'หมายเลขการเดินทางหัว',
  FirstLegNoTips: 'ตัวบ่งชี้ที่สำคัญสำหรับการจัดการการขนส่งภายในประเทศและการดำเนินงานก่อนการส่งออกในโลจิสติกส์การขนส่งทางอากาศระหว่างประเทศ',
  OperateType: 'โหมดการทำงาน',
  CustomsDeclarationWay: 'วิธีการประกาศศุลกากร',
  CustomsDeclarationType: 'ประเภทการประกาศศุลกากร',
  AirlineCompany: 'สายการบิน',
  Flight: 'เที่ยวบิน',
  FlightNo: 'หมายเลขเที่ยวบิน',
  PortOfHub: 'ท่าเรือ HUB',
  CommissionedNumberOfPackages: 'จำนวนชิ้นที่ได้รับมอบหมาย',
  CommissionedGrossWeight: 'น้ำหนักรวมที่ได้รับมอบหมาย',
  CommissionedVolume: 'ปริมาณค่าคอมมิชชั่น',
  ActualChargedWeight: 'น้ำหนักการเรียกเก็บเงินจริง',
  PrintingPlatePhotos: 'ภาพถ่ายการตีกระดาน',
  ProtocolType: 'ประเภทของโปรโตคอล',
  FieldOperation: 'การดำเนินงานภาคสนาม',
  OverseaOperation: 'การดำเนินงานในต่างประเทศ',
  Auditor: 'รีวิวโดย',
  preverifyDate: 'วันที่ตรวจสอบ',
  OtherWarehouseNotes: 'คำอธิบายอื่น ๆ',
  JobNo: 'หมายเลขงาน',
  NominatedAgent2: 'ตัวแทนที่ได้รับมอบหมาย',
  AirFreighMode: 'โหมดการขนส่งทางอากาศ',
  WarehouseNo2: 'หมายเลขห้องโดยสารขาเข้า',
  PleaseInputJobNo: 'กรุณากรอกหมายเลขงาน',
  PrintProfitAnalysis: 'พิมพ์การวิเคราะห์กำไร',
  SendToBranchCompany: 'ส่งสาขา',
  EnterTransitInfo: 'ป้อนข้อมูลการโอน',
  ArrivalForTheSecondJourney: 'การเดินทางมาถึงที่สอง',
  LeaveForTheSecondJourney: 'ออกจากทริปสอง',
  ArrivalForTheThirdJourney: 'การเดินทางมาถึง 3 ครั้ง',
  LeaveForTheThirdJourney: 'ออกจากสามการเดินทาง',
  PreAlertOperation: 'การดำเนินการพยากรณ์',
  Actual: 'ในทางปฏิบัติ',
  Frontcabin: 'ห้องโดยสารด้านหน้า',
  FrontCabinActual: 'คลังหน้า (จริง)',
  Documentation: 'สั่งทำ',
  Select: 'เลือก',
  Join: 'เข้าร่วม',
  Separate: 'การแยก',
  pbProportion: 'ลูกค้า Pb',
  pbProportion2: 'ผู้ให้บ.Pb',
  SpaceRquirement: 'ข้อกำหนดห้องโดยสาร',
  OnBoardRequirements: 'ความต้องการของคณะกรรมการติดตั้ง',
  DocumentationRequirements: 'ข้อกำหนดสำหรับการสั่งซื้อ',
  SellingPrice: 'ราคาขาย',
  BuyingPrice: 'ราคาซื้อ',
  SalesBranchCompany: 'สาขาขาย',
  CopyFromOtherBill2: 'สำเนาหมายเลข',
  CodeSearching2: 'การเลือกรหัส',
  ResetInitialValue: 'รีเซ็ตค่าเริ่มต้น',
  CopyTheMbl: 'คัดลอกแผ่นหลัก',
  InputWarehouseData: 'ป้อนข้อมูล Position เข้า',
  EditWarehouseData: 'แก้ไขข้อมูล Position ขาเข้า',
  DeleteWarehouseData: 'ลบข้อมูล Position ขาเข้า',
  CancelInvalid: 'การยกเลิกการเป็นโมฆะ',
  MblInfo: 'ข้อมูลตั๋วหลัก',
  AirOperation: 'การดำเนินงานทางอากาศ',
  CustomerSpecialRequirements: 'ความต้องการพิเศษของลูกค้า',
  AirportHandlingAgent: 'ตัวแทนภาคพื้นดิน',
  CustomsTenBitCode: 'การเข้ารหัสสิบหลักของการประกาศศุลกากร',
  InspectionTenBitCode: 'รหัสตรวจสอบสิบหลัก',
  TradeDetail: 'รายละเอียดของสินค้า',
  TradeCommission: 'การค้าขาย',
  HblInfo: 'ข้อมูลสลิปย่อย',
  MBLInfo: 'ข้อมูลใบตราส่งสินค้าหลัก (MBL)',
  Charge: 'ค่าธรรมเนียม',
  InternalBillInfo: 'บิลในประเทศ',
  OverseaBillInfo: 'บิลต่างประเทศ',
  AdvanceChargeInfo: 'การชำระเงินดาวน์',
  DocumentCirculation: 'การไหลเวียนของเอกสารเดียว',
  FileHistory: 'ประวัติไฟล์',
  ImportToPDF: 'การนำเข้า PDF',
  Trucking: 'จุดบริการลูกค้า',
  ImportOperation: 'การดำเนินการนำเข้า',
  CustomsDeclarationOnward: 'พิธีการศุลกากร / การต่ออายุ',
  WarehouseDoorLoading: 'คลังสินค้าภายใน / ประตูจุดบรรจุกล่อง',
  GrossWeight: 'น้ำหนักรวม',
  CustomJobType: 'ประเภทธุรกิจที่กำหนดเอง',
  TaxNature: 'ภาษี',
  ContainerInfo2: 'ข้อมูลสินค้ากล่อง',
  ContainerIdentification: 'โลโก้สินค้ากล่อง',
  CopyConsignationDescriptionAndMarks: 'คัดลอกชื่อจากเครื่องหมายการจัดส่งที่ได้รับมอบหมาย',
  SelecteAll: 'เลือกทั้งหมด',
  ConsigneeShipperAndNotifyAddress: 'ที่อยู่ทางไปรษณีย์',
  ShipperId: 'รหัสผู้ส่ง',
  ConsigneeId: 'รหัสผู้รับ',
  NotifyId: 'รหัสผู้แจ้ง',
  ShipperInfo: 'ข้อมูลผู้ส่งสินค้า',
  ConsigneeInfo: 'ข้อมูลผู้รับ',
  NotifyInfo: 'ข้อมูลผู้แจ้ง',
  CopyShipper: 'เลือกผู้ส่ง',
  CopyConsignee: 'เลือกผู้รับ',
  CopyNotify: 'เลือกผู้แจ้ง',
  CopyManifestShipper: 'เลือกผู้ส่งสินค้า',
  CopyManifestConsignee: 'เลือกผู้รับสินค้า',
  CopyManifestNotify: 'เลือกผู้แจ้งรายการสินค้า',
  CopyAll: 'เลือก',
  FillInQuantityOfVotes: 'กรอกบัตรลงคะแนน',
  QueryLCLJobOrder: 'เข้าร่วมแบบสอบถามแผ่นงาน LCL',
  QueryLCLJobOrder2: 'เข้าร่วมแบบสอบถามแผ่นงาน',
  QuantityOfSelectedOrder: 'เลือกจำนวนโหวต',
  NoDisplay: 'ไม่แสดง',
  Number: 'จำนวนโหวต',
  SelectSoNo: 'S/O ไม่ เลือก',
  MBLHBR: 'MBL และหมายเลขเดียว',
  AgentInfo: 'ข้อมูลตัวแทน',
  HBLHBR: 'HBL และหมายเลขเดียว',
  ChargeItem: 'ชื่อค่าธรรมเนียม',
  Close: 'ปิด',
  SearchJobNo: 'เรียกดูแผ่นงาน',
  SerialNo: 'เรือไหล',
  Search: 'ดึงข้อมูล',
  VolumeOnBl: 'ปริมาณ B / L',
  MethodOfPayment: 'วิธีการชำระเงิน',
  PortOfFinalDestination: 'ท่าเรือปลายทางสุดท้าย',
  SelectContainerInfo: 'เลือกข้อมูลการบรรจุ',
  SearchTheWarehouseRecords: 'สอบถามบันทึกคลังสินค้า',
  ReceiptNo: 'หมายเลขใบตอบรับ',
  warehouseOp: 'พนักงานคลังสินค้า',
  deliveryCMP: 'บริษัท จัดส่ง',
  inDate: 'วันที่เข้าคลังสินค้า',
  DamagedAndDamp: 'ได้รับความเสียหายจากความชื้น',
  EntryCustomsInformation: 'ป้อนข้อมูลการประกาศศุลกากร',
  Recorded: 'รายการแล้ว',
  ListPulled: 'ดึงแผ่น',
  AtReception: 'ที่แผนกต้อนรับส่วนหน้า',
  CustomsDeclared: 'รายงานดี',
  Undeclared: 'ยังไม่ได้รับการรายงาน',
  CustomsExamination: 'การตรวจสอบศุลกากร',
  InspectionExamination: 'การตรวจสอบสินค้า',
  ExamedWithoutReleasing: 'ตรวจสอบไม่ได้ปล่อย',
  AmendDeclaration: 'เปลี่ยนแผ่น',
  NotifyToDeclare: 'ฯลฯ ประกาศศุลกากร',
  CustomsExamed: 'มีปัญหาในการตรวจสอบทางศุลกากร',
  PreNumber: 'หมายเลขรายการ',
  ContainerNo2: 'ประเภทตู้ หมายเลขตู้',
  UnknownState: 'ไม่ทราบสถานะ',
  ProductName: 'ชื่อโครงการ',
  Carrier: 'ผู้ให้บริการ',
  RecordCount: 'จำนวนระเบียน',
  Autowire: 'จับคู่อัตโนมัติ',
  SchemaName: 'ชื่อโปรแกรม/ค่าธรรมเนียม',
  Receivable: 'การรับชำระเงิน',
  PartnerType: 'ประเภทหน่วยการชำระเงิน',
  Account: 'หน่วยการชำระเงินคงที่',
  MeasureCurrency: 'หน่วยเรียกเก็บเงิน',
  MeasureUnit: 'หน่วยเรียกเก็บเงิน',
  UnitRate: 'ราคาต่อหน่วย',
  MiniMum: 'ค่าธรรมเนียมขั้นต่ำ',
  FCLFreightTariff: 'รายการค่าขนส่ง FCL',
  PleaseInputTariffSheet: 'กรุณากรอกหมายเลขใบนำส่ง',
  CostLeave: 'เกรดการจัดส่งสินค้า:',
  ValidFrom: 'วันหมดอายุตั้งแต่',
  ValidTo: 'ใช้ได้จนถึง',
  MON: 'วันจันทร์',
  TUE: 'วันอังคาร',
  WED: 'วันพุธ',
  THU: 'วันพฤหัสบดี',
  FRI: 'วันศุกร์',
  SAT: 'วันเสาร์',
  SUN: 'วันอาทิตย์',
  GetCostsByTheCabinet: 'ค่าใช้จ่ายแยกตามประเภทตู้',
  ShippingFeesAreALLINTHEWAYImport: 'ค่าขนส่งทางทะเล ไม่ ALL IN วิธีการนำเข้า',
  PriceNo: 'หมายเลขค่าจัดส่ง',
  BranchCMP: 'สำนักงานสาขา',
  IsDirect: 'โดยตรง',
  PriceState: 'สถานะห้องโดยสาร',
  Trend: 'แนวโน้ม',
  Share: 'ลักษณะของห้องโดยสาร',
  ContractNo: 'หมายเลขโดยประมาณ',
  PriceFrom: 'แหล่งที่มาของราคาจัดส่ง',
  SailingDate: 'กำหนดเวลาเรือ',
  Voyage2: 'การเดินทาง',
  Cargo: 'สินค้า',
  Box: 'กล่อง',
  Dock: 'ท่าเรือแขวน',
  LCLFreightTariff: 'รายการค่าขนส่ง FCL',
  ImportCostsByPeers: 'ค่าธรรมเนียมการนำเข้าโดยเพียร์',
  PriceState2: 'สถานะค่าจัดส่ง',
  CostValue: 'ราคาต้นทุน',
  PeerPrice: 'ราคาเพียร์',
  DirectPrice: 'ราคาบัตรโดยสาร',
  MarketPrice: 'ราคาตลาด',
  ClosingDay: 'วันที่ตัดศุลกากร',
  ShareCarrier: 'บริษัท เรือโดยสารร่วม',
  VerificationSchedule: 'ตารางรายละเอียดการขายนิวเคลียร์',
  Cash: 'เงินสด',
  Check: 'เช็ค',
  Transfer: 'โอนเงิน',
  ClearingDate: 'วันที่ชำระราคา',
  PayReceiveDate: 'วันที่รับเงิน',
  VerificationBy: 'ตัวแทนจำหน่าย',
  ClearCurrency: 'สกุลเงิน Nuclear Outlet',
  ClearRate: 'อัตราการชำระหนี้',
  ClearAmount: 'จำนวนเงินชำระหนี้',
  VoucherNo: 'หมายเลขคูปอง',
  OurBank: 'ธนาคารของเรา',
  AddBillCharge: 'ค่าธรรมเนียมการเข้าร่วม',
  RemoveBillCharge: 'ค่าธรรมเนียมการกำจัด',
  ShowBillDetail: 'แสดงข้อมูลการเรียกเก็บเงิน',
  Close2: 'วางลง',
  OverseasBillingMaintenance: 'การบำรุงรักษาบิลต่างประเทศ',
  MainOffice: 'บริษัท บิลอัพ',
  BillType: 'ประเภทการเรียกเก็บเงิน',
  BillAmount: 'จำนวนภาษี',
  AccountObject: 'วัตถุของการตั้งถิ่นฐาน',
  Bank: 'เปิดบัญชีธนาคาร',
  BankAccount: 'หมายเลขบัญชีธนาคาร',
  CounterPartyBillingNo: 'หมายเลขบิลของฝ่ายตรงข้าม',
  InputDate: 'วันที่เรียกเก็บเงิน',
  RevenueTotalGroup: 'สกุลเงินทั้งหมด',
  IncludingTaxAmount: 'ราคารวมภาษี',
  ExcludingTaxAmount: 'ราคายังไม่รวมภาษี',
  WhetherCollectingAdvance: 'ไม่ว่าจะเป็นการรับเงินดาวน์แทน',
  Unit: 'หน่วย',
  Quantity2: 'ปริมาณ',
  ShowLcl: 'แสดงค่าธรรมเนียมตั๋วขนาดเล็ก',
  AgentIntoBills: 'ตัวแทนแบ่งการเรียกเก็บเงิน',
  Office: 'Bill Up สาขา',
  Percentage: 'แบ่งเป็นสัดส่วน',
  IsPercentage: 'แบ่งเป็น',
  ChargeEnglishName: 'ค่าธรรมเนียม ชื่อภาษาอังกฤษ',
  ChangeSchema: 'โปรแกรมค่าธรรมเนียม',
  SendEMail: 'ส่งจดหมาย',
  LocalAgent: 'ตัวแทนท้องถิ่น',
  placeholderVal: 'โปรดเลือกเทมเพลตจดหมายก่อนแล้วจึงเลือกเทมเพลต',
  UpDestAgent: 'ตัวแทนท่าเรือต้นทาง/ปลายทาง',
  Haulage: 'กองเรือ',
  CompanyName: 'ชื่อบริษัท',
  GroupCode: 'รหัสบริษัท',
  CompanyAddress: 'ที่อยู่บริษัท',
  Contact: 'ติดต่อ',
  OtherInformation: 'ข้อมูลอื่นๆ',
  BlTitle: 'ชื่อ บริษัท B / L',
  BlAddress: 'ที่อยู่ B / L',
  BlContact: 'ข้อมูลการติดต่อ BL',
  MscBlAddress: 'ที่อยู่ B / L ของ Msc',
  PleaseChooseItem: 'โปรดเลือกรายการที่ต้องการดำเนินการก่อน',
  WhetherDelete: 'ยืนยันว่าจะลบหรือไม่',
  IsEmptyPleaseEnter: 'ว่างเปล่า กรุณากรอกข้อมูลให้ครบถ้วน',
  Cc: 'ซีซี',
  MailContent: 'เนื้อหาของจดหมาย',
  SystemEmail: 'กล่องจดหมายระบบ',
  CompanyMail: 'กล่องจดหมายบริษัท',
  PersonalMailbox: 'กล่องจดหมายส่วนตัว',
  emailSubject: 'หัวข้อจดหมาย',
  mailTemplate: 'เทมเพลตจดหมาย',
  SaveTheDefaultCC: 'บันทึก CC ปริยาย',
  Title: 'หัวข้อ',
  Content: 'เนื้อหา',
  operationalMotion: 'การดำเนินการดำเนินการ',
  operationTime: 'เวลาทำงาน',
  customsReceiptStatus: 'สถานะการส่งกลับศุลกากร',
  returnTime: 'เวลาคืน',
  source: 'แหล่งที่มา',
  FileUpload: 'อัพโหลดไฟล์',
  FileName: 'ชื่อแฟ้ม',
  FileSize: 'ขนาดไฟล์',
  UploadProgress: 'อัพโหลดความคืบหน้า',
  DocumentType: 'ประเภทเอกสาร',
  SelectFile: 'เลือกไฟล์',
  DeleteFile: 'ลบไฟล์',
  Upload: 'อัพโหลด',
  PlsSeeEIR: 'โปรดดูแบบฟอร์มการส่งมอบอุปกรณ์',
  SelectCopyContent: 'เลือกเนื้อหาที่คัดลอก',
  DuplicateContent: 'คัดลอกเนื้อหา',
  BasicInfo: 'ข้อมูลพื้นฐาน',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAsk: 'คัดลอกโดยการเลือกนี้ในภายหลังโดยไม่ต้องถามอีก หากคุณต้องการตั้งค่าเงื่อนไขใหม่สามารถแตะที่ปุ่ม Setting & Tools ที่มุมขวาบน - Page Personalization',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskLeft: 'ตั้งเนื้อหาที่เลือกนี้เป็นการคัดลอกโดยปริยายและจะไม่มีการแจ้งเตือนครั้งต่อไป',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskRight: 'หากต้องการรีเซ็ตเนื้อหาที่คัดลอกให้ไปที่ไอคอนเมนูด้านขวาบน - การตั้งค่าและเครื่องมือ - ในการปรับแต่งหน้าเว็บแตะปุ่มการตั้งค่า',
  Slaves: 'บัตรลงคะแนนขนาดเล็ก',
  Master: 'บัตรลงคะแนนหลัก',
  CustomerCount: 'จำนวนลูกค้า',
  SingleWeight: 'น้ำหนักชิ้นเดียว',
  Weight2: 'น้ำหนัก',
  ReceivableType: 'ประเภทรายรับและรายจ่าย',
  AccountType: 'ประเภทหน่วยการชำระเงิน',
  Account2: 'หน่วยการชำระเงิน',
  Oversea: 'ทั้งในและต่างประเทศ',
  Remove: 'ลบ',
  SourceAmount: 'จำนวนเงินเดิม',
  NewAmount: 'จำนวนเงินใหม่',
  IsUpdate: 'ไม่ว่าจะเป็นการปรับปรุง',
  ExportLog: 'บันทึกการส่งออก',
  Role: 'ฟังก์ชัน',
  Mobile: 'โทรศัพท์มือถือ',
  Email: 'ที่อยู่อีเมล',
  SOPOperatingState: 'สถานะการทำงาน SOP',
  KG: 'กิโลกรัม',
  CBM: 'ลูกบาศก์เมตร',
  Tons: 'ตัน',
  SelectOpRequirement: 'การเลือกความต้องการในการใช้งาน',
  PleaseInputAKeyword: 'กรุณาป้อนคำหลัก',
  contentDescription: 'คำอธิบายเนื้อหา',
  chargeItem: 'รายการค่าธรรมเนียม',
  LCLLastBillOfLading: 'LCL ใบตราส่งสุดท้าย',
  Addr: 'ที่อยู่',
  OnlyOriginalSend: 'ส่งต้นฉบับเท่านั้น',
  OnlyAddAndDeleteSend: 'ส่งเฉพาะการแก้ไขและลบ',
  NoSuccessAddAndDeleteNotSend: 'ส่งไม่สำเร็จ ไม่สามารถส่งการแก้ไขหรือลบซ้ำได้',
  NeedFillPortBeforeEnteringEU: 'ต้องกรอกท่าก่อนเข้าสหภาพยุโรป',
  HouseNumber: 'เลขที่บ้าน',
  Country: 'ประเทศ',
  Province: 'จังหวัด',
  City: 'เมือง',
  ZIP: 'รหัสไปรษณีย์',
  SelectCharge: 'เลือกค่าธรรมเนียม',
  First: 'หน้าแรก',
  Pre: 'หน้าก่อนหน้า',
  Page: 'ข้อที่',
  AllPage1: 'ทั้งหมด',
  AllPage2: 'หน้า',
  Next: 'หน้าถัดไป',
  Last: 'หน้าสุดท้าย',
  ShowFromTo1: 'แสดง',
  ShowFromTo2: 'ถึง',
  AllRecord1: 'ทั้งหมด',
  AllRecord2: 'บันทึก',
  Convert: 'พับ',
  Received: 'การยอมรับ',
  Paid: 'จ่ายจริง',
  AllPositions: 'โพสต์ทั้งหมด',
  DestinationAgent1: 'ตัวแทนในต่างประเทศ',
  Accessible: 'เข้าถึงได้',
  IsDisplay: 'ไม่ว่าจะเป็นการแสดง',
  Uncertain: 'ยังไม่แน่ใจ',
  PrincipalUnitSOPReceiver: 'ผู้รับ SOP',
  PortOfDestinationAgency: 'ท่าเรือปลายทาง ผู้รับ SOP',
  DesignatedFreightAgentSOPReceiver: 'ระบุผู้รับ SOP ตัวแทนจัดส่งสินค้า',
  PortOfDepartureAgentSOPReceiver: 'ตัวแทนผู้รับ SOP',
  Unconfirmed: 'ยังไม่ได้รับการยืนยัน',
  Confirmed: 'ได้รับการยืนยันแล้ว',
  PassAudit: 'การตรวจสอบผ่าน',
  Refuse: 'ปฏิเสธ',
  Bl: 'ใบตราส่ง',
  Original: 'ต้นฉบับ',
  LateOriginal: 'ปลายชิน',
  Correct: 'การแก้ไข',
  Message: 'เอกสารเผยแพร่',
  DeleteCustoms: 'การลบ (การลบศุลกากร, การจอง Qitai)',
  DeleteAll: 'ลบ (ศุลกากร Qitai ลบทั้งหมด)',
  send: 'ส่ง',
  change: 'เปลี่ยนแผ่น',
  deleteSingle: 'ลบแผ่น',
  cancelBill: 'ถอนคำสั่ง',
  OverseasAgeFore: 'ตท.คาดการณ์',
  JclForecast: 'การคาดการณ์ JCL',
  AnnPackingList: 'กล่องติดตั้ง',
  PreShippingBill: 'รายการตู้สินค้าล่วงหน้า',
  PreShippingBillPperation: 'การดำเนินการ Manifold ล่วงหน้า',
  ShippingBill: 'รายการสินค้า',
  Anti_terrorismShipping: 'รายการต่อต้านการก่อการร้าย',
  CleanShipping: 'รายการทำความสะอาด',
  Suitcase: 'ยกกล่อง',
  DelSuitcase: 'ลบกระเป๋าเดินทาง',
  ViewHistory: 'ดูประวัติ',
  ElectronicPackingList: 'รายการบรรจุภัณฑ์อิเล็กทรอนิกส์ 99 วิธี',
  SendHistory: 'ส่งประวัติ',
  ShippingSchedule: 'ตารางเวลาเรือ',
  PortOfLoadingArea: 'บริเวณท่าเรือขนส่งสินค้า',
  PortOfDestinationArea: 'บริเวณท่าเรือปลายทาง',
  ShipsCallSign: 'หมายเลขเรือ EDI',
  ImportTheVoyage: 'เที่ยวบินที่นำเข้า',
  IncreaseThePort: 'เพิ่มพอร์ต',
  DeletePorts: 'ลบพอร์ต',
  AutomaticallyImportVoyage: 'นำเข้าเที่ยวบินอัตโนมัติ',
  CountryOfRegistration: 'ชื่อเรือ ประเทศที่จดทะเบียน',
  AddShippingCompany: 'เพิ่มบริษัทเรือ',
  DelShippingCompany: 'ลบ บริษัท เรือ',
  DepartureTime: 'เวลาออกเรือ',
  DateOfOrder: 'วันที่รับรายการ',
  ProjectReceivedBy: 'รับคนเดียว',
  dateOfFiling: 'วันที่ยื่น',
  ArchivePeople: 'ยื่นโดย',
  ReturnOrderExpressNumber: 'หมายเลขการจัดส่งสินค้าด่วน',
  StateOfTheWithdrawal: 'การถอนสถานะ',
  EmptyTheList: 'ล้างรายการ',
  BatchStateTransition: 'การแปลงสถานะแบทช์',
  CollectFormation: 'ข้อมูลการรับเงิน',
  RetreatASingle: 'รายการคืนเงิน',
  BatchSaving: 'บันทึกแบทช์',
  AppendQueryRecord: 'บันทึกการสอบถามเพิ่มเติม',
  StateHisCase: 'สถานะการยก',
  BoxStatus: 'สถานะกล่อง (เฉพาะท่าเรือเซี่ยงไฮ้)',
  StatusOfAnti_TerrorismManifest: 'สถานะ EDI รายการต่อต้านการก่อการร้าย',
  ManifestStatus: 'สถานะ Manifests EDI',
  AdvanceManifestStatus: 'สถานะ EDI',
  InstallPackingListStatus: 'สถานะ Safebox Single EDI',
  StateOfTheBillOfLading: 'สถานะ B/L EDI',
  BookingStatus: 'สถานะการจอง EDI',
  reset: 'รีเซ็ต',
  PrintStatus: 'สถานะการพิมพ์',
  TeamContact: 'ติดต่อ Fleet',
  ContactNumber: 'เบอร์ติดต่อ',
  DoorContact: 'ติดต่อ Doorpoint',
  DoorContactNumber: 'Doorpoint เบอร์ติดต่อ',
  PleaseScanTheBarcodeOrInputDirectly: 'กรุณาสแกนบาร์โค้ดหรือป้อนข้อมูลโดยตรง',
  CollectionSituation: 'สถานการณ์การรับเงิน',
  DocumentDate: 'วันที่เอกสาร',
  checkbox: '【หลายช่อง】',
  RefundDate: 'วันที่ขอคืนภาษี',
  RefundPerson: 'การขอคืนภาษี',
  AutomaticallyRefresh: 'รีเฟรชอัตโนมัติ',
  Piece: 'ชิ้น',
  Volume: 'ร่างกาย',
  CartonQuantity: 'ประเภทกล่อง ปริมาณกล่อง',
  ClientsRequirement: 'ความต้องการของลูกค้า',
  LandCarriage: 'การขนส่งทางบก',
  HLID: 'รหัสการเชื่อมต่อ',
  ShippingCmp: 'กองเรือ',
  CarrierSpecificCode: 'รหัสเฉพาะของกองเรือ',
  PortOfLoadingAI: 'ท่าเรือขนส่งสินค้า',
  RiverCarrier: 'บริษัท เชียงเรือ',
  Synchronization: 'ซิงค์',
  BatchShutOut: 'ยกเลิกศุลกากร',
  OverseaCustomerService: 'ฝ่ายบริการลูกค้าต่างประเทศ',
  CargoFeature: 'คุณสมบัติของสินค้า',
  CustomerLevel: 'ระดับลูกค้า',
  ContractStatus: 'สถานะสัญญา',
  HBLNotifier: 'ผู้แจ้งรายการย่อย',
  ExportWithSOPToExcel: 'ส่งออก Excel (มีรายละเอียด SOP)',
  ManagerSubmission: 'ส่งโดยผู้บังคับบัญชา',
  CustomerSelfRelease: 'ใบสั่งซื้อจากลูกค้าเอง',
  CompanySelfRelease: 'ใบสั่งซื้อจากบริษัท',
  QuantitySize: 'จำนวนชิ้น ขนาด',
  EquipmentEstimatedReturnTimeFrom: 'คาดว่าจะเริ่มส่งคืนคณะรัฐมนตรี',
  EquipmentEstimatedReturnTimeTo: 'คาดว่าจะส่งคืนคณะรัฐมนตรีถึง',
  copyDGStuffing: 'คัดลอก',
  pasteDGStuffing: 'วางบน',
  viewDGStuffing: 'ดู',
  copyAndAddPoItems: 'คัดลอกใหม่',
  SynchroHBLInfo: 'ซิงค์ข้อมูล HBL',
  Cubage2: 'ปริมาณ m³',
  AMSLog: 'บันทึกประจำวัน',
  AMSReceiptInfo: 'ดูการตอบกลับ',
  ViewAssociatedBusiness: 'ดูธุรกิจที่เกี่ยวข้อง',
  isShutOut: 'ไม่ว่าจะเป็นการถอนตัว',
  RevokeTuckOrder: 'ถอนคำสั่ง',
  SearchTuckOrder: 'สอบถาม',
  ShowTuckOrderLog: 'บันทึกประจำวัน',
  TuckStatus: 'สถานะการส่งรถ',
  DriverNameHL: 'คนขับรถที่เชื่อมต่อ',
  DriverPhoneHL: 'การเชื่อมต่อโทรศัพท์',
  TruckNoHL: 'ป้ายทะเบียนที่เชื่อมต่อกัน',
  TmsNoHL: 'หมายเลขส่งรถ',
  ContainerSerialNo: 'หมายเลขลำดับกล่อง',
  ContainerNoDiff: 'เคล็ดลับความแตกต่าง',
  isRelated: 'ไม่ว่าจะเป็นความเกี่ยวข้อง',
  viewDGStuffingInvalid: 'โมฆะ',
  CommissionedChargedWeight: 'น้ำหนักการเรียกเก็บเงินที่ได้รับมอบหมาย',
  CustomsHasCheck: 'ศุลกากรตรวจสอบแล้ว',
  CustomsOneRelease: 'ปล่อยครั้งเดียว',
  CustomsRelease2: 'ปล่อย',
  PartnerShortType: 'ประเภท',
  Transit2: 'การถ่ายโอนข้อมูล',
  AuditDate: 'วันที่ปรับ',
  IsNeedInvoice: 'ไม่ว่าจะเป็นการเรียกเก็บเงินที่จำเป็น',
  needInvoice: 'ต้องมีใบแจ้งหนี้',
  InvoiceNo: 'หมายเลขภาษี',
  Email2: 'กล่องจดหมาย',
  DgconsignParty: 'DGCONSIGN',
  ElseInvoiceParty: 'ELSEINVOICE',
  ShowPODAgency: 'ShowPODAgency',
  FnlTm: 'วิธีการโอนย้ายจุดภายในประเทศ',
  InvokeLocalMailClient: 'เรียกกล่องจดหมายภายใน',
  preview: 'สร้างอุปกรณ์เสริม',
  attachment: 'อุปกรณ์เสริม:',
  AddPackingInfo: 'เพิ่มข้อมูลการบรรจุ',
  RemovePackingInfo: 'ลบข้อมูลบรรจุภัณฑ์',
  sendJdy: 'ส่ง Jiandao Cloud',
  sendFailInfo: 'ส่งแถบสำเร็จ {0} แถบล้มเหลว {1}：',
  batchSendJdy: 'ส่ง Jandao Cloud เป็นกลุ่ม',
  batchUnlockGoodsDetails: 'รายละเอียดสินค้าปลดล็อคเป็นกลุ่ม',
  IdentifyPackingList: 'ระบุเอกสารประกอบบรรจุภัณฑ์',
  BoxListRecognition: 'ai - การระบุกล่อง',
  SupportingUploadFormat: 'รูปแบบที่สนับสนุนสําหรับการอัปโหลด pdf / xls / xlsx / doc / docx / jpg / gif / png , ขนาดไม่เกิน 4 เมกะไบต์',
  UploadedFile: 'อัปโหลดแฟ้มแล้ว',
  Parsing: 'กําลังแยกวิเคราะห์',
  SpecialCharactersNotAllow: 'ชื ่ อแฟ ้ มไม ่ อนุญาตให ้ อักขระพิเศษ',
  MaterialInformation: 'ข้อมูลวัสดุ',
  MaterialNumber: 'รายการ',
  HsCode2: 'HS CODE',
  NetWeightKg: 'น้ําหนักสุทธิ ( kg )',
  PONumber: 'หมายเลข po',
  FilePreview: 'แสดงตัวอย่างแฟ้ม',
  MultiCabinets: 'หลายตู้',
  CopyDoorPoint: 'คัดลอกข้อมูลตู้ลากจุดประตู',
  SelectCabinetData: 'เลือกทำข้อมูลตู้',
  ExportPackingInfo: 'ส่งออกทำกล่องข้อมูล',
  ImportPackingInfo: 'นำเข้าข้อมูล Do Box',
  ContainerId: 'รหัสกล่อง',
  TrailerRemark: 'หมายเหตุรถพ่วง',
  RemarkItems: 'หมายเหตุเพิ่มเติม',
  DriverId: 'บัตรประชาชน',
  DriverName: 'พนักงานขับรถ',
  DriverPhone: 'โทรศัพท์มือถือ',
  TruckNo: 'ป้ายทะเบียน',
  EstimatArrivalTime: 'คาดว่าเมื่อถึงเวลาโรงงาน',
  DownloadImportResults: 'ดาวน์โหลดผลการนำเข้า',
  ImportSuccess: 'นำเข้าสำเร็จ',
  ImportFaildAndDownFile: 'มีชุดข้อมูลที่ล้มเหลวในการนำเข้าโปรดดาวน์โหลดผลการนำเข้าเพื่อดู!',
  SendBack: 'การคืนเงิน',
  MSC: 'MSC',
  CompanyInfo: 'ข้อมูล บริษัท',
  LadingBillInfo: 'ข้อมูล BL',
  HV: 'HV',
  RefNo: 'หมายเลขอ้างอิง',
  DgStuffing: 'DG Stuffing',
  HSCODE: 'HSCODE',
  CustomsCommodity: 'ประกาศศุลกากร ชื่อสินค้า',
  TradeShortName: 'ชื่อย่อของสินค้า',
  Code3: 'รหัส',
  TradeDescription: 'คำอธิบายของสินค้า',
  ShippingMark: 'เครื่องหมายการจัดส่งสินค้า',
  ZipCode: 'รหัสไปรษณีย์',
  EmailAddress: 'อีเมล์',
  VipCode: 'รหัสวีไอพี',
  InttraCode: 'รหัส INTTRA',
  MscCode: 'รหัส MSC',
  CompanyCode: 'รหัสบริษัท',
  LadingBillTitle: 'B / L เพิ่มขึ้น',
  LadingBillAddress: 'ที่อยู่ B / L',
  LadingBillContactInfo: 'ข้อมูลการติดต่อ BL',
  MstBooking: 'MST BOOKING',
  SplitType: 'แยกประเภท',
  RelatedOrderNo: 'หมายเลขคำสั่งซื้อที่เกี่ยวข้อง',
  SignedType: 'ประเภทของสัญญา',
  FreightTerm: 'เงื่อนไขการจัดส่งสินค้า',
  PlaceOfPayment: 'สถานที่ชำระเงิน',
  ProductionInstallationPlace: 'สถานที่ผลิตและอุปกรณ์',
  ProductionInstallationPlaceStation: 'สถานีสนามผลิต',
  ProductionInstallationModeOfTransportation: 'วิธีการจัดส่งสินค้าสำหรับการผลิตและบรรจุ',
  PortOfLoadingWharf: 'ท่าเรือต้นทาง',
  PortOfDischargeWharf: 'ท่าเรือขนถ่ายสินค้า',
  PortOfDischargeRequire: 'ความต้องการพอร์ตการปลดปล่อย',
  Destination: 'จุดหมายปลายทาง',
  DestinationStation: 'สถานีปลายทาง',
  DestinationTransportWay: 'วิธีการถ่ายโอนปลายทาง',
  TransferCountry: 'ประเทศเปลี่ยนเครื่อง',
  BlNumber: 'BL NUMBER',
  FreightBL: 'Freight BL',
  PODAgency: 'POD Agency',
  MscServiceCode: 'รหัสบริการ',
  ToOrderType: 'TO ORDER TYPE',
  DestinationZipCode: 'รหัสไปรษณีย์ปลายทาง',
  CopyCompany: 'สำเนาข้อมูลบริษัท',
  ChargeImport: 'ค่าธรรมเนียมการนำเข้า',
  customerLevel: 'ระดับลูกค้า',
  isSignContract: 'ไม่ว่าจะเป็นการเซ็นสัญญา',
  RemovePacking: 'ลบกล่อง',
  LastContainerDescription: 'ภาพสินค้าล่าสุด',
  SelectLocation: 'เลือกสถานที่',
  GetBack: 'การรับคืน',
  CancelGetBack: 'ถอนการรับคืน',
  Releasing: 'ใส่แผ่น',
  CancelReleasing: 'เพิกถอนแผ่นวางจำหน่าย',
  StatusModefySuccessfully: 'แก้ไขสถานะสำเร็จ',
  BillingOfLadingRecordManager: 'บันทึก B / L',
  ApplyForARelease: 'ใบสมัครสำหรับใส่แผ่น',
  RequestReleaseBy: 'ใบสมัคร วางคนเดียว',
  TicketHasSplit: 'ตั๋วนี้ถูกถอดออกแล้วโปรดส่งใบสมัครในการแยกชิ้นส่วน',
  TicketHasMerged: 'กรุณากรอกใบสมัครลงในแบบฟอร์ม',
  RequestReleaseDate: 'วันที่สมัครวางบิล',
  RequestReleaseState: 'ใบสมัคร สถานะการวางแผ่น',
  MblRequestReleaseState: 'สถานะขอปล่อย MBL',
  HblRequestReleaseState: 'สถานะขอปล่อย HBL',
  NotApplying: 'ยังไม่ได้สมัคร',
  Requested: 'สมัครแล้ว',
  NoGuarantee: 'ไม่มีหนังสือค้ำประกัน',
  InEffect: 'มีผลบังคับใช้',
  Expired: 'ล้มเหลวแล้ว',
  Uploaded: 'อัปโหลดแล้ว',
  NotUploaded: 'ไม่ได้อัพโหลด',
  NoUploadRequired: 'ไม่จำเป็นต้องอัปโหลด',
  NotUploadedYetPlease: 'ยังไม่ได้อัพโหลด กรุณา',
  LongTermGuaranteeState: 'สถานะหนังสือค้ำประกันระยะยาว',
  SingleTicketGuaranteeState: 'สถานะหนังสือค้ำประกันตั๋วใบเดียว',
  WithdrawTheRequestForRelease: 'การถอนใบสมัคร',
  NoRequestReleaseData: 'ไม่มีข้อมูลที่ต้องใช้ในการยื่นขอวางบิล',
  NoCancelRequestReleaseData: 'ไม่มีข้อมูลที่จะต้องถอนใบสมัคร',
  ReleasingDate: 'วันที่ใส่แผ่น',
  mblReleasingDate: 'วันที่ใส่ MBL',
  receiptDate: 'เวลา',
  receiptContent: 'เนื้อหา',
  receiptCode: 'รหัสตอบกลับ',
  createdDate: 'เวลา',
  createdBy: 'ดำเนินการโดย',
  content: 'เนื้อหา',
  consignorCode: 'รหัสธุรกิจของผู้ส่ง',
  codeAbbreviation: 'ชื่อย่อรหัส',
  enterpriseCode: 'รหัสองค์กร',
  consignorName: 'ชื่อธุรกิจของผู้ส่ง',
  consignorDetailAddress: 'ที่อยู่โดยละเอียดของผู้จัดส่ง',
  consignorPhone: 'หมายเลขโทรศัพท์ของผู้จัดส่ง',
  consignorEmail: 'ที่อยู่ EMAIL ของผู้จัดส่ง',
  consignorRelexNumber: 'หมายเลขโทรสารของผู้จัดส่ง',
  cityName: 'ชื่อเมือง',
  consignorCityName: 'ชื่อเมืองของผู้จัดส่ง',
  provinceCode: 'รหัสจังหวัด',
  provinceName: 'ชื่อจังหวัด',
  postalCode: 'รหัสไปรษณีย์',
  countryCode: 'รหัสประเทศ',
  aeoEnterpriseCode: 'รหัสองค์กร AEO',
  formatSynchronizeToOrder: 'ซิงค์ข้อมูลการจัดรูปแบบการสั่งซื้อ',
  ladingBill: 'ระบุ B / L',
  consigneeCode: 'รหัสธุรกิจผู้รับ',
  consigneeCodeAbbreviation: 'ชื่อย่อรหัส',
  consigneeEnterpriseCode: 'รหัสองค์กร',
  consigneeName: 'ชื่อธุรกิจผู้รับ',
  consigneeDetailAddress: 'ที่อยู่ของผู้รับ',
  consigneePhone: 'หมายเลขโทรศัพท์ของผู้รับ',
  consigneeEmail: 'ที่อยู่ EMAIL ของผู้รับ',
  consigneeRelexNumber: 'หมายเลขโทรสารของผู้รับ',
  consigneeCityName: 'ชื่อเมือง',
  consigneeProvinceCode: 'รหัสจังหวัด',
  consigneeProvinceName: 'ชื่อจังหวัด',
  consigneePostalCode: 'รหัสไปรษณีย์',
  consigneeCountryCode: 'รหัสประเทศ',
  consigneeAeoEnterpriseCode: 'รหัสองค์กร AEO',
  specificContactName: 'ชื่อผู้ติดต่อเฉพาะ',
  specificContactPhone: 'หมายเลขโทรศัพท์ติดต่อเฉพาะ',
  specificContactAddress: 'ที่อยู่ติดต่อเฉพาะ EMAIL',
  specificContactRelexNumber: 'หมายเลขโทรศัพท์ติดต่อเฉพาะ',
  notifyingCode: 'แจ้งรหัสธุรกิจ',
  notifyingCodeAbbreviation: 'ชื่อย่อรหัส',
  notifyingEnterpriseCode: 'รหัสองค์กร',
  notifyingName: 'แจ้งชื่อธุรกิจ',
  notifyingDetailAddress: 'แจ้งที่อยู่โดยละเอียด',
  notifyingPhone: 'หมายเลขโทรศัพท์ของผู้แจ้ง',
  notifyingEmail: 'แจ้งที่อยู่ EMAIL',
  notifyingRelexNumber: 'แจ้งหมายเลขโทรสาร',
  notifyingCityName: 'ชื่อเมือง',
  notifyingProvinceCode: 'รหัสจังหวัด',
  notifyingProvinceName: 'ชื่อจังหวัด',
  notifyingPostalCode: 'รหัสไปรษณีย์',
  notifyingCountryCode: 'รหัสประเทศ',
  notifyingAeoEnterpriseCode: 'รหัสองค์กร AEO',
  formatManifestInformation: 'การจัดรูปแบบข้อมูลรายการสินค้า',
  freightChargesInfo: 'ข้อมูลค่าธรรมเนียม',
  freightChargesUSDTotal: 'ค่าธรรมเนียม USD รวม:',
  tips: 'เคล็ดลับ!',
  checkNominatedAgent: 'ตัวแทนจัดส่งที่ระบุไม่สามารถว่างเปล่า!',
  checkActualNotifyParty: 'ผู้แจ้งเตือนที่แท้จริงไม่สามารถว่างเปล่า!',
  checkConsignationCompany: 'หน่วยบัญชาการต้องไม่ว่างเปล่า!',
  checkLoadingPort: 'พอร์ตของการโหลดไม่สามารถว่างเปล่า!',
  checkLoadingPort2: 'พอร์ตการจัดส่งสินค้าไม่สามารถว่างเปล่า!',
  checkPortOfDischarge: 'ท่าเรือขนถ่ายสินค้าต้องไม่ว่างเปล่า!',
  checkPlaceOfDelivery: 'สถานที่จัดส่งต้องไม่ว่างเปล่า!',
  checkFinalDestination: 'ปลายทางสุดท้ายต้องไม่ว่างเปล่า!',
  checkDateOfDepartureAndDateOfArrival: 'วันที่ออกเดินทางต้องไม่เกินวันที่มาถึง!',
  checkSales: 'ยอดขายไม่สามารถว่างเปล่า!',
  checkDept: 'ดิวิชั่นจะว่างเปล่าไม่ได้!',
  searchInfo: 'ไม่มีการป้อนข้อมูลการสอบถาม!',
  checkVslVoy: 'ชื่อเรือหรือเที่ยวบินไม่สามารถเว้นว่างได้',
  prePlanBooking: 'ข้อมูลประกอบล่วงหน้า',
  VgmInfo: 'ข้อมูล VGM',
  ChooseSoNoInfoToCopy: 'กรุณาทำเครื่องหมายที่ข้อมูลรายการศุลกากรเพื่อทำสำเนา ~',
  ChooseContainerInfoToCopy: 'โปรดเลือกข้อมูลกล่องสำหรับการคัดลอก ~',
  manifestLinkCopy: 'คัดลอกลิงก์ Manifests',
  manifestInviteSupplement: 'เชิญเข้าร่วมรายการพิเศษ',
  manifestQueryLog: 'การส่งกลับรายการ',
  manifestCfmStateLog: 'สถานะรายการสินค้า',
  manifestByPreShipping: 'รายการตู้สินค้าล่วงหน้า',
  manifestByClearBooking: 'รายการทำความสะอาด',
  manifestCfmButton: 'ยืนยัน',
  manifestUnLockButton: 'ปลดล็อคชั่วคราว',
  HBLWeight: 'น้ำหนักรวม B / L',
  HBLQuantity: 'จำนวนชิ้น B / L',
  BillPortOfLoading: 'ท่าเรือเริ่มต้นของ B / L',
  BillPortOfDischarge: 'ท่าเรือขนส่งสินค้า B / L',
  BillPlaceOfDelivery: 'สถานที่จัดส่ง B / L',
  UserDefinedField1: 'ฟิลด์ที่กำหนดเอง 1',
  UserDefinedField2: 'ฟิลด์ที่กำหนดเอง 2',
  UserDefinedField3: 'ฟิลด์ที่กำหนดเอง 3',
  UserDefinedArea: 'ข้อมูลที่กำหนดเอง',
  PleaseAddConsigneeFirst: 'โปรดเพิ่ม CONSIGNEE ก่อน',
  CopyConsigneeToNotify1: 'คัดลอก CONSIGNEE',
  OnlyOne: 'สามารถเลือกได้เพียงหนึ่งรายการเท่านั้น',
  CopyPoItemInfo: 'สำเนาข้อมูลการจัดส่งกล่อง',
  CopySuccess: 'คัดลอกสำเร็จ',
  CopyFaild: 'การคัดลอกล้มเหลว',
  PaseteSuccess: 'วางประสบความสำเร็จ',
  NoPasetePoItemInfo: 'ยังไม่ได้คัดลอกข้อมูลสินค้ากล่องโปรดคัดลอกก่อน',
  IsOrNotSpelling: 'เพิ่มขีดความสามารถหรือไม่?',
  Insure: 'ประกันชีวิต',
  billPaymentNo: 'หมายเลขใบคำขอชำระเงิน',
  confirmUser: 'ยืนยันค่าใช้จ่าย',
  ediFeedBackState: 'บันทึกการตอบกลับ',
  receiptPrompt: 'Tip: ส่งข้อมูลภายใน 20 วัน ใน Manifests ระบบจะทำการตอบกลับโดยอัตโนมัติ',
  loadingManifestReceipt: 'การโหลด Manifests ตอบกลับ',
  customsReceipt: 'ประกาศกรมศุลกากร',
  receiving: 'กำลังตอบกลับ',
  receiptSucceeded: 'การตอบกลับประสบความสำเร็จ',
  receiptFailed: 'การส่งกลับล้มเหลว',
  customCode: 'รหัสปิด',
  transportation: 'วิธีการจัดส่ง',
  receiptBillType: 'ประเภทใบนำส่ง',
  transportationName: 'ชื่อเครื่องมือขนส่ง',
  receiptVoyage: 'เที่ยวบิน/เที่ยวบิน',
  importArrivalSignal: 'เครื่องหมายรับรองการนำเข้า',
  receiptBillNumber: 'แบบฟอร์มการก่อสร้าง',
  entryDepatureDate: 'วันที่เข้าประเทศ',
  itemCount: 'จำนวนชิ้น',
  kilogram: 'กิโลกรัม',
  receiptWeight: 'ปริมาณ',
  tallyStatus: 'สถานะการจัดการสินค้า',
  exportArrivalStatus: 'สถานะการส่งออกมาถึง',
  sendLog: 'ส่งบันทึก',
  ediStatus: 'สถานะ EDI',
  ManifestDeliveryStatus: 'สถานะการจัดส่ง',
  chooseShipper: 'เลือกผู้ส่ง',
  chooseConsignee: 'เลือกผู้รับ',
  chooseNotify: 'เลือกผู้แจ้ง',
  bulkReplication: 'คัดลอกจำนวนมาก',
  PlannedDepartureTime: 'กำหนดเวลาออกเดินทาง',
  ActualDepartureTime: 'เวลาออกเดินทางจริง',
  PlannedArrivalTimeAtTheFactory: 'กำหนดเวลามาถึงโรงงาน',
  RealTimeOfArrivalAtTheFactory: 'เวลามาถึงโรงงานจริง',
  PlannedTimeToLeaveTheFactory: 'กำหนดเวลาออกจากโรงงาน',
  ActualTimeToLeaveTheFactory: 'เวลาออกจากโรงงานจริง',
  PlannedArrivalTime: 'กำหนดเวลาเดินทางมาถึง',
  ActualArrivalTime: 'เวลามาถึงจริง',
  currentLocation: 'ตำแหน่งปัจจุบัน',
  ViewExceptions: 'ดูข้อยกเว้น',
  truckingPlaceDep: 'ลานยกตู้',
  truckingPlaceDest: 'ลานเก็บของตู้คืน',
  travelTime: 'ในเวลาเดินทาง',
  Hour: 'ชั่วโมง',
  Minute: 'นาที',
  salesOffice: 'สาขาขาย',
  opOffice: 'สาขาปฏิบัติการ',
  BookingAgentIsNull: 'ตัวแทนการจองห้องพักว่างเปล่า',
  SOPReceiver: 'ผู้รับ SOP',
  Collectioninformation: 'ข้อมูลการรับเงิน',
  Appendqueryrecord: 'บันทึกการสอบถามเพิ่มเติม',
  SalesOfGoods: 'แพคเกจการขาย',
  BatchProcessing: 'การประมวลผลแบทช์',
  ClickSpaceToDropDownOptions: 'แตะช่องว่างเพื่อเลือกแบบเลื่อนลง',
  PleaseMaintainTheCorrespondingSalesInThePartner: 'โปรดไปที่คู่ค้าเพื่อดูแลรักษา',
  CheckRecordedCustomsDeclaration: 'สอบถามเกี่ยวกับการแจ้งเตือนการเปิดตัวของใบศุลกากร',
  ClearPacking: 'ล้างกล่อง',
  CopyMarksFromReceipt: 'ใช้เครื่องหมายการจัดส่งตั๋วขนาดเล็ก',
  PODCountry: 'ประเทศปลายทาง',
  Details: 'รายละเอียด',
  import: 'นำเข้า',
  DangerousClass: 'ระดับสินค้าอันตราย',
  DangerousGoodsContact: 'รายชื่อสินค้าอันตราย',
  DangerousGoodsContactPhoneNumber: 'หมายเลขติดต่อวัตถุอันตราย',
  emptyBox: 'กล่องเปล่า',
  ShipperByCompany: 'ผู้ส่ง (ข้อมูล บริษัท)',
  ConsigneeByCompany: 'ผู้รับ (ข้อมูล บริษัท)',
  PreverifyStatus: 'สถานะก่อนการพิจารณาคดี',
  ChangeCommit: 'ค่าธรรมเนียมในการยื่นคำขอเปลี่ยนแปลง',
  ConfirmChangeCommit: 'แน่ใจหรือไม่ว่าต้องการยื่นค่าธรรมเนียมการเปลี่ยนแปลง?',
  UserDefinedField4: 'ฟิลด์ที่กำหนดเอง 4',
  BoardSales: 'การขายระบบการตีบอร์ด',
  BoardCsr: 'ฝ่ายบริการลูกค้าระบบ Punch Plate',
  BoardSite: 'เว็บไซต์ระบบ Punch Plate',
  ArrivalMethod: 'วิธีการมาถึง',
  FlightLabel: 'ฉลากทางอากาศ',
  bargePOL: 'ท่าเรือขนส่งสินค้า (POL)',
  SalesRequire: 'ความต้องการในการขาย',
  OnlyDisplayTicket: 'แสดงเฉพาะบัตรขนาดเล็กที่ตรงตามเงื่อนไข',
  batchImportCharge: 'ค่าธรรมเนียมการนำเข้าจำนวนมาก',
  importCharge: 'ค่าธรรมเนียมการนำเข้า',
  historyLogQuery: 'สอบถามประวัติ',
  noRule: 'กฎหมายเลข',
  MBLNO: 'MBL NO',
  importSetting: 'นำเข้าการตั้งค่า',
  receivable: 'การรับสมัคร',
  payable: 'การรับมือ',
  importFile: 'นำเข้าไฟล์',
  confirmImport: 'ยืนยันการนำเข้า',
  checkLines: 'จำนวนแถวต้องไม่เกิน 1,000 แถว',
  checkLines200: 'จำนวนแถวต้องไม่เกิน 200 แถว',
  checkChargeInfo: 'กรุณาป้อนข้อมูลที่เกี่ยวข้องของค่าใช้จ่ายที่จะทำการดำเนินการนำเข้าอีกครั้ง!',
  internal: 'ในประเทศ',
  overseas: 'ต่างประเทศ',
  batchOperate: 'การดำเนินการแบทช์',
  batchImport: 'นำเข้า-มาก',
  activity: 'กระบวนการ',
  JobInfo: 'ข้อมูลธุรกิจ',
  Service: 'บริการ',
  Supplier: 'ผู้ให้บริการ',
  InnerInfo: 'ข้อมูลภายใน',
  Defined: 'การปรับแต่ง',
  MoreInfo: 'ข้อมูลเพิ่มเติม',
  unDisplayInfo: 'ซ่อนข้อมูล',
  GeneralInfo: 'ข้อมูลตั๋วขนาดเล็ก',
  BatchModifiedState: 'สถานะการปรับเปลี่ยนแบทช์',
  SplitTicketsInfo: 'ข้อมูลตั๋วโดยสาร',
  destinationStation: 'สถานีปลายทาง',
  departureStation: 'สถานีต้นทาง',
  transitStation: 'สถานีขนส่ง',
  destinationStationRailport: 'สถานีปลายทาง (รถไฟ)',
  departureStationRailport: 'สถานีต้นทาง (รถไฟ)',
  transitStationRailPort: 'สถานีขนส่ง (รถไฟ)',
  CommonInfo: 'ข้อมูลทั่วไป',
  settlementAgent: 'ตัวแทนการตั้งถิ่นฐาน',
  Dimension: 'ขนาด CM (L * W * H)',
  PaymentType: 'ชำระเงินล่วงหน้า / เก็บเงิน',
  ToPay: 'การชำระเงิน',
  PrePay: 'การชำระเงินล่วงหน้า',
  PickUpGoods: 'ไม่ว่าจะเป็นการรับสินค้า',
  DocumentationNumberOfPackages: 'จำนวนชิ้นที่ทำ',
  DocumentationGrossWeight: 'น้ำหนักรวมในการทำแผ่น',
  DocumentationVolume: 'ปริมาณการสั่งซื้อสินค้า',
  DocumentationChargedWeight: 'น้ำหนักการเรียกเก็บเงินสำหรับการสั่งซื้อ',
  CustomerQuantity: 'จำนวนชิ้นของลูกค้า',
  CustomerGrossWeight: 'น้ำหนักรวมของลูกค้า',
  CustomerVolume: 'ปริมาณลูกค้า',
  CustomerChargedWeight: 'น้ำหนักการเรียกเก็บเงินของลูกค้า',
  VerifyReviewThrough: 'ตรวจสอบผ่าน',
  VerifyReviewRefusal: 'ตรวจสอบปฏิเสธ',
  ImportTime: 'เวลานำเข้า',
  descr: 'หมายเหตุ คำอธิบาย',
  logFile: 'แฟ้มบันทึก',
  ChargeBranchId: 'สาขาในเครือ',
  DateCreated: 'วันที่เข้า',
  ProfitOwner: 'บุคคลที่ได้กำไร',
  ScfiDeclare: 'ประกาศ SCFI',
  ScfiPrice: 'SCFI ราคาจัดส่ง',
  Copy: 'คัดลอก',
  ImportOrder: 'นำเข้าข้อมูลการสั่งซื้อ',
  ImportBusinessNo: 'นำเข้าหมายเลขธุรกิจ',
  SelectOrderNumber: 'เลือกหมายเลขการสั่งซื้อ',
  ArrivalTime2: 'วันที่จัดส่งถึงปลายทาง',
  ProjectName: 'ชื่อโครงการ',
  ProjectBatch: 'ล็อตโครงการ',
  CargosExpectedArrivalDateByTrucking: 'วันที่คาดว่าจะมาถึง (จุดบริการลูกค้า)',
  CargosExpectedArrivalDateWarehouseLoading: 'วันที่มาถึงโดยประมาณ (โหลดภายในคลังสินค้า)',
  CargosExpectedArrivalDatePacking: 'วันที่บรรจุโดยประมาณ',
  EstimatedPackTheCabinetTime: 'เวลาติดตั้งโดยประมาณ',
  MaintainJobNoRule: 'โปรดรักษากฎการเข้ารหัสหมายเลขงาน!',
  SelectCodeRule: 'โปรดเลือกกฎการเข้ารหัส',
  CodeRuleDesc: 'คำอธิบายกฎการเข้ารหัส',
  SpecifyAgentNumber: 'ระบุจำนวนตัวแทนจัดส่งสินค้า',
  CustomsClearanceChargeRelatedEdit: 'การยกเลิกค่าธรรมเนียมสามารถทำได้เฉพาะการเปลี่ยนแปลงค่าธรรมเนียมเท่านั้น',
  CustomsClearanceNoChargeNoChange: 'การยกเลิกศุลกากรโดยไม่มีค่าธรรมเนียมไม่สามารถเปลี่ยนแปลงได้ (ค่าธรรมเนียมทั้งหมดจะถูกลบ)',
  ClearFeeNoChargeCustomsClearance: 'การยกเลิกโดยไม่มีค่าธรรมเนียมจะไม่สามารถยกเลิกได้โดยไม่มีค่าใช้จ่ายหากไม่มีการยกเลิกค่าธรรมเนียมที่ได้รับการยืนยัน',
  VotesPreSubmission: 'มีการยื่นตั๋วล่วงหน้าหรือไม่',
  AllNotPositiveOperationStatus: 'การบันทึกข้อมูลที่เลือกไม่ใช่สถานะ 【การทำงานในเชิงบวก】 ทั้งหมด',
  AllNotToVerifyStatus: 'การบันทึกข้อมูลที่เลือกไม่ใช่สถานะ 【เพื่อตรวจสอบ】 ทั้งหมด',
  ContainerLoadTypeNotCorrect: 'ประเภทของธุรกิจตั๋วนี้ไม่ใช่ LCL ด้วยตนเอง buyer consol、 LCL ที่ได้รับมอบหมาย',
  RecordNotPositiveOperationStatus: 'ธุรกิจตั๋วนี้ไม่ใช่สถานะ "ปฏิบัติการในเชิงบวก"',
  RailwayCheckLob: 'Job เลือกประเภทธุรกิจที่แตกต่างกัน กรุณาเลือกประเภทธุรกิจเดียวกันเพื่อลองใหม่อีกครั้ง',
  TheTicketIsMain: 'ธุรกิจตั๋ว ตั๋วหลัก',
  TheTicketAssociatedMain: 'ธุรกิจตั๋ว ตั๋วหลักที่เกี่ยวข้อง',
  TheTicketAssociatedContainerInfo: 'ธุรกิจตั๋วนี้เชื่อมโยงข้อมูลการบรรจุกล่อง',
  ContainerLoadTypeIs: 'ประเภทการสะกดทั้งหมดเป็น',
  NoneModified: 'ไม่จำเป็นต้องปรับเปลี่ยน',
  ContainerLoadTypeBatchModifySuccess: 'ชุดแก้ไขประเภทการสะกดสำเร็จ:',
  NoDataProcessed: 'ไม่มีข้อมูลที่ถูกประมวลผล',
  CustomsInformation: 'ข้อมูลการประกาศศุลกากร',
  AddFile: 'เพิ่มไฟล์',
  CustomsReceiptFile: 'เอกสารผลตอบแทนศุลกากร',
  CustomsReceiptState: 'สถานะการส่งกลับศุลกากร',
  CloneCabinBerth: 'คัดลอกห้องโดยสาร',
  BackFillCabinBerth: 'ห้องโดยสาร Backfill',
  GenerateBusiness: 'สร้างธุรกิจ',
  ReturnCabin: 'กลับห้องโดยสาร',
  CheckBeforeEntrust: '{0} ที่คุณได้มอบหมายไม่มีการบำรุงรักษาข้อมูลที่เกี่ยวข้องเช่นรหัส SCAC ของ {1} โปรดตรวจสอบกับอีกฝ่ายก่อนที่จะมอบหมาย!',
  CheckPortBeforeEntrust: '【{0}】 ที่คุณได้รับมอบหมายไม่มีการบำรุงรักษาพอร์ต 【{0}】 โปรดตรวจสอบกับแต่ละอื่น ๆ ก่อนที่จะมอบหมาย!',
  CheckPackBeforeEntrust: '【{0}】 ที่คุณได้รับมอบหมายไม่มีการบำรุงรักษา 【{0}】 แพคเกจโปรดตรวจสอบกับแต่ละอื่น ๆ ก่อนที่จะมอบหมาย!',
  PortDataPushLog: 'บันทึกการผลักดันข้อมูลของเขตท่าเรือ',
  EdiStatusChangeLog: 'บันทึกการเปลี่ยนแปลงสถานะ EDI',
  BookingReceiptLog: 'บันทึกการดำเนินการสำรองห้องพัก',
  MergeAndSingle: 'และโสด',
  OuJianDeclaration: 'ประกาศศุลกากร Oujian',
  AirportPort: 'ท่าอากาศยานสุวรรณภูมิ',
  Airport: 'สนามบิน',
  GoodsStoragePlace: 'สถานที่จัดเก็บสินค้า',
  ExchangeServiceAi: 'หากต้องการใช้บริการถอนเงินผ่านตัวแทนศุลกากร',
  DataPushChangeLog: 'ข้อมูลการบันทึกการเปลี่ยนแปลง Push',
  SendBookingData: 'ส่งข้อมูลการจองห้องพัก',
  SelectAction: 'เลือกการดำเนินการ',
  IsGroupBranch: 'ไม่ว่าจะเป็นสาขาของกลุ่ม',
  SmtpServerError: 'ข้อผิดพลาดของเซิร์ฟเวอร์ SMTP',
  NotConnectSmtpServer: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ SMTP ได้',
  NotFindFile: 'ระบบไม่พบแฟ้มที่ระบุ',
  SendFileError: 'เกิดข้อผิดพลาดในการส่งไฟล์',
  AttachTemplateError: 'แม่แบบอุปกรณ์เสริมผิดพลาด',
  MailSentSuccess: 'ส่งข้อความสำเร็จ',
  PleaseSelectAction: 'โปรดเลือกการดำเนินการ',
  PleaseSelectCategory: 'กรุณาเลือกหมวดหมู่สินค้า',
  PleaseSelectOpDep: 'โปรดเลือกฝ่ายปฏิบัติการ',
  SeaExportLetter: 'หนังสือมอบอำนาจการขนส่งสินค้าทางทะเลเพื่อการส่งออก',
  DataPush: 'การผลักดันข้อมูล',
  MasterTicketSync: 'ซิงค์ตั๋วหลัก',
  BookingDataSentSuccess: 'ส่งข้อมูลการจองเรียบร้อยแล้ว',
  CostSettlementObjectBlocked: 'วัตถุการตั้งถิ่นฐานของค่าธรรมเนียม [{0}] ถูกบล็อกอาจมีความเสี่ยง คุณจะยังคงบันทึกต่อไปหรือไม่?',
  ConsigneeRequired: 'โปรดป้อนอินเทอร์เฟซ HB / L เพื่อรับและส่งข้อความ!',
  OverseaCustomerUpdate: 'ฝ่ายบริการลูกค้าต่างประเทศเดิม [{0}] หมดอายุและไม่ว่าจะเป็นฝ่ายบริการลูกค้าต่างประเทศใหม่ [{0}]',
  ConatainerNoRemoveRelation: 'ข้อมูลที่มีหมายเลขกล่อง {0} จะถูกลบออกจากสมาคมทั้งหมด จำเป็นต้องดำเนินการต่อไป',
  EDIBooking: 'EDI จองห้อง',
  EDIContainers: 'ข้อมูลการบรรจุ EDI',
  ContainersLog: 'ข้อมูลการบรรจุหีบห่อ บันทึกการตอบกลับ',
  PleaseSelect2: 'โปรดเลือกธุรกิจที่คุณต้องการส่ง!',
  MingShen: 'การทำมาหากินของประชาชน',
  MingShenCompany: 'บริษัท มินเซิง อินเตอร์เนชั่นแนล ชิปปิ้ง เอเจนซี่ จำกัด',
  EDIDoc: 'บ./ตร. EDI',
  RoundPaymentAmountExchangeRate: 'ROUND (จำนวนเงินที่ต้องชำระ * อัตราแลกเปลี่ยนที่ต้องชำระ)',
  VGMIsEmpty: 'VGM ว่างเปล่า!',
  VGMRaw: 'VGM ต้นฉบับ',
  VGMCorrection: 'การแก้ไข VGM',
  FileOnlyXlsXlsx: 'ไฟล์ที่อัปโหลดสามารถเป็นรูปแบบ xls, xlsx เท่านั้น!',
  FileOnlyXlsx: 'ไฟล์ที่อัปโหลดต้องเป็นรูปแบบ xlsx เท่านั้น!',
  stayTuned: 'โปรดติดตาม',
  UploadImageFormatWrong: 'รูปภาพที่อัปโหลดไม่ถูกต้องและรูปแบบภาพที่เราสนับสนุนในขั้นตอนนี้คือ: PNG、JPG、JPEG， กรุณาแปลงรหัสหรือเปลี่ยนรูปภาพ',
  ItIsEmpty: 'ว่างเปล่า',
  AdvancePayment_ActualAmount_HandlingCharge_PostTelecommunicationCharge_AcceptanceHandlingCharge: 'การชำระเงินล่วงหน้า (RMB) - จำนวนเงินที่จ่ายจริง (RMB) - ค่าธรรมเนียมการจัดการ (RMB) - ค่าไปรษณีย์และโทรเลข (RMB) - ค่าธรรมเนียมการรับรอง (RMB)',
  RelatedBusinessNoSpecial: 'ไม่มีข้อมูลเกี่ยวกับสินค้าพิเศษชั่วคราวสำหรับธุรกิจที่เกี่ยวข้อง',
  ReceiptImportFailed: 'ล้มเหลวในการนำเข้าใบแจ้งหนี้!',
  ReceiptImportedSuccessfully: 'นำเข้าใบส่งคืนเรียบร้อยแล้ว!',
  ReceiptImport: 'การนำเข้า Return',
  CopyLinkPublic: 'คัดลอกลิงค์ (สาธารณะ)',
  CopyLinkPromissoryNote: 'คัดลอกลิงค์ (แคชเชียร์เช็ค)',
  RepeatBoxType: 'มีบันทึกประเภทกล่องชนิดเดียวกันสองรายการ',
  RepeatUldType: 'มีการบันทึกรหัสคอนเทนเนอร์เดียวกันอยู่แล้ว!',
  RealDepartureTime: 'เวลาออกทะเลจริง',
  RealDeparture: 'การจอดเรือที่แท้จริง',
  ActualBerthingTime: 'เวลาเทียบท่าจริง',
  ImportFailedContactAdministrator: 'การนำเข้าล้มเหลว โปรดติดต่อผู้ดูแลระบบ',
  ContractPeriod: 'พันธมิตร: $ {0} มีสัญญาภายในระยะเวลาที่ถูกต้องโปรดไปที่ 【การจัดการสัญญา】 เพื่อปรับบัญชีเครดิตที่สอดคล้องกัน',
  HasBeenSelected: 'ได้รับการคัดเลือกแล้ว',
  HasExceeded: 'เกินแล้ว!',
  HasExceededCannotEDI: 'เกินแล้ว อีดีไอไม่ได้',
  UnloadingPortNotMaintain: 'ปัจจุบัน"หน่วยงานหลัก"ของ"ท่าเรือขนถ่ายสินค้า"ตัวแทนที่เกี่ยวข้องไม่ได้รับการบำรุงรักษา ตัวแทนการขนส่งที่ระบุและข้อมูลการขายจะถูกเลือกไว้ว่างเปล่าหรือไม่?',
  EnYuanHuaXiaKu: 'อึนวอน',
  EnyuanYangyuanKu: 'สวนยาง Enwara',
  EnyuanGaoxiangku: 'อุนวาระ',
  NotInsuranceOperationPermission: 'คุณไม่มีสิทธิ์ [ประกัน] ในการดำเนินงาน!',
  CorrectionBillOfLading: 'การแก้ไข BL',
  ConfirmationBillOfLading: 'การยืนยัน B / L',
  Tips: 'เคล็ดลับ!',
  PickUpTypeDifferentSmallTicket: 'ประเภทของการรับสินค้าไม่เหมือนกับบัตรใบเล็ก,ยืนยันต้องการเซฟหรือไม่?',
  OperationDepartmentCannotBeEmpty: 'ฝ่ายปฏิบัติการจะว่างเปล่าไม่ได้',
  FileContentIsEmpty: 'เนื้อหาของแฟ้มว่างเปล่า',
  FileContentWrong: 'เนื้อหาแฟ้มผิดพลาด',
  FileSizeCannotLargerThan2MB: 'ขนาดไฟล์ต้องไม่เกิน 2MB',
  NoData: 'ไม่มีข้อมูล',
  NoBusinessSelected: 'ธุรกิจไม่ได้เลือก',
  OriginalNormal: 'ต้นฉบับ',
  NoImportEDI: 'ไม่มี EDI ที่สามารถนำได้ในซิงเกิลนี้',
  PackingDataNotCconsistent: 'ข้อมูลการบรรจุหีบห่อนี้ไม่ตรงกับข้อมูลจริงโปรดตรวจสอบข้อมูลการบรรจุหีบห่อ!',
  CreditControlTheClient: 'ความน่าเชื่อถือของหน่วยงานที่ได้รับมอบหมายจากตั๋วนี้',
  SaveBusinessBeforeEnterMultiGate: 'หมายเหตุ: ป้อนหลายจุดโปรดบันทึกธุรกิจก่อน',
  SaveBusinessBeforeEnterMultiGate2: 'หมายเหตุ: ป้อนหลายจุดหรือหลายตู้โปรดบันทึกธุรกิจก่อน',
  BookingWorkspace_PrePlan_ImportExcel: 'การจัดส่งสินค้าทางทะเลรุ่น Extreme - ข้อมูลล่วงหน้า - นำเข้า Excel',
  SpecialCargoNumber: 'หมายเลขสินค้าพิเศษ',
  RelevantTicketsResetAndUpdated: 'บัตรขนาดเล็กที่เกี่ยวข้องจะถูกรีเซ็ตและอัปเดตหลังจากการยืนยัน จะซิงค์หรือไม่?',
  ManifestConfirmed: 'ยืนยันรายการแล้ว',
  ManifestDataIsEmpty: 'ข้อมูลรายการสินค้าว่างเปล่า!',
  ManifestConfirmationFailed: 'ยืนยันรายการสินค้าล้มเหลว!',
  NodeTriggerFailed: 'ล้มเหลวในการเรียกใช้โหนด!',
  LoadingOfPackingInformationFailed: 'การโหลดข้อมูลบรรจุกล่องล้มเหลว',
  PlanDepartureTime: 'กำหนดเวลาเดินเรือ',
  PlannedBerthingTime: 'วางแผนเวลาเทียบท่า',
  OriginalPlanDepartureTime: 'เวลาออกจากท่าตามแผนเดิม',
  OriginalPlannedBerthingTime: 'เวลาเข้าท่าตามแผนเดิม',
  NowPlanDepartureTime: 'เวลาออกจากท่าตามแผนปัจจุบัน',
  NowPlannedBerthingTime: 'เวลาเข้าท่าตามแผนปัจจุบัน',
  CurrentETA: 'กำหนดเวลาปัจจุบันไปฮ่องกง',
  OriginalETA: 'ตารางเวลาเดิมถึงท่าเรือ',
  CurrentETA1: 'กำหนดเวลาปัจจุบันไปฮ่องกง (Current ETA)',
  OriginalETA1: 'ตารางเวลาเดิมถึงท่าเรือ (Original ETA)',
  ShippingScheduleNew: 'เทมเพลตการนำเข้าเรือ (เวอร์ชันใหม่)',
  ShippingScheduleold: 'เทมเพลตการนําเข้าการจัดส่ง(รุ่นเก่า)',
  ImportNew: 'นำเข้า (เวอร์ชั่นใหม่)',
  ImportOld: 'นำเข้า (รุ่นเก่า)',
  PlannedBerthing: 'วางแผนจอดเทียบท่า',
  PlanDeparture: 'วางแผนการเดินทาง',
  BookingEDI: 'จองห้องพัก EDI',
  BookingCorrection: 'การแก้ไขการจองห้องพัก',
  PortMaintainedDesignatedFreightForwarder: 'พอร์ตมีการรักษาตัวแทนสินค้าที่ได้รับการแต่งตั้งที่สอดคล้องกันจะใช้ตัวแทนสินค้าที่ได้รับการแต่งตั้งการบำรุงรักษาพอร์ตนี้หรือไม่?',
  MBLStatusNotIsUnStart: 'ตั๋ว MBL สำหรับสถานะเดียวไม่ได้เริ่มต้นและไม่สามารถนำเข้าได้',
  PrimaryOrderNotSameReceipt: 'หมายเลขเจ้าของธุรกิจตั๋วไม่ตรงกับหมายเลขเจ้าของตั๋ว และจะมีการนำเข้าต่อหรือไม่',
  RequestSuccessful: 'ขอความสำเร็จ!',
  SpecialCharacters: 'มีอักขระพิเศษไม่สามารถเริ่มการสมัครรับข้อมูลในเขตท่าเรือหรือ บริษัท เรือ',
  EnterReleaseNumber: 'กรุณาใส่หมายเลขใส่',
  SelectAPieceOfData: 'กรุณาเลือกข้อมูล!',
  SelectARecord: 'กรุณาเลือกบันทึก!',
  ChooseDesignatedAgent: 'กรุณาเลือกตัวแทนจัดส่งสินค้าที่ระบุ!',
  ChooseSpecialGoods: 'กรุณาเลือกสินค้าพิเศษ!',
  CargoInformationIsEmpty: 'ข้อมูลสินค้าว่างเปล่า',

  InviteSupplementaryLinksPublic: 'ลิงก์เสริมเชิญ (สาธารณะ)',
  InviteSupplementaryLinkPromissoryNote: 'คำเชิญ ลิงค์เสริม (แคชเชียร์เช็ค)',
  DownloadCWTemplate: 'ดาวน์โหลด CargoWare Stencil',
  DownloadCWTemplateJC: 'ดาวน์โหลด CargoWare Stencil (Kimchang)',
  DownloadSeaHouseTemplate: 'ดาวน์โหลดแม่แบบ Sea Butler',
  DownloadWseTemplate: 'ดาวน์โหลดแม่แบบ CargoWare (ชิงเต่า)',
  DownloadWseTemplateSh: 'ดาวน์โหลดแม่แบบ CargoWare (เซี่ยงไฮ้)',
  DownloadWseTemplateVgm: 'ดาวน์โหลดแม่แบบ Wash',
  SendingChannelVgm: 'ช่องทางการส่ง',
  MailSendingFailed: 'การส่งจดหมายล้มเหลว!',
  DistributionFailed: 'การจัดส่งสินค้าล้มเหลว',
  SalesAndOperationAreSame: 'ขายและดำเนินการเหมือนกัน,ยืนยันอยากประหยัด?',
  PreConfiguredManifestAPI: 'เตรียม Manifold API',
  PreConfiguredManifestDeletion: 'การลบรายการสินค้าล่วงหน้า',
  PreConfiguredManifestIsEmpty: 'วัตถุลบรายการสินค้าล่วงหน้าว่างเปล่าโปรดลองอีกครั้งหลังจากรีเฟรชหน้า',
  CorrectionOfPreAllocatedManifest: 'การแก้ไขรายการสินค้าคงคลังล่วงหน้า',
  OperationFailed: 'ปฏิบัติการล้มเหลว!',
  RedOffsetCannotModified: 'ค่าช่องแดง หรือโดนค่าช่องแดงไม่สามารถแก้ไขได้อีกขอให้เลือกเพิ่มการปรับ',
  RedOffsetCannotDeleted: 'ค่าธรรมเนียมช่องแดง หรือถูกค่าธรรมเนียมช่องแดงไม่สามารถลบออกได้โปรดเลือกใหม่',
  MaintainNodeDetailCode: 'โปรดรักษารหัสรายละเอียดโหนด',
  DeleteNumRecord: 'แน่ใจนะว่าคุณต้องการลบระเบียน {0} นี้?',
  DeleteNumFile: 'แน่ใจหรือว่าคุณต้องการลบไฟล์ {0} เป็นชุด?',
  ClickYesRetrievedToReturnedStatus: 'เมื่อคลิก "ใช่" จะข้ามไปยังหน้าการพิมพ์และเอกสารที่ "ได้รับคืน" จะเปลี่ยนเป็นสถานะ "ได้รับคืน"',
  ClickYesToReturnedStatus: 'เมื่อคลิก "ใช่" จะข้ามไปยังหน้าพิมพ์และแก้ไขสถานะเอกสารเป็น "คืนเงิน"',
  FileNotAllowedView: '{0} ไฟล์ไม่อนุญาตให้ใครดูหรือดาวน์โหลด',
  NoPermissionToView: 'คุณไม่มีสิทธิ์ดูหรือดาวน์โหลดไฟล์ [{0}]',
  UploadFailed: 'อัปโหลดล้มเหลว!',
  UploadSuccess: 'อัปโหลดสำเร็จ!',
  UploadSuccessNoOrder: 'อัปโหลดสำเร็จไม่พบคำสั่งซื้อที่เกี่ยวข้อง!',
  UploadedFileNotMatch: 'ประเภทของไฟล์ที่อัปโหลดไม่ตรงกันโปรดตรวจสอบ!',
  UploadType: 'ประเภทการอัปโหลด',
  FileSource: 'แหล่งที่มาของไฟล์',
  ReceiptType: 'ประเภทการตอบกลับ',
  SendAisle: 'ช่อง EDI',
  BusinessNotSubmitted: 'ธุรกิจไม่ยื่นและไม่สามารถคืนเงินได้',
  BusinessNotBeenApproved: 'ธุรกิจยังไม่ได้รับการทบทวน,ยืนยันจะคืน?',
  NoPermissionToViewOrprinted: 'คุณไม่มีสิทธิ์ดูไฟล์ที่อัปโหลดหรือพิมพ์โดยคนอื่น',
  DocumentDelivery: 'ส่งเอกสาร',
  SameStatusCanBePrinted: 'สามารถพิมพ์เอกสารที่มีสถานะเดียวกันเท่านั้น!',
  ReceiptContent: 'เนื้อหาการตอบกลับ',
  ReceiptTime: 'เวลาตอบกลับ',
  PrintCommonControls: 'พิมพ์การควบคุมสาธารณะ',
  CustomsBrokerOthers: 'ตัวแทนออกของ / อื่นๆ',
  ReceiveReceiptTime: 'เวลารับกลับ',
  ReceivingAddress: 'ที่อยู่ผู้รับ',
  bookingParty: 'หน่วยการจองห้องพัก',
  BusinessIsLocked: 'ธุรกิจถูกล็อคและไม่สามารถคืนเงินได้',
  ConfirmUploadFileType: 'กรุณายืนยันประเภทไฟล์ที่อัปโหลด คุณต้องการอัปโหลดต่อหรือไม่?',
  InputCustomerName: 'กรุณาใส่ชื่อลูกค้า!',
  InputExpressNumber: 'กรุณากรอกหมายเลขพัสดุ!',
  InputExpressAddress: 'กรุณาป้อนที่อยู่จัดส่ง!',
  InputRecipient: 'โปรดป้อนผู้รับ!',
  InputRecipientName: 'โปรดป้อนชื่อผู้รับ!',
  InputReceivingcompany: 'โปรดป้อนหน่วยรับ!',
  InputReceivingAddress: 'กรุณาป้อนที่อยู่ผู้รับ!',
  InputContactNumber: 'กรุณากรอกเบอร์ติดต่อ!',
  InputContactNumberMark: 'กรุณากรอกเบอร์ติดต่อ!',
  InputReturnExpressNumber: 'กรุณากรอกหมายเลขการจัดส่งคืน!',
  ReturnInformation: 'กลับข้อมูล',
  ReturnDateGreaterThanRetrieveDate: 'วันที่ส่งคืนต้องมากกว่าวันที่รับคืน!',
  DateModified: 'อัปเดตเวลา',
  OperationCannotBeEmpty: 'การดำเนินการต้องไม่ว่างเปล่า',
  OperationCompanyCannotBeEmpty: 'บริษัทที่ดำเนินการไม่สามารถว่างได้',
  BookingAudit: 'รีวิวการจองห้องพัก',
  UseThisNo: 'ใช้หมายเลขนี้',
  WarehousingFee: 'ค่าธรรมเนียมคลังสินค้า',
  BookingSuccess: 'ความสำเร็จในการจองห้องพัก',
  ToBeConfirmed: 'การจองห้องพักเพื่อยืนยัน',
  BookingFail: 'การจองห้องพักล้มเหลว',
  CabinState: 'สถานะห้องโดยสาร',
  CostGenerationMethod: 'วิธีการสร้างค่าธรรมเนียม',
  SettlementInPriginalCurrency: 'ชำระหนี้ตามสกุลเงินเดิม',
  SettlementInBillCurrency: 'การชำระเงินตามสกุลเงินบิล',
  ShowDetails: 'แสดงรายละเอียด',
  ImportResultLog: 'นำเข้าบันทึกผลลัพธ์',
  ImportComplete: 'การนำเข้าเสร็จสมบูรณ์',
  SuccessItemFailedItem: 'แถบสำเร็จ 【{0}】 แถบล้มเหลว 【{0}】',
  ContinueImporting: 'ดำเนินการนำเข้า',
  DownloadResultLog: 'ดาวน์โหลดบันทึกผลลัพธ์',
  PONo: 'หมายเลข PO',
  VoyageOnlyNum: 'เที่ยวบินสามารถป้อนตัวเลขหรือตัวอักษรเท่านั้น',
  UpdateSuccess: 'การเปลี่ยนแปลงสำเร็จ',
  ShippingSpace: 'ห้องโดยสาร',
  RejectTips: 'ยืนยันคุณต้องการปฏิเสธ {0} ผ่านการตรวจสอบหรือไม่? โปรดป้อนเหตุผลในการปฏิเสธ:',
  GenerateBusinessTips: 'ยืนยันการสร้างธุรกิจหรือไม่? (ไม่สามารถเพิกถอนได้หลังจากสร้าง)',
  ReturnedShipping: 'ยืนยันการเดินทางกลับหรือไม่ (ไม่สามารถเพิกถอนได้หลังจากบันทึกการเดินทางกลับ)',
  ReturnedShippingSuccess: 'การคืนยานประสบความสำเร็จ',
  ShippingCompanyAndBookingAgent: 'โปรดป้อน บริษัท เรือและตัวแทนจองที่สอดคล้องกัน',
  CabinCopySuccess: 'การจำลองห้องโดยสารประสบความสำเร็จด้วยหมายเลขธุรกิจใหม่:',
  CheckShippingCompanyAndBookingAgent: 'บริษัท เรือและตัวแทนจองไม่สามารถกรอกได้เพียงรายการเดียว',
  ReviewRejectedSuccess: 'ตรวจสอบปฏิเสธความสำเร็จ',
  ReviewSuccess: 'ตรวจสอบความสำเร็จ',
  BatchReviewSuccess: 'ตรวจสอบความสำเร็จของแบทช์',
  CheckBatchReview: 'ธุรกิจตรวจสอบแบทช์ต้องไม่เกิน 50 รายการ!',
  RefuseSuccess: 'ปฏิเสธความสำเร็จ',
  BatchAuditSuccess: 'การตรวจสอบจำนวนมากประสบความสำเร็จ',
  AuditSuccess: 'การตรวจสอบสำเร็จ',
  CheckCreditTipOne: 'หน่วยงานหลักของธุรกิจต่อไปนี้อยู่เหนือการควบคุมและไม่สามารถตรวจสอบได้ ผ่าน',
  CheckCreditTipTwo: 'หน่วยต้นสังกัดของกิจการต่อไปนั้นอยู่นอกเหนือความไว้วางใจ,ยืนยันจะตรวจสอบให้ผ่าน?',
  BatchAuditBusinessTip: 'ธุรกิจการตรวจสอบจำนวนมากต้องไม่เกิน 50 รายการ!',
  CheckCreditSaveTip: 'แคชเชียร์เช็คถูกล็อคเนื่องจากไม่มีการควบคุมเครดิตและไม่สามารถพิมพ์หรือ EDI ได้ โปรดติดต่อผู้บังคับบัญชาเพื่อปลดล็อคเมื่อจำเป็น!',
  CabinCopy: 'คัดลอกห้องโดยสาร',
  EnterShippingCompany: 'โปรดป้อน บริษัท เรือใน 【ห้องโดยสาร {0}】',
  EnterBookingAgent: 'โปรดป้อนตัวแทนการจองใน 【ห้องโดยสาร {0}】',
  EnterEtd: 'กรุณาใส่วันที่ออกเดินทางใน 【ห้องโดยสาร {0}】',
  CheckEnterShippingCompanyBookingAgentEtd: 'โปรดป้อน บริษัท เรือที่สอดคล้องกับห้องโดยสารตัวแทนจองวันที่ออกเดินทาง',
  UnreviewedBusinessNumber: 'ยังไม่ได้ตรวจสอบ Business Number: {0}',
  UnreviewedBusinessNumber2: 'หมายเลขมอบอำนาจที่ยังไม่ได้ตรวจสอบ',
  DateOfCreation2: 'สร้างเวลา',
  plateNumberAndMblCannotBeEmpty: 'หมายเลขทะเบียนรถ และหมายเลข B / L ไม่สามารถเว้นว่างได้',
  ActualDateOfDeparture: 'วันที่ออกเดินทางจริง',
  ActualDateOfDeparture2: 'วันที่ออกเดินทางจริง (ATD)',
  nameOfVesselCannotBeEmpty: 'ชื่อเรือจะว่างเปล่าไม่ได้',
  voyageNumberCannotBeEmpty: 'เที่ยวบินไม่สามารถว่างเปล่าได้',
  shippingCompanyCannotBeEmpty: 'บริษัทเรือจะว่างเปล่าไม่ได้',
  MasterShippingCompanyCannotBeEmpty: 'ต้องระบุบริษัทเรือหลัก',
  hasBeanSend: 'ส่งแล้ว',
  notSend: 'ยังไม่ได้ส่ง',
  UpdateTime: 'อัปเดตเวลา',
  CategoryOfGoods: 'หมวดหมู่สินค้า',
  ShipperLine1: 'บรรทัดแรกของผู้ส่ง',
  ConsigneeLine1: 'บรรทัดแรกของผู้รับ',
  NotifyPartyLine1: 'บรรทัดแรกของผู้แจ้ง',
  CargoDocShipperLine1: 'บรรทัดแรกของผู้ส่ง B / L',
  CargoDocConsigneeLine1: 'บรรทัดแรกของผู้รับ B / L',
  CargoDocShipper: 'ใบตราส่งสินค้า',
  CargoDocConsignee: 'ผู้รับ B / L',
  CargoDocNotify: 'ใบตราส่งสินค้า',
  CargoDocNotifyPartyLine1: 'บรรทัดแรกของผู้แจ้ง B / L',
  MBLBillOfLadingNum: 'หลักน้ำเดี่ยว',
  HBLBillOfLadingNum: 'แยกเดี่ยวน้ำ',
  RegularBusiness: 'ธุรกิจทั่วไป',
  InputDate2: 'วันที่เข้า',
  ExpectedArrivalDate: 'วันที่คาดว่าจะมาถึง',
  PleaseChooseEtdStartDate: 'โปรดเลือกวันที่เริ่ม ETD',
  PleaseChooseEtdEndDate: 'โปรดเลือกวันที่สิ้นสุด ETD',
  VOYAGE_NUMBER_ALERT: 'กรุณากรอกหมายเลขเที่ยวบิน',
  voyageNumberRepeat: 'เที่ยวบินไม่สามารถทําซ้ําได้',
  DirectOrderOrNot: 'ไม่ว่าจะเป็นเดี่ยวตรง',
  EDICode: 'รหัส EDI',
  MSCVesselImport: 'นำเข้า MSC',
  MSCEDIExport: 'MSC Vessel CODE',
  pleaseDelEmptyCarrierRecord: 'บันทึกของบริษัทเรือจะว่างเปล่าไม่ได้',
  CannotBeTheSame: 'สายเรือร่วมต้องไม่ซ้ำกับสายเรือหลัก',
  PortNotNull: 'พบข้อมูลท่าเรือว่าง ทุกท่าเรือในทุกเที่ยวห้ามเว้นว่าง',
  PortDuplication: 'ห้ามซ้ำท่าเรือ',
  EtdAndEtaNotNull: 'Original ETA และ Original ETD ต้องไม่ว่างเปล่าทั้งคู่',
  shipNameCannotBeEmpty: 'ชื่อภาษาจีนหรือชื่อภาษาอังกฤษของชื่อเรือไม่สามารถเว้นว่างได้',
  EnglishShipNameCannotBeEmpty: 'ชื่อเรือภาษาอังกฤษไม่สามารถว่างเปล่าได้',
  alreadyExistsShipNameAndContinueToSave: 'มีชื่อภาษาจีน หรือชื่ออังกฤษที่มีชื่อเรือเดียวกันอยู่แล้ว จะเก็บต่อหรือไม่',
  ExportAllToExcel: 'ส่งออกทั้งหมด Excel',
  FlightAndTime: 'เที่ยวบิน/เที่ยว',
  exportThisPageEdi: 'ส่งออก EDI ของหน้านี้',
  ExportAgentList: 'ส่งออกรายการพร็อกซี่',
  ContinueToExport: 'ดำเนินการส่งออกต่อไป',
  OnlyMainTicketAndFCLServicesCanBeExported: 'เฉพาะบัตรหลักและธุรกิจ FCL เท่านั้นที่สามารถส่งออกได้ ธุรกิจที่คุณติ๊กไม่สามารถส่งออกได้',
  IgnoresNonExportableServices: 'เฉพาะตั๋วหลักและระบบ FCL Business Exportable System จะละเลยธุรกิจที่ไม่สามารถส่งออกได้โดยอัตโนมัติหรือไม่',
  ExportSuccess: 'ส่งออกสำเร็จ',
  voyageShippingCompanyCanNotNull: 'บริษัท เรือที่เดินทางไม่สามารถว่างเปล่าได้',
  PleaseSelectShippingName: 'กรุณาเลือกชื่อเรือ',
  DownloadTemplate: 'ดาวน์โหลดแม่แบบ',
  BLForm: 'แบบฟอร์ม B / L',
  FreeDetention: 'ระยะเวลาการเช่าตู้ฟรี',
  FreeDemurrage: 'จำนวนวันที่กองฟรี',
  CustomsAreaApplication: 'การสมัครเข้าเขตกว๊าน',
  SettlementCompanyNotEmpty: 'แผนก Settlement Department จะว่างเปล่าไม่ได้!',
  StartMbl: 'คำนำหน้าหมายเลขเดี่ยว',
  EndMbl: 'สิ้นสุดหมายเลขหลัก',
  BillOfLading: 'หมายเลขใบรับสินค้า',
  CartonQuantityCannotBeZero: 'ปริมาณกล่องไม่สามารถว่างเปล่า!',
  DistributionNo: 'หมายเลขโทรย่อย',
  DistributionWarehouse: 'คลังสินค้าย่อย',
  PreDateOfCustomsDeclaration: 'คาดการณ์วันที่ปิด',
  sendFailed: 'ส่งล้มเหลว',
  SelfDeclaration: 'ประกาศศุลกากรด้วยตนเอง',
  FilingType: 'ประเภทการประกาศ',
  emailAccount: 'บัญชีประกาศ',
  secondGeneration: 'หมายเหตุ ร2: กรอก CRN แคนาดา',
  CanadianCustomsRecordNumber: 'หมายเลขบันทึกศุลกากรแคนาดา',
  ExchangeService: 'ต้องการบริการแลกเปลี่ยนสินค้าผ่านนายหน้าศุลกากรหรือไม่',
  SpecialRelationshipOfBuyer: 'ไม่ว่าจะเป็นความสัมพันธ์พิเศษระหว่างผู้ซื้อและผู้ขาย',
  IncludeRoyalty: 'ไม่ว่าจะมีส่วนผสมของค่าสัมปทาน',
  AffectPrice: 'ไม่ว่าจะเป็นผลกระทบต่อราคา',
  WoodPacking: 'ไม่ว่าจะเป็นบรรจุภัณฑ์ไม้',
  Combination: 'คอมโบ',
  Split: 'แยก',
  FinalStepSync: 'ซิงค์เส้นทางสุดท้าย',
  FinalStepSyncBtn: 'ซิงค์เส้นทางสุดท้าย',
  Synced: 'ซิงค์แล้ว',
  NotSynced: 'ยังไม่ซิงค์',
  PleaseSelectSyncOrder: 'กรุณาเลือกคำสั่งที่ต้องการซิงค์',
  PleaseFillLastMilePlanner: 'กรุณากรอกผู้นำธุรกิจการจัดส่งระยะสุดท้าย',
  PleaseSelectNotSyncedOrder: 'กรุณาเลือกคำสั่งที่ยังไม่ได้ซิงค์',
  CombinationJob: 'ธุรกิจรวม',
  ReceivableChargeLockedStatus: 'สถานะล็อคค่าธรรมเนียมการรับ',
  PayableChargeLockedStatus: 'สถานะล็อคค่าใช้จ่ายที่ต้องจ่าย',
  NotLocked: 'ไม่ได้ล็อค',
  ChargeLocked: 'ค่าธรรมเนียมที่เรียกเก็บหรือค่าธรรมเนียมเจ้าหนี้ถูกล็อคและไม่สามารถดำเนินการได้!',
  ArChargeLocked: 'ค่าธรรมเนียมที่เรียกเก็บถูกล็อคและไม่สามารถดำเนินการได้!',
  ApChargeLocked: 'ค่าใช้จ่ายถูกล็อคและไม่สามารถดำเนินการได้!',
  LockedStatus: 'สถานะล็อค',
  LockedDate: 'เวลาล็อค',
  LockAr: 'ล็อคการรับเข้า',
  UnLockAr: 'ยกเลิกการล็อคการรับสมัคร',
  LockAp: 'ล็อคเพื่อรับมือ',
  UnLockAp: 'ยกเลิกการล็อคเจ้าหนี้',
  importExpenseStatus: 'สถานะค่าธรรมเนียมหลังการนำเข้า',
  accountingDate: 'วันที่ทางการเงินหลังจากการนำเข้า',
  BatchReturnSubmit: 'การถอนเงินจำนวนมาก',
  BatchReturnPreSubmission: 'การส่งคืนแบบกลุ่ม',
  BatchUnlockReceivableExpenses: 'ปลดล็อกค่าธรรมเนียมลูกหนี้เป็นจำนวนมาก',
  BatchUnlockPayableFees: 'การปลดล็อกจำนวนมากต้องชำระค่าธรรมเนียม',
  UnlockApplyBtn: 'ส่งคำขอปลดล็อก',
  UnlockApplyTitle: 'คำขอปลดล็อกค่าธรรมเนียม',
  UnlockApplyJobCount: 'จำนวนงานในคำขอนี้: {0}',
  UnlockApplyCountLimitTip: 'สูงสุด 200 งานต่อคำขอ',
  UnlockApplyReason: 'เหตุผลการปลดล็อก',
  UnlockApplyReasonPlaceholder: 'กรุณากรอกเหตุผลการปลดล็อก',
  UnlockApplyReasonRequired: 'กรุณากรอกเหตุผลการปลดล็อก',
  UnlockApplyReasonOverLength: 'เหตุผลการปลดล็อกต้องไม่เกิน 500 ตัวอักษร',
  DeclaredProfitImpact: 'จำนวนผลกระทบกำไรที่ระบุ',
  UnlockApplyAmountRequired: 'กรุณากรอกจำนวนผลกระทบกำไรที่ระบุ',
  UnlockApplySubmit: 'ส่งคำขอ',
  UnlockApplyPrecheckFailed: 'ตรวจสอบไม่ผ่าน งานต่อไปนี้ไม่สามารถส่งคำขอได้ กรุณาปรับแก้แล้วลองใหม่:',
  UnlockApplyFailureReason: 'สาเหตุที่ล้มเหลว',
  UnlockApplyOnlySeaExport: 'งานส่งออกทางเรือเท่านั้นที่สามารถส่งคำขอได้',
  UnlockApplyOverLimit: 'การดำเนินการครั้งเดียวไม่สามารถเกิน 200 งานได้',
  UnlockApplyChargeNotLocked: 'ค่าใช้จ่ายรับและจ่ายยังไม่ถูกล็อก ไม่จำเป็นต้องยื่นคำขอปลดล็อก',
  UnlockApplyJobNotLocked: 'คำสั่งซื้อปัจจุบันไม่ได้ถูกล็อก ไม่สามารถยื่นคำขอปลดล็อกได้!',
  UnlockApplyJobStateInvalid: 'มีคำสั่งซื้อที่เลือกบางรายการไม่ได้อยู่ในสถานะอนุมัติ กรุณาตรวจสอบ!',
  UnlockApplySubmitted: 'ส่งคำขอแล้ว หมายเลขชุด: {0}',
  UnlockApplyApproving: 'อยู่ระหว่างพิจารณาปลดล็อก',
  UnlockApplyUnlocking: 'กำลังปลดล็อก',
  UnlockApplyUnlockedBanner: 'ค่าใช้จ่ายของงานนี้ถูกปลดล็อกให้แก้ไขได้แล้ว และจะถูกล็อกอัตโนมัติเวลา 01:00 ในอีก 3 วัน',
  BatchLockingReceivableExpenses: 'ค่าธรรมเนียมการล็อคแบทช์',
  BatchLockingPayableFees: 'ล็อคจำนวนมากต้องชำระค่าธรรมเนียม',
  ReplaceSOPTemplatesInBatches: 'เทมเพลต SOP แบบเปลี่ยนแบทช์',
  BatchUpdateScNo: 'จำนวนการแก้ไขโดยประมาณ',
  BatchUpdateScNoSuccess: 'แก้ไขหมายเลขโดยประมาณสำเร็จ: {0}',
  BatchUpdateScNoCheck: 'สามารถเปลี่ยนแปลงรายการปฏิบัติการที่เป็นบวกได้เป็นชุดเท่านั้น',
  BatchReturnSubmitCheck: 'อนุญาตให้ยกเลิกสถานะกิจการได้เฉพาะใบที่ยื่นแล้ว',
  MasterChargeIsShare: 'ไม่ว่าจะเป็นการแบ่งค่าตั๋วหลัก',
  PackageDisplayName: 'ชื่อแสดงบรรจุภัณฑ์',
  ChargeSource: 'แหล่งข้อมูล',
  AddressOfContact: 'ที่อยู่ติดต่อ',
  FinancialExamineDate: 'วันที่สอบทานทางการเงิน',
  ReceiptStatus: 'สถานะการตอบกลับ',
  TransitInformation: 'ข้อมูลการโอน',
  ThreeWay: 'สามการเดินทาง',
  placeOrder: 'สั่งซื้อสินค้า',
  BatchUpdateCustomJobType: 'การปรับเปลี่ยนกลุ่มประเภทธุรกิจที่กำหนดเอง',
  CustomJobTypeBatchModifySuccess: 'การปรับเปลี่ยนกลุ่มธุรกิจที่กำหนดเองประสบความสำเร็จ:',
  BatchManagerSubmission: 'การส่งหัวหน้างานจำนวนมาก',
  BatchManagerSubmissionTips: 'หัวหน้างานสามารถส่งธุรกิจที่มีการดำเนินงานในเชิงบวกและส่งล่วงหน้าเป็นกลุ่มเท่านั้น!',
  BatchManagerSubmissionSuccessfully: 'การส่งผู้บริหารจำนวนมากประสบความสำเร็จ:',
  VotesManagerSubmission: 'ตั๋วให้ผู้บังคับบัญชายื่นหรือไม่',
  CopyMarkFromMergeJob: 'สมัคร-สั่งซื้อ-รับจัดส่ง',
  CopyEnglishDescriptionOfGoodsFromMergeJob: 'ใช้ชื่อภาษาอังกฤษสำหรับการเข้าร่วมและสั่ง',
  SyncToSmallTicket: 'ซิงค์ไปยัง Small Ticket',
  externalBusinessStatus: 'สถานะการสั่งซื้อ', // 爱拼订单状态
  SoNo1: 'S/O No.',
  NaturalPerson: 'บุคคลธรรมดา',
  LegalPerson: 'นิติบุคคล',
  IndividualAssociation: 'สมาคมส่วนบุคคล',
  TelSeparate: 'รหัสพื้นที่ กรุณาใช้' - 'แยกจากกัน',
  EnsNo: 'หมายเลข ENS',
  ShippingCompanyEORI: 'บริษัท เรือ EORI',
  DeclarantEORI: 'แถลงการณ์ EORI',
  Memberstate: 'ประเทศแรกที่เข้าสู่สหภาพยุโรป',
  ENSNumber: 'หมายเลข ENS',
  EnsHsCodeNotMatch: 'หมายเลขซีเรียลของข้อมูลสินค้าไม่ตรงกับข้อมูลกล่อง',
  EnsCorrelativeNoRepeat: 'มีการซ้ำหมายเลขซีเรียลของข้อมูลสินค้า',
  LinkedCargoInformationNoNotNull: 'ข้อมูลบรรจุภัณฑ์ ข้อมูลสินค้าที่เกี่ยวข้อง หมายเลขซีเรียลไม่สามารถว่างเปล่าได้',
  maxLength: 'ความยาวไม่เกิน {0} ตัวอักษร',
  PleaseEnterLength: 'โปรดป้อน {0} ตัวอักษร',
  FreightTermConflict: 'การเลือกที่ขัดแย้งกับการเลือกข้อมูลสถานที่จัดส่งของท่าเรือขนถ่าย',
  FreightTermConflict2: 'การเลือกที่ขัดแย้งกับการเลือกข้อมูลสถานที่รับของที่ท่าเรือของการโหลด',
  NeedPrefix: 'ต้องประกาศด้วยคำนำหน้านำหน้าหมายเลขเดียว: {0}',
  RemoveThePrefix: 'ต้องการลบคำนำหน้า: {0}',
  PhoneTooLong: 'รหัสพื้นที่ต้องไม่เกิน 4 ตัวอักษร, โทรศัพท์ต้องไม่เกิน 20 ตัวอักษร',
  SaveOnly: 'บันทึกเท่านั้น',
  Only6: 'รองรับตัวเลข 6 หลักเท่านั้น',
  ChargesPaymentMethod: 'วิธีการชำระเงินค่าธรรมเนียม',
  CopyConsignor: 'คัดลอกผู้ส่ง',
  CopConsignee: 'คัดลอกผู้รับ',
  BuyerAndSellerInformation: 'ข้อมูลผู้ซื้อและผู้ขาย',
  StreetNumber: 'หมายเลขถนน',
  WaitingForReceipt: 'ส่งล่าสุดสำเร็จและยังไม่ได้รับการตอบกลับ โปรดรอส่งอีกครั้งหลังจากการตอบกลับ',
  DirectlyRepresenting: 'ตัวแทนโดยตรง',
  IndirectRepresentation: 'ตัวแทนทางอ้อม',
  NeedOne: 'เพียงแค่เพิ่มข้อมูล',
  ContainShutOutJob: 'รวมธุรกิจการถอนศุลกากร',
  BatchEditJobNo: 'แก้ไขหมายเลขธุรกิจ',
  IncludingSCFIFreightRate: 'รวมค่าจัดส่ง SCFI',
  SCFIDesignatedBoxType: 'SCFI ระบุประเภทกล่อง',
  JingyiSystemForecast: 'การคาดการณ์ระบบ Jingyi',
  OriginalAHR: 'ต้นฉบับ AHR',
  AddChr: 'เพิ่ม CHR',
  CorrectAFR: 'แก้ไข AFR',
  NonRepeatingNumbers: 'กรุณาใส่หมายเลขที่ไม่ซ้ำกัน',
  AddressFormatting: 'การจัดรูปแบบที่อยู่',
  SendToGoFreight: 'ส่งไปยัง GO FREIGHT',
  ViewSendLog: 'ดูบันทึกการส่ง',
  BookingFreightRate: 'อัตราค่าจัดส่ง',
  SelectedDataDeclaration: 'เลือกการประกาศข้อมูล',
  EmptySubmissionDeclaration: 'ประกาศการยื่นเปล่า',
  SettlementFreightRate: 'ชำระราคาค่าขนส่ง',
  DeclarationRecord: 'บันทึกการประกาศ',
  ImNotHavePermissionDetails: 'ขอโทษนะ! ท่านไม่มีสิทธิ์ดูรายละเอียด',
  ActionOptionsNotCaptured: 'ไม่จับตัวเลือกการดำเนินการ!',
  BatchNotSupportedPleaseAgain: 'ไม่รองรับการส่งเป็นกลุ่มโปรดเลือกใหม่!',
  ItFreightAndRepeatedAllowed: 'ส่งไปยัง GO FREIGHT แล้ว ไม่อนุญาตให้ส่งซ้ำ',
  SentSuccessfully: 'ส่งเรียบร้อยแล้ว',
  CheckTheSendingLog: 'ต้องการดูบันทึกการส่ง',
  OnlyToViewTheSelect: 'เลือกได้เพียงหนึ่งธุรกิจเพื่อดูบันทึกการส่งโปรดเลือกใหม่!',
  ItUpTo50Businesses: 'รองรับได้ถึง 50 ธุรกิจ',
  Business: 'ธุรกิจ:',
  NonIntegralType: 'ประเภทการสะกดแบบไม่สมบูรณ์',
  SendComplete: 'ส่งเสร็จแล้ว',
  PackingList: 'แผ่นความปลอดภัย',
  PleaseContainerBusinessForOperation: 'โปรดเลือกธุรกิจ FCL สำหรับการดำเนินงาน!',
  EmptyInterfaceSendingPleaseWait: 'ในการส่งอินเตอร์เฟสข้อมูลกล่องเปล่าโปรดรอสักครู่ ...',
  VerificationOfDeclarationData: 'การตรวจสอบข้อมูลการประกาศ',
  DataCheckTheDataAgain: 'การตรวจสอบข้อมูลล้มเหลว โปรดลองอีกครั้งหลังจากตรวจสอบข้อมูลแล้ว',
  PleaseWhetherToSubmitThis: 'ขอยืนยันว่าจะยื่นญัตตินี้หรือไม่',
  TicketData: 'ข้อมูลตั๋ว?',
  DataDeclarationSucceeded: 'การรายงานข้อมูลสำเร็จ',
  EmptySubmittedSuccessfully: 'ส่งเอกสารว่างสำเร็จ',
  NotData: 'ไม่มีข้อมูล',
  ThereElectronicPackingListData: 'ไม่มีข้อมูลใบกล่องอิเล็กทรอนิกส์',
  SendFailed: 'ส่งล้มเหลว:',
  Empty: 'ว่างเปล่า',
  PleaseOfDepartureMustPort: 'โปรดยืนยันว่าพอร์ตการจัดส่งต้องเป็นท่าเรือเซี่ยงไฮ้',
  PleaseMustBeTheExchange: 'โปรดยืนยันว่าท่าขนถ่ายสินค้าต้องกำหนดให้เป็นท่าของตลาดหลักทรัพย์',
  PleaseOfGoodsMustGoods: 'ขอยืนยันว่าประเภทสินค้าต้องเป็นสินค้าทั่วไป',
  PleaseOfTheMainCY: 'โปรดยืนยันว่าเงื่อนไขการจัดส่งหลักต้องเป็น "CY-CY"',
  PleaseTradeTermsMustCIF: 'โปรดยืนยันว่าข้อตกลงการค้าต้องเป็น "CIF"',
  PleaseBoxQuantityInformationCorrect: 'ขอยืนยันว่าข้อมูลปริมาณกล่องถูกต้องหรือไม่',
  TheAmountReceivableIncludesUSD: 'โปรดยืนยันค่าธรรมเนียม - การรับเงินประกอบด้วยจำนวนเงิน USD ที่ระบุ',
  NoBillOfLadingInformation: 'ไม่มีข้อมูล BL HBL',
  ResponseDataIsEmpty: 'ข้อมูลที่ตอบสนองว่างเปล่า',
  PleaseToViewTheLog: 'โปรดเลือกธุรกิจที่คุณต้องการดูบันทึกการส่ง!',
  ExportEDI: 'จะส่งออก EDI หรือไม่',
  LandTransportationDetailsEditing: 'แก้ไขรายละเอียดการขนส่งทางบก',
  PreviewOfBookingFileParsing: 'ตัวอย่างการแยกไฟล์การจองห้องพัก',
  GenerateOrder: 'สร้างคำสั่งซื้อ',
  HangInTheAir: 'ยังไม่เสร็จ',
  Completed: 'เสร็จสมบูรณ์',
  Dustbin: 'ถังขยะ',
  PictureLoadingFailed: 'การโหลดรูปภาพล้มเหลว',
  ResolutionCompletionTime: 'เวลาการวิเคราะห์เสร็จสิ้น',
  ViewParsingResults: 'ดูผลการวิเคราะห์',
  ViewOrder: 'ดูคำสั่งซื้อ',
  AreYouWantToDelete: 'ยืนยันจะลบ?',
  BusinessNumber: 'หมายเลขธุรกิจ',
  LCL: 'รวม LCL',
  NearlyAWeek: 'เกือบหนึ่งสัปดาห์',
  NearlyAMonth: 'เกือบเดือน',
  NearlyThreeMonths: 'เกือบสามเดือน',
  DragUploadTheFileIdentified: 'ลากไฟล์มาที่นี่เพื่ออัพโหลดไฟล์ที่ต้องการระบุ',
  SupportUploadFormat: 'รองรับรูปแบบที่อัปโหลด',
  ParsingFailed: 'การวิเคราะห์ล้มเหลว',
  ParsingComplete: 'การวิเคราะห์เสร็จสมบูรณ์',
  OrderGenerated: 'สร้างคำสั่งซื้อ',
  UploadCompletedParsing: 'อัพโหลดเสร็จสมบูรณ์ กำลังวิเคราะห์...',
  Second: 'วินาที',
  ReviewRejectedBusinessNumber: 'ตรวจสอบหมายเลขธุรกิจที่ถูกปฏิเสธ',
  RejectedBusinessNumber: 'หมายเลขธุรกิจที่ถูกปฏิเสธ',
  TheNotExceed5Lines: 'สูงสุดไม่เกิน 5 บรรทัด!',
  Interface: 'อินเตอร์เฟซ',
  Sinotrans: 'การขนส่งระหว่างจีนและต่างประเทศ',
  SinotransEastChinaCoLtd: 'ประเทศจีน Export China Dong Co Ltd',
  NingboEPort: 'ท่าเรืออิเล็กทรอนิกส์ Ningbo',
  SeaHousekeeper: 'แม่บ้านทะเล',
  Wse: 'เวส',
  CargoWare: 'Cargoware ส่ง',
  EDISend: 'ส่ง EDI',
  OtherChannel: 'ช่องทางอื่น ๆ',
  Ningbo99Road: 'Ningbo 99 ถนน',
  DeclarationHistory: 'ประวัติการประกาศ',
  CredentialNumber: 'หมายเลขข้อมูลประจำตัว',
  ResponseCode: 'รหัสตอบกลับ',
  ElectronicBoxListSendingHistory: 'ประวัติการส่งสลิปกล่องอิเล็กทรอนิกส์',
  PrintTime: 'เวลาในการพิมพ์',
  PrintingTimes: 'จำนวนการพิมพ์',
  BookingDataFeedback: 'ข้อเสนอแนะข้อมูลการจอง',
  QuerySendingLog: 'แบบสอบถาม ส่งบันทึก',
  SendDataInformation: 'การส่งข้อมูล',
  ExportAllEDI: 'ส่งออก EDI ทั้งหมด',
  UploadThisPageEDI: 'อัปโหลดหน้านี้ EDI',
  UploadAllEDI: 'อัปโหลด EDI ทั้งหมด',
  EmailUploadEDI: 'อีเมลอัพโหลด EDI',
  IsExportEDI: 'จะส่งออก EDI หรือไม่',
  UploadEDI: 'อัปโหลด EDI หรือไม่?',
  IsUploadAllEDI: 'อัปโหลด EDI ทั้งหมดหรือไม่?',
  MailSending: 'การส่งจดหมาย',
  UploadEDISucceeded: 'อัพโหลด EDI Success',
  FailedToUploadEDI: 'การอัปโหลด EDI ล้มเหลว',
  MultiSegmentNumberRuleConfiguration: 'การกำหนดค่ากฎหมายเลขหลายส่วน',
  StartNumber: 'หมายเลขเริ่มต้น',
  IncrementalRule: 'กฎที่เพิ่มขึ้น',
  DirectExport: 'ส่งออกโดยตรง',
  Plus1: 'บวก 1',
  Plus10: 'บวก 10',
  TheNumberCannotBeEmpty: 'หมายเลขเริ่มต้นไม่สามารถว่างได้',
  IllegalNumberEntry: 'การเข้าหมายเลขไม่ถูกต้องตามกฎหมาย',
  TheMustBeGreaterZero: 'จำนวนสำเนาต้องมากกว่าศูนย์',
  IncrementRuleIsNotSelected: 'กติกาที่เพิ่มขึ้นไม่ได้เลือก',
  PleaseBusinessNumberSearchCriteria: 'กรุณากรอกหมายเลขธุรกิจ เงื่อนไขการค้นหา',
  UploadCompletedProcessing: 'อัปโหลดเสร็จสมบูรณ์ในการประมวลผล',
  SuccessfulProcessing: 'การประมวลผลที่ประสบความสำเร็จ',
  ProcessingFailed: 'การประมวลผลล้มเหลว',
  ExportTime: 'เวลาการส่งออก',
  UnitPriceCannotBe0: 'ราคาต่อหน่วยต้องไม่เป็น 0',
  ExchangeRateCannotBe0: 'อัตราแลกเปลี่ยนไม่สามารถเป็น 0 ได้',
  CustomsNoCannotBeBlank: 'หมายเลขปิดจะว่างเปล่าไม่ได้!',
  ShipperCityCannotBeBlank: 'กรุณาระบุชื่อเมืองของผู้จัดส่ง',
  PrimaryCustomsNo: 'ไม่ว่าจะเป็นหมายเลขด่านหลัก',
  GetPackingInformation: 'รับข้อมูลการบรรจุหีบห่อ',
  GetGoodsInformation: 'รับข้อมูลการขนส่ง',
  GetGoodsInformationTip: 'รับขนาดของบันทึกรายการสินค้าที่เกี่ยวข้องกับการลงชื่อหน้า [ข้อมูลสินค้า]',
  SynchronizeMainTicketPackingInformation: 'ซิงค์ข้อมูลการบรรจุตั๋วหลัก',
  CaseNumberCannotBeEmpty: 'หมายเลขกล่องต้องไม่ว่างเปล่า',
  InvalidCaseNumber: 'หมายเลขกล่องที่ไม่ถูกต้อง',
  TheSealNumberCannotBeEmpty: 'ตราประทับต้องไม่ว่างเปล่า',
  BoxTypeCannotBeEmpty: 'ประเภทกล่องไม่สามารถว่างเปล่าได้',
  EnglishNameCannotBeEmpty: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้',
  TheMarkCannotBeEmpty: 'เครื่องหมายการจัดส่งต้องไม่ว่างเปล่า',
  HscodeCannotBeEmpty: 'HSCODE ไม่สามารถว่างได้',
  ThePackageCannotBeEmpty: 'บรรจุภัณฑ์ต้องไม่ว่างเปล่า',
  ThePiecesCannotBeEmpty: 'จำนวนชิ้นไม่สามารถว่างได้',
  GrossWeightCannotBeEmpty: 'น้ำหนักรวมต้องไม่ว่างเปล่า',
  VolumeCannotBeEmpty: 'ปริมาตรต้องไม่ว่างเปล่า',
  DanUNNoCannotBeEmpty: '【UN Code】 สินค้าอันตรายที่จำเป็น, ช่วง 0001-9999',
  DanClassNoCannotBeEmpty: '【ระดับสินค้าอันตราย】 สินค้าอันตรายที่จำเป็น, ช่วง: 1-9.9',
  DangerousGoodsContactCannotBeEmpty: 'รายชื่อสินค้าอันตรายไม่สามารถว่างได้',
  DangerousGoodsContactPhoneNumberCannotBeEmpty: 'โทรศัพท์ติดต่อวัตถุอันตรายไม่สามารถว่างได้',
  TherePleaseEnterItTab: 'ไม่มีข้อมูลที่สามารถนำเข้าได้ โปรดไปที่หน้า "ข้อมูลการบรรจุ" เพื่อลงชื่อเข้าใช้',
  NoMasterTicketInformationYet: 'ไม่มีข้อมูลเกี่ยวกับตั๋วหลักชั่วคราว!',
  WeighingMethod: 'วิธีการชั่งน้ำหนัก',
  VGMLLC: 'บริษัท วีจีเอ็ม',
  VGMWeightAddress: 'ที่อยู่ชั่งน้ำหนัก VGM',
  VGMSignature: 'วีจีเอ็ม ซิกเนเจอร์',
  TareWeight: 'น้ำหนักกล่อง',
  TareWeightUnit: 'กล่อง Tare หน่วย',
  WeighingAddress: 'ที่อยู่ชั่งน้ำหนัก',
  WeighingMethodCannotBeEmpty: 'วิธีการชั่งน้ำหนักต้องไม่ว่างเปล่า',
  TheWeightCannotBeEmpty: 'น้ำหนักรวมไม่สามารถเว้นว่างได้',
  VGMCompanyCannotBeEmpty: 'VGM Liability Corporation ไม่สามารถเว้นว่างได้',
  VGMSignatureCannotBeEmpty: 'ลายเซ็น VGM ไม่สามารถเว้นว่างได้',
  MailboxCannotBeEmpty: 'กล่องจดหมายต้องไม่ว่างเปล่า',
  PhoneNumberCannotBeEmpty: 'โทรศัพท์จะว่างเปล่าไม่ได้',
  WeighingAddressCannotBeEmpty: 'ที่อยู่การชั่งน้ำหนักต้องไม่ว่างเปล่า',
  NotifierCodeCannotBeEmpty: 'ผู้แจ้งรหัสธุรกิจไม่สามารถเว้นว่างได้',
  ContactNotifierCannotBeBlank: 'ข้อมูลติดต่อของผู้รับแจ้งไม่สามารถว่างได้',
  ImportTallyInformation: 'การนำเข้าข้อมูลการรับสินค้า',
  PTImport: 'การนำเข้า PT',
  SelectTime: 'เลือกเวลา',
  CaseNoSealNo: 'หมายเลขกล่อง - หมายเลขซีล',
  CopySmallTicketCost: 'คัดลอกค่าใช้จ่ายตั๋วขนาดเล็ก',
  PleaseCostToBeCopied: 'โปรดเลือกค่าใช้จ่ายเพื่อคัดลอก',
  CrossTenantDelegationHistory: 'บันทึกสถานะประวัติการมอบหมายข้าม tenant',
  Operator: 'ผู้ดำเนินการ',
  OperationTime: 'เวลาทำงาน',
  DelegationStatusHistory: 'ประวัติการมอบอำนาจ',
  GeneratePrimaryDocNo: 'สร้างหมายเลขเดี่ยว',
  PleasePrimaryOrderNumberRule: 'โปรดเลือกกฎ Master Single',
  PleaseCodeOfTheNo: 'โปรดเลือกรหัสบริการของหมายเลขหลัก',
  SendOnlineManifestInvitationEmail: 'ส่งจดหมายเชิญ Manifests ออนไลน์',
  PleaseConfirmEmailAddress: 'กรุณายืนยันที่อยู่กล่องจดหมาย:',
  ShippingPreConfigurationInformationManifest: 'จองเรือด่วนรุ่น - ข้อมูลก่อนประกอบ - เชิญรายการออนไลน์',
  TheSentToTheIt: 'ลิงก์คำเชิญถูกส่งไปยังกล่องจดหมายแล้ว โปรดตรวจสอบ!',
  TotalCustomsNo: 'หมายเลขใบปิด รวม',
  TotalNumberOfPieces: 'จำนวนชิ้น รวม',
  TotalGrossWeight: 'น้ำหนักรวม',
  TotalVolume: 'ปริมาณรวม',
  CustomsNoNotImported: 'ไม่มีการนำเข้าหมายเลขศุลกากร:',
  ImportDate: 'วันที่นำเข้า',
  ImportUser: 'นำเข้าผู้ใช้',
  SendUser: 'ส่งผู้ใช้',
  ManifestImportUser: 'ผู้ใช้นำเข้า Manifold',
  SendTag: 'ส่งเครื่องหมาย',
  SubtotalOfCustomsOrderNo: 'ผลรวมย่อยของหมายเลขปิด',
  ConfirmToVoid: 'ยืนยันเป็นโมฆะหรือไม่',
  MBNOCannotBeEmpty: 'MB / L ไม่ ไม่สามารถว่างเปล่า!',
  ShipNameCannotBeEmpty: 'ชื่อเรือจะว่างเปล่าไม่ได้!',
  VoyageCannotBeEmpty: 'เที่ยวบินไม่สามารถว่างเปล่า!',
  ShippingCompanyCannotBeEmpty: 'บริษัทเรือจะว่างเปล่าไม่ได้!',
  ShippingAgentCannotBeEmpty: 'อู่เรือจะว่างเปล่าไม่ได้!',
  DestinationPortCannotBeEmpty: 'ท่าเรือปลายทางต้องไม่ว่างเปล่า!',
  GoodsTypeCannotBeEmpty: 'ประเภทของสินค้าต้องไม่ว่างเปล่า!',
  TransportationTermsCannotBeBlank: 'เงื่อนไขการจัดส่งไม่สามารถว่างเปล่า!',
  FreightTermsCannotBeBlank: 'เงื่อนไขการจัดส่งไม่สามารถว่างเปล่า!',
  BillTypeCannotBeEmpty: 'ประเภท B / L ไม่สามารถว่างเปล่า!',
  PaymentPlaceCannotBeEmpty: 'สถานที่ชำระเงินต้องไม่ว่างเปล่า!',
  MattersNeedingAttention: 'ข้อควรระวัง',
  DontRemindMeAgain: 'ไม่มีการแจ้งเตือนครั้งต่อไป',
  CloseSpace: 'ปิด',
  TheBeenSentToSending: 'หมายเลขใบกำกับสินค้า【{0}】 ได้ถูกส่งไปยัง EDI แล้วหรือยัง?',
  SelectToSendPreManifest: 'เลือกการส่งช่องบรรจุสินค้าล่วงหน้า',
  SelectCorrectConfiguredManifestChannel: 'เลือกการแก้ไขช่องรายการสินค้าที่เตรียมไว้',
  SelectDeleteConfiguredManifestChannel: 'เลือกการลบช่องบรรจุสินค้าล่วงหน้า',
  ThePleaseRefreshTheAgain: 'ทำความสะอาดวัตถุรายการว่างเปล่าโปรดลองอีกครั้งหลังจากรีเฟรชหน้า',
  CustomsClearanceNo: 'หมายเลขบัตรย่อย',
  ShippingCompanyOperation: 'การดำเนินการของบริษัทเรือ',
  CustomsRestAssured: 'ศุลกากรมั่นใจ',
  PlanType: 'ประเภทโปรแกรม',
  AcceptanceTime: 'เวลายอมรับ',
  ScheduledStartTime: 'กำหนดเวลาเริ่มต้น',
  PlannedEndTime: 'กำหนดเวลาสิ้นสุด',
  DepartureTime2: 'เวลาเปิดพอร์ต:',
  PortCutOffTime: 'เวลาตัดพอร์ต:',
  ActualBerthingTimeColon: 'เวลาเทียบท่าจริง:',
  ActualDepartureTimeColon: 'เวลาออกทะเลจริง:',
  ClickToViewTheTrailer: 'คลิกเพื่อดูรถพ่วง',
  DisplayPortArea: 'ข้อมูลต่อไปนี้แสดงข้อมูลท่าเรือ / บริษัท เรือ',
  DetailedData: 'ข้อมูลรายละเอียด',
  manualPrompt: 'Orange Data: บริการข้อมูล',
  thirdPartyPrompt: 'ข้อมูลสีฟ้าอ่อน: ป้อนข้อมูลด้วยตนเอง',
  promptNo: 'ข้อมูลสีเทา: ไม่มีข้อมูลชั่วคราว',
  promptNoData: 'ไม่มีข้อมูลในขณะนี้',
  ArrivalReportStatus: 'สถานะการรายงานการขนส่งขาเข้า',
  CustomsClearanceSheetStatus: 'สถานะของใบสั่งปิด',
  PlanDetails: 'รายละเอียดโปรแกรม',
  PutInTheBox: 'ใส่กล่องแล้ว',
  EmptyBox: 'กล่องเปล่า',
  Arrival: 'พอร์ตขาเข้า',
  EstimatedCYOpening: 'คาดว่าจะเปิดท่าเรือ',
  PortDocCutOff: 'เขตท่าเรือ',
  ActualBerthing: 'จอดเทียบท่าจริง',
  ActualDeparture: 'เปิดเรือได้จริง',
  customsClearance: 'ศุลกากรปล่อย',
  DockRelease: 'เปิดตัวท่าเทียบเรือ',
  CancelCustomsClearance: 'ยกเลิกการปล่อยทะเล',
  CancelDockRelease: 'ยกเลิกการใส่รหัส',
  AllocateVehiclesToTransportSth: 'กำลังโหลด',
  Sail: 'ล่องเรือ',
  Departure: 'ท่าเรือขาออก',
  Pickup: 'ยกน้ำหนัก',
  BusinessFunction: 'คุณสมบัติทางธุรกิจ',
  ClickTheButton: 'คลิกที่ปุ่ม',
  ReturnAddress: 'ที่อยู่ส่งคืน',
  DepartureTime3: 'เวลาออกเดินทาง',
  ArrivalWharf: 'ท่าเรือท่าเรือ',
  departureTime: 'เวลาออก',
  StowageTime: 'เวลาโหลด',
  AbnormalCause: 'สาเหตุของความผิดปกติ',
  StackingTime: 'เวลาในการใส่รหัส',
  StackingState: 'สถานะการวางรหัส',
  SeaReleaseTime: 'เวลาเปิดทะเล',
  SeaReleaseDescription: 'ทะเลปล่อย Description',
  SeaReleaseState: 'สถานะการเปิดตัวทะเล',
  arrivalTime: 'เวลาเข้า',
  TrailerFollow: 'รถพ่วงติดตาม',
  SuitcaseLocation: 'สถานที่ยกกระเป๋า',
  BoxReleaseTime: 'เวลาวางกล่อง',
  EstimatedPickUpPoint: 'คาดว่าจุดรับกระเป๋า',
  Wharf: 'ท่าเรือ',
  NameNumberOfImportedVessels: 'ชื่อเรือนำเข้า เรือสำราญ',
  FieldBoxPosition: 'ฟิลด์กล่องบิต',
  NameNumberOfExportVessel: 'ชื่อเรือส่งออก เรือเดินสมุทร',
  containerWeight: 'น้ำหนักบรรทุกกล่อง',
  VGMWharfWeighing: 'การชั่งน้ำหนักท่าเรือ VGM',
  ContainerHolder: 'ผู้ถือกล่อง (เฉพาะท่าเรือเซี่ยงไฮ้)',
  LeadSeal: 'หมายเลขซีลตะกั่ว',
  TransshipmentPort: 'พอร์ตโอน',
  VGMMessageReceiving: 'การรับเอกสาร VGM',
  ApproachMode: 'วิธีการเข้า',
  ArrivalMessageTime: 'เวลารายงานมาถึง',
  AppearanceMode: 'วิธีการปรากฏตัว',
  ReeferTemperatureRequired: 'อุณหภูมิห้องเย็น',
  ReceivedTheReleaseTime: 'ได้รับเวลาปล่อยทะเล',
  NationalInspectionRelease: 'การปล่อยตัวตรวจสอบของรัฐ',
  OverrunCode: 'รหัสเกินขีด จำกัด',
  WharfStowage: 'โหลดท่าเทียบเรือ',
  EmptyContainerRelease: 'ปล่อยกล่องที่ว่างเปล่า',
  Front: 'หน้า',
  After: 'โพสต์',
  SuperLong: 'ยาวพิเศษ',
  FlowTo: 'ทิศทางการไหล',
  Left: 'ซ้าย',
  Right: 'ขวา',
  UltraWide: 'กว้างพิเศษ',
  MaritimeReleaseException: 'ความผิดปกติของการปล่อยทางทะเล',
  SuperHigh: 'สูงพิเศษ',
  QuantityOfBoxesAndPieces: 'ปริมาณกล่อง จำนวนชิ้น:',
  GreaterActualNumberOfPieces: 'มากกว่าจำนวนชิ้นจริง:',
  BoxWeight: 'น้ำหนักของปริมาณกล่อง:',
  GreaterThanActualWeight: 'มากกว่าน้ำหนักจริง:',
  BoxVolume: 'ปริมาณกล่อง:',
  LargerThanActualVolume: 'มากกว่าปริมาณที่แท้จริง:',
  JobNoColon: 'หมายเลขงาน:',
  AddSpellCustomsOrderNo: 'เพิ่มหมายเลขใบสะกด',
  PleaseForAddingAndForm: 'โปรดเลือกกฎสำหรับการเพิ่มหมายเลขใบสะกด',
  PleaseSelectSuffixSeparator: 'โปรดเลือกตัวคั่นต่อท้าย',
  PleaseCustomsDeclarationNoSpelled: 'กรุณาใส่หมายเลขใบปิดสมุดที่ต้องการเพิ่ม',
  DirectToCanada: 'ส่งตรงถึงแคนาดา',
  ToInlandWarehouse: 'ไปยังคลังสินค้าต่างจังหวัด',
  TransitClearancePullToStates: 'ส่งต่อในแคนาดาโดยไม่ต้องผ่านพิธีการศุลกากรดึงไปยังสหรัฐอเมริกา',
  TheThroughTheUnitedStates: 'เส้นทางขนส่งสินค้า สหรัฐอเมริกา',
  PleaseSelectAnAccount: 'กรุณาเลือกบัญชี',
  PleaseOfYourCurrentFirst: 'โปรดรักษารหัสในแผนกปัจจุบันของคุณก่อน!',
  ItServiceProviderOfHouse: 'กลายเป็น"บ้านโวฮัง"ผู้ให้บริการ',
  YouHisPartnerAndService: 'คุณสามารถสมัครออนไลน์เพื่อเป็นพันธมิตรของเขาก็สามารถเพลิดเพลินกับบริการสั่งซื้อสินค้าออนไลน์',
  PleaseSelectTheEntrustingCompany: 'กรุณาเลือกหน่วยงาน',
  PleaseSelectDestinationAgent: 'โปรดเลือกตัวแทนปลายทาง!',
  UncheckedSmallTicket: 'ตั๋วขนาดเล็กไม่ถูกเลือก',
  CustomerInformation: 'ข้อมูลลูกค้า',
  CodeCannotBeEmpty: 'รหัสต้องไม่ว่างเปล่า',
  TheNameCannotBeEmpty: 'ชื่อไม่สามารถว่างได้',
  CertificateTypeCannotBeBlank: 'ประเภทของเอกสารต้องไม่ว่างเปล่า',
  IDNumberCannotBeEmpty: 'หมายเลขเอกสารไม่สามารถเว้นว่างได้',
  AddressCannotBeEmpty: 'ที่อยู่ไม่สามารถว่างได้',
  CityCannotBeEmpty: 'บ้านเมืองจะว่างเปล่าไม่ได้',
  CountryCannotBeEmpty: 'ประเทศชาติจะว่างเปล่าไม่ได้',
  ThisSuccessfullyInsuredRepeatedAllowed: 'ธุรกิจตั๋วนี้ประสบความสำเร็จในการทำประกันและไม่อนุญาตให้ทำประกันซ้ำ',
  Seller: 'ผู้ขาย',
  Manufacturer: 'ผู้ผลิต',
  Consolidator: 'ผู้ประกอบการขนส่ง',
  OriginalBookingParty: 'การจองห้องพักเดิม',
  GoodsReceiver: 'ผู้รับสินค้า',
  PackingPoint: 'จุดบรรจุ',
  Importer: 'ผู้นำเข้า',
  AMSNoCannotBeBlank: 'หมายเลขย่อย AMS ไม่สามารถว่างได้',
  SCACCompanyCannotBeEmpty: 'บริษัทเรือ SCAC จะว่างเปล่าไม่ได้',
  TheDischargeCannotBeEmpty: 'ท่าเรือขนถ่ายสินค้าต้องไม่ว่างเปล่า',
  TheDeliveryCountryCannotBeEmpty: 'ประเทศที่จัดส่งจะว่างเปล่าไม่ได้',
  TheDeliveryCannotBeEmpty: 'สถานที่จัดส่งต้องไม่ว่างเปล่า',
  CorrectionOfBillOfLading: 'แก้ไขใบตราส่งสินค้า',
  OriginalBillOfLading: 'ต้นฉบับ B / L',
  TheBillOfLadingEmpty: 'สถานที่จัดส่ง B / L ไม่สามารถว่างเปล่าได้',
  SailingDateEmpty: 'วันที่ออกเดินทางไม่สามารถว่างได้',
  TransceiverSelection: 'เลือก Trans-Com',
  YouServiceOfTheManifest: 'คำถามเกี่ยวกับรายการสินค้าล่วงหน้าสามารถคลิกที่ไอคอนเพื่อปรึกษาฝ่ายบริการลูกค้าของ Sea Butler',
  OriginalCleaningManifest: 'รายการทำความสะอาดดั้งเดิม',
  Correction1: 'การแก้ไข 1',
  CorrectCleaningManifest: 'แก้ไขรายการทำความสะอาด',
  SendPreConfiguredManifest: 'ส่งรายการฝากสินค้าล่วงหน้า',
  CorrectionOfPreAllocationManifest: 'แก้ไขรายการสินค้าที่เตรียมไว้',
  DeletePreConfiguredManifest: 'ลบรายการที่เตรียมไว้',
  CancelPreConfiguredManifest: 'การถอนรายการสินค้าล่วงหน้า',
  OriginalPreAllocatedManifest: 'รายการเดิมที่จัดเตรียมไว้',
  CleanManifestAPI: 'ทำความสะอาด Manifold API',
  OriginalVGM: 'ต้นฉบับ VGM',
  HscodeConfigurationInformationCannotEmpty: 'HSCODE สำหรับข้อมูลล่วงหน้าไม่สามารถว่างได้',
  HscodeInformationMustBeDigits: 'HSCODE สำหรับข้อมูลล่วงหน้าต้องเป็น 6 หลัก',
  PleaseTickTheBoxForTheCargoInformationYouWantToAmendTheManifest: 'โปรดติ๊กข้อมูลสินค้าที่คุณต้องการแก้ไขรายการสินค้า',
  PleaseConfirmThatTheCustomsInformationYouSelectedHasNotBeenModified: 'ข้อมูลศุลกากรที่คุณเลือกไม่ได้รับการแก้ไขโปรดยืนยัน',
  PleaseSelectAllSeaHouseUpdateData: 'คุณแก้ไขเนื้อหาของโมดูล 【ข้อมูลพื้นฐานของรายการสินค้า】 และ 【ข้อมูลการจัดส่งลูกค้า】 ต้องตรวจสอบข้อมูลที่ส่งมาทั้งหมดเพื่อส่งด้วยกัน',
  SendingSucceeded: 'ส่งเรียบร้อยแล้ว!',
  TheTheReceiptLogInformation: 'รายการสินค้าต้นฉบับถูกส่งไปแล้ว แตะ Back Log เพื่อดูข้อมูลการคืนสินค้า',
  UpdateSucceeded: 'อัปเดตสำเร็จ!',
  PleaseSuccessfullyIfNotFirst: 'กรุณาตรวจสอบว่ารายการสินค้าต้นฉบับถูกส่งเรียบร้อยแล้วหรือยัง หากไม่ส่งให้ส่งรายการสินค้าต้นฉบับก่อน',
  DeleteSucceeded: 'ลบสำเร็จ!',
  WseModifyReasonNotEmpty: 'กรุณาเลือกเหตุผลในการเปลี่ยนแปลงรายการ',
  WseModifyRemarkNotEmpty: 'โปรดเพิ่มคำอธิบายการเปลี่ยนแปลง',
  WseDeleteReasonNotEmpty: 'โปรดเลือกเหตุผลในการลบแผ่นงาน',
  WseDeleteRemarkNotEmpty: 'โปรดเพิ่มคำอธิบายการตัดแผ่น',
  BrandNew: 'แบรนด์ใหม่',
  SecondHand: 'มือสอง',
  Unknown: 'ไม่ทราบ',
  ReImportAfterModification: 'นำเข้าใหม่หลังจากแก้ไขได้',
  FailedToDownloadData: 'ดาวน์โหลดข้อมูลล้มเหลว',
  ClickVehiclePositioningAndTrack: 'คลิกปุ่มเพื่อสอบถามตำแหน่งยานพาหนะและเส้นทางการเดินทางของยานพาหนะ',
  VehiclePositioningTrack: 'ติดตามตำแหน่งยานพาหนะ',
  IfToTheCurrentIt: 'สถานะค่าใช้จ่ายที่ต้องชำระของบริษัทขนส่งในปัจจุบันได้เปลี่ยนแปลงไปแล้วและจะไม่มีการซิงค์กับหน้าค่าธรรมเนียมหลังจากลบ / แก้ไขแล้ว คุณต้องการดำเนินการต่อหรือไม่?',
  VehicleTrajectory: 'ติดตามการขับขี่ยานพาหนะ',
  DistributionCustomsNo: 'กำหนดหมายเลขปิด',
  BookingReceipt: 'การตอบกลับการจองห้องพัก',
  InMailOfThePrevail: 'ขั้นตอนการตรวจสอบภายในขึ้นอยู่กับจดหมายเจ้าของเรือ',
  CorrectBooking: 'แก้ไขการจองห้องพัก',
  OriginalBooking: 'ห้องจองเดิม',
  TheBeVoidedAndThis: 'มีการสร้างเลขหมายหลักเลขหมายหลักเลขหมายจะถูกสร้างขึ้นอีกครั้งจะทำให้หมายเลขเดิมเป็นโมฆะและสร้างเลขหมายใหม่เลขหมายเดียวได้รับการยืนยันที่จะทำเช่นนั้นหรือไม่?',
  BasicTab: 'ป้ายหน้าพื้นฐาน',
  TheHairBodyCannotEmpty: 'ชิ้นส่วนจริงขนไม่สามารถว่างเปล่า',
  PackageCannotBeEmpty: 'บรรจุภัณฑ์ต้องไม่ว่างเปล่า',
  MBLTab: 'ลายเซ็นหน้า MBL',
  ShipperCannotBeBlank: 'ผู้ส่งสินค้าไม่สามารถว่างได้',
  ConsigneeCannotBeEmpty: 'ผู้รับสินค้าต้องไม่ว่างเปล่า',
  NotifierCannotBeBlank: 'ผู้แจ้งไม่สามารถว่างได้',
  TheEmptyPleaseRefreshAgain: 'วัตถุรายการล่วงหน้าว่างเปล่าโปรดลองอีกครั้งหลังจากรีเฟรชหน้า',
  TheIsEmptyPleaseAgain: 'วัตถุแก้ไขรายการสินค้าล่วงหน้าว่างเปล่าโปรดลองอีกครั้งหลังจากรีเฟรชหน้า',
  VGMRefreshThePageAgain: 'วัตถุ VGM ว่างเปล่าโปรดลองอีกครั้งหลังจากรีเฟรชหน้า',
  TheCleaningIsEmptyPleaseAgain: 'วัตถุรายการทำความสะอาดล่วงหน้าว่างเปล่าโปรดลองอีกครั้งหลังจากรีเฟรชหน้า',
  TheNoCannotBeBlank: 'หมายเลขปิดไม่สามารถว่างได้',
  MBLNoCannotEmpty: 'MB / L NO ไม่สามารถว่างได้',
  NewGoods: 'เพิ่มสินค้า',
  DeleteGoods: 'ลบสินค้า',
  TotalOfThisBox: 'กรณีนี้รวม:',
  DataComparison: 'การเปรียบเทียบข้อมูล',
  UpdatePortAreaData: 'ปรับปรุงข้อมูลพื้นที่ท่าเรือ',
  NoPortDataHasBeenObtained: 'ยังไม่ได้รับข้อมูลในพื้นที่ท่าเรือขณะที่',
  SynchronizePortData: 'ซิงค์ข้อมูล Harbour Area',
  NotVerified: 'ไม่มีการตรวจสอบ',
  SystemVerification: 'การตรวจสอบระบบสอดคล้องกัน',
  ManualVerification: 'การตรวจสอบด้วยตนเองสอดคล้อง',
  ToBeConfirmed2: 'เพื่อยืนยัน',
  TheInThePortOpened: 'ยังไม่เปิดให้บริการผลักดันข้อมูลสินค้ากล่องในพื้นที่ท่าเรือ',
  TheDirectlyImportTheCall: 'บริการข้อมูล Port Area Boxes ช่วยให้คุณตรวจสอบว่าข้อมูล Port Area Boxes ถูกต้องหรือไม่และยังสามารถนำเข้าข้อมูล Port Area Boxes ไปยังธุรกิจได้โดยตรง หากต้องการเปิดบริการกรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์หรือโทรติดต่อหมายเลขโทรศัพท์:',
  HarbourNotInServiceNoOpen: 'ท่าเรือที่เกี่ยวข้องไม่ได้เปิดบริการเปรียบเทียบข้อมูลชั่วคราวและไม่สามารถให้บริการฟังก์ชั่นการเปรียบเทียบข้อมูลได้ ขณะนี้รองรับท่าเรืออื่น ๆ สำหรับการเปรียบเทียบข้อมูลสำหรับการเปิดกรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์หรือโทรติดต่อหมายเลขโทรศัพท์:',
  HarbourInServiceNoOpen: 'บริการข้อมูลกล่องของ Harbour Area ช่วยให้คุณตรวจสอบข้อมูลกล่องว่าถูกต้องหรือไม่และยังสามารถนำเข้าข้อมูลการจัดส่งกล่องของ Harbour Area โดยตรงเพื่อให้สามารถป้อนข้อมูลได้อย่างง่ายดาย หากต้องการเปิดบริการกรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์หรือโทรติดต่อหมายเลขโทรศัพท์:',
  HarbourNotInServiceOpen: 'การผลักดันและการเปรียบเทียบข้อมูลของเขตท่าเรือนี้ไม่สนับสนุนในปัจจุบัน',
  ThisActionCannotBeUndone: 'การกระทำนี้ไม่สามารถเพิกถอนได้',
  DoYouWantToContinue: 'คุณจะทำต่อหรือไม่',
  ItPortDataAndVerified: 'ไม่ตรงกับข้อมูลเขตท่าเรือและไม่สามารถตรวจสอบได้',
  TheNotContainTheData: 'ข้อมูลปัจจุบันไม่มีข้อมูลเขตท่าเรือต่อไปนี้',
  PortInformationVerification: 'การตรวจสอบข้อมูลท่าเรือ',
  SIsMissingAndVerified: 'S/O NO หายไปและไม่สามารถตรวจสอบได้',
  PleaseNoForTheFirst: 'กรุณากรอก S/O NO สำหรับตั๋วขนาดเล็กปัจจุบันก่อน',
  TheOverwriteTheCurrentData: 'ฟังก์ชันจะเขียนทับข้อมูลปัจจุบัน',
  OperationSucceeded: 'การดำเนินการประสบความสำเร็จ!',
  OrderNumber: 'จำนวนการสั่งซื้อ',
  TotalPacking: 'จำนวนบรรจุภัณฑ์ทั้งหมด',
  ContainerList: 'รายการภาชนะ',
  UpdateStatus: 'สถานะการอัปเดต',
  ClearThePackingInformation: 'ล้างข้อมูลบรรจุภัณฑ์',
  ExportThePackingPlan: 'ส่งออกแผนการบรรจุ',
  checkGoods: 'ดูรายการสินค้า',
  checkPackages: 'ดูบรรจุภัณฑ์',
  NumberOfPackages: 'ปริมาณบรรจุภัณฑ์',
  AskForPositionTime: 'ต้องการเวลาเข้าโพซิชั่น',
  EstimatedPositionTime: 'เวลาโดยประมาณในการเข้าสู่ตำแหน่ง',
  CheckTheDetailsOfTheGoods: 'ดูรายละเอียดสินค้า',
  UnableToRemove: 'ไม่สามารถถอดออกได้ตู้คอนเทนเนอร์ถูกล็อคหรือบรรจุในกล่อง',
  removeOrderTips: 'แน่ใจหรือไม่ว่าคำสั่งนี้จะถูกลบออก',
  removeOrder: 'ลบคำสั่ง',
  PackageNo: 'หมายเลขบรรจุภัณฑ์',
  NumberOfPackagesAnticipateOrReality: 'จำนวนบรรจุภัณฑ์ (ก่อน / จริง)',
  Code4: 'การเข้ารหัส',
  LengthAnticipateOrReality: 'ยาว (ก่อน / จริง)',
  WidthAnticipateOrReality: 'กว้าง (ก่อน / จริง)',
  HighAnticipateOrReality: 'สูง (ก่อน / จริง)',
  UnitVolumeAnticipateOrReality: 'ปริมาณหน่วย (ก่อน / จริง)',
  GrossWeightAnticipateOrReality: 'น้ำหนักรวมเดี่ยว (ก่อน / จริง)',
  Considerations: 'ข้อควรระวัง',
  Anufacturer: 'ผู้ผลิต',
  EstimateLoadingTime: 'คาดว่าเวลาจัดส่งสินค้าดี',
  ActualWarehousingTime: 'เวลาเข้าจริง',
  NO: 'หมายเลข',
  NoCorrespondingFile: 'ยังไม่ได้รับแฟ้มที่ตรงกัน!',
  ChooseState: 'เลือกสถานะ',
  ActualPackingTime: 'เวลาบรรจุจริง',
  ChooseActualPackingTime: 'โปรดเลือกเวลาบรรจุจริง',
  updateContainerStateTip: 'การอัพเดตล้มเหลวและมีคำสั่งเปิดในกล่อง',
  firstCleanedContainer: 'โปรดเลือกภาชนะที่ต้องการล้างก่อน',
  containerBeCleared: 'ตู้คอนเทนเนอร์ไม่สามารถถอดออกได้',
  removeSelectedContainer: 'แน่ใจหรือไม่ว่าจะลบคำสั่งซื้อทั้งหมดภายใต้ภาชนะที่เลือก?',
  ClearContainerInformation: 'ล้างข้อมูลตู้คอนเทนเนอร์',
  goodsOperateTips: 'กรุณาบันทึกข้อมูลหมายเลขนี้ก่อนดำเนินการขนส่งสินค้า',
  removeGoodsTips: 'โปรดเลือกสินค้าที่ต้องการลบ',
  NumberOfCartons: 'จำนวนกล่อง',
  importGoodsTips: 'โปรดเลือกสินค้าที่ต้องการนำเข้า',
  ChooseGoods: 'เลือกสินค้า',
  RemoveTheGoods: 'ลบคำสั่ง',
  Source: 'แหล่งที่มา',
  PreCommitUser: 'ลงทะเบียนล่วงหน้า',
  PreCommitDate: 'เวลายื่นล่วงหน้า',
  SubmissionDate: 'เวลาส่ง',
  CommitUser: 'ผู้เขียน',
  RelatedSubmissionDate: 'ไป-กลับ ธุรกิจที่เกี่ยวข้อง เวลาส่ง',
  RelatedCommitUser: 'ติดต่อกลับ ธุรกิจที่เกี่ยวข้อง ผู้เขียน',
  RelatedPreCommitUser: 'ติดต่อซื้อขายล่วงหน้ากับธุรกิจที่เกี่ยวโยงกัน',
  RelatedPreCommitDate: 'ไป-กลับ ธุรกิจที่เกี่ยวโยงกัน',
  FcAuditDate: 'เวลาตรวจสอบ',
  FcAuditUser: 'รีวิวโดย',
  LockJobDate: 'ล็อคเวลาเดียว',
  LockJobUser: 'ล็อคเดี่ยว',
  PrintListTip: 'กรุณาเลือกรายการที่คุณต้องการพิมพ์',
  CargoActArrivalDatePacking: 'วันที่บรรจุจริง',
  releaseStowageState: 'สถานะการเปิดตัว',
  ChangeHistory: 'ประวัติการเปลี่ยนแปลง',
  SynchronizationInformation: 'ซิงค์ข้อมูล',
  SyncChargeToEas: 'EAS ซิงค์',
  NoEasCharge: 'ไม่มีค่าธรรมเนียมที่ต้องประสานกับ EAS',
  CheckEasChargeState: 'ไม่มีค่าธรรมเนียมที่ต้องซิงค์กับ EAS โปรดตรวจสอบสถานะค่าธรรมเนียม EAS',
  CheckBusinessUuid: 'ธุรกิจ UUID ไม่สามารถว่างเปล่า!',
  KingDeeChargePush: 'Jin Die ค่าธรรมเนียมผลักดัน',
  ExternalSerialNumber: 'หมายเลขเอกสาร',
  EmptyCabinetDate: 'เวลาเข้าโรงงานของตู้ที่ว่างเปล่า',
  RealArrivalsDate: 'เวลาเข้าจริง',
  ActualLiftingDate: 'เวลายกจริง',
  DeliveryDoneDate: 'เวลาจัดส่งเสร็จสิ้น',
  CleaningDate: 'เวลาทำความสะอาดตู้',
  ReturnBoxDate: 'เวลาคืนกล่อง',
  DestinationDeliveryTime: 'เวลาส่งสถานะที่ท่าเรือปลายทาง',
  DestinationReturnTime: 'ท่าเรือปลายทาง เวลาว่าง',
  PortDischargeTime: 'เวลาขนถ่ายจริง',
  EstimatedPortDischargeTime: 'เวลาขนถ่ายโดยประมาณ',
  UnloadingTime: 'เวลาขนถ่าย',
  LiftingTime: 'เวลายกน้ำหนัก',
  RailwayDepartureTime: 'เวลาขนส่งทางรางจริง',
  EstimatedRailwayDepartureTime: 'คาดว่าจะใช้เวลาในการขนส่งทางราง',
  RailwayDischargeTime: 'เวลาขนถ่ายทางรถไฟจริง',
  EstimatedRailwayDischargeTime: 'คาดว่าจะใช้เวลาขนถ่ายทางรถไฟ',
  EstimatedTimeOfArrivalAtThePlaceOfDelivery: 'เวลาโดยประมาณของสถานที่จัดส่งมาถึง',
  Arrived: 'มาถึง',
  Acquire: 'ใบเสร็จรับเงิน',
  TheActualTimeOfArrivalAtThePlaceOfDelivery: 'เวลาจัดส่งสินค้ามาถึงจริง',
  EstimatedCustomsReleaseTime: 'คาดว่าจะใช้เวลาในการปล่อยตัว',
  EstimatedPickupTime: 'คาดว่าจะใช้เวลาในการยกน้ำหนัก',
  ActualPickUpTime: 'เวลายกจริง',
  EstimatedDeliveryToWarehouseTime: 'เวลาการจัดส่งโดยประมาณ',
  EstimatedReturnTime: 'คาดว่าจะใช้เวลาคืนพื้นที่',
  ActualReturnTime: 'เวลาคืนพื้นที่จริง',
  PODDeliveryInformation: 'ข้อมูลการจัดส่งไปยังท่าเรือปลายทาง',
  ActualDeliveryToWarehouseTime: 'เวลาจัดส่งสินค้าในคลังสินค้าจริง',
  EstimatedDeliveryToCustomersWarehouseTime: 'เวลาจัดส่งโดยประมาณ',
  ActualDeliveryToCustomersWarehouseTime: 'เวลาจัดส่งจริง',
  PickupMessage: 'CY-DOOR， คลังสินค้า Unboxing จากพื้นที่ท่าเรือไปยังคลังสินค้า FCL / LCL',
  DeliveryToWarehouseMessage: 'เวลาส่งไปยังคลังสินค้าท่าเรือปลายทางหลังจากยกน้ำหนัก',
  EstimatedDeliveryToCustomersWarehouseMessage: 'จากคลังสินค้า LCL ถึงคลังสินค้าลูกค้า (B2B) / ส่งคลังสินค้าระยะสุดท้าย (B2C)',
  ActualDeliveryToCustomersWarehouseMessage: 'จากคลังสินค้า LCL ถึงคลังสินค้าของลูกค้า / จัดส่งกิโลเมตรสุดท้ายจากคลังสินค้า',
  CargoReadyDate: 'สินค้าดี เวลา',
  BackUpWarehouse: 'ตำแหน่งล่วงหน้า',
  PleaseSelectBackUpWarehouse: 'กรุณาเลือกตัวเลือก 【ตำแหน่งล่วงหน้า】',
  HeavyContainerMobilization: 'รายการกล่องหนัก',
  checkLines100: 'ตรวจสอบจำนวนแถวต้องไม่เกิน 100 แถว!',
  estimatedDeliveryTime: 'เวลาที่คาดว่าจะออกจากตำแหน่ง',
  estimatedArrivalTime: 'เวลาโดยประมาณขาเข้า',
  EmailGroup: 'กลุ่มจดหมาย',
  EmailTemplate: 'เทมเพลตจดหมาย',
  CargoAllocationList: 'รายชื่อห้องโดยสาร',
  CheckApproved: 'กรุณาเลือกธุรกิจที่คุณต้องการตรวจสอบ!',
  StateVerifyingReview: 'ตรวจสอบ (เพื่อตรวจสอบ)',
  VotesSubmission: 'มีการยื่นตั๋วหรือไม่',
  BatchSubmitCheckOperate: 'สามารถส่งรายการที่มีการดำเนินงานในเชิงบวกเป็นกลุ่มเท่านั้น!',
  BatchSubmitCheckPre: 'สามารถส่งรายการที่ส่งล่วงหน้าได้จำนวนมากเท่านั้น!',
  CancelFormalHblTips: 'มีใบสั่งแบ่งรูปแบบอยู่แล้วโปรดยกเลิกการติ๊กหลังจากลบออก!',
  BatchSend: 'ส่งเป็นกลุ่ม',
  BatchSendCheck: 'กรุณาเลือกค่าธรรมเนียม EAS ที่ต้องการส่ง',
  BatchSendTip: 'สามารถซิงค์ค่าใช้จ่ายที่ยังไม่ได้ตรวจสอบได้เท่านั้น โปรดตรวจสอบสถานะค่าใช้จ่าย',
  PleaseSelectRemovedContainer: 'โปรดเลือกข้อมูลบรรจุภัณฑ์ที่คุณต้องการลบ!',
  PleaseRemovedSplitOrder: 'กรุณาลบใบแบ่งรูปแบบที่เกี่ยวข้องกับการรื้อถอนในปัจจุบันก่อน!',
  ThereAreTheFollowingExceptionsInTheImportDataPleaseCheckTheDataInTheForm: 'มีความผิดปกติดังต่อไปนี้ในการนำเข้าข้อมูลโปรดตรวจสอบข้อมูลในแบบฟอร์ม',
  NoPrimaryTicketIsAssociatedSoTheContainerDataCannotBeImported: 'ไม่มีตั๋วหลักที่เกี่ยวข้องและไม่สามารถนำเข้าข้อมูลสินค้าในกล่องได้',
  ImportContainerInformation: 'มีการนำเข้าข้อมูลสินค้ากล่องหรือไม่',
  SecondLoadingTime: 'การขนส่งบนเรือ',
  SecondDepartureTime: 'เปลี่ยนเที่ยวบิน',
  SecondArrivalTime: 'ส่งต่อไปยังท่าเรือ',
  SecondUnloadingTime: 'การถ่ายโอนข้อมูล',
  TransferModeAtTransferPoint: 'วิธีการถ่ายโอนจุดโอน',
  DispatchVehiclesAtDestination: 'ส่งรถที่ท่าเรือปลายทาง',
  PortOfDestinationServices: 'ท่าเรือปลายทาง',
  Manifest: 'รายการตู้สินค้าล่วงหน้า',
  Other: 'อื่นๆ',
  Temperature: 'อุณหภูมิ',
  OpenVentilation: 'เปิดการระบายอากาศ',
  VentilationQuantity: 'ปริมาณการระบายอากาศ',
  VentilationUnit: 'หน ่ วยการระบายอากาศ',
  FlashPointUnit: 'หน่วยของ flashpoint',
  HazardForm: 'รูปแบบของวัตถุอันตราย',
  AutoSpecialGoods: 'รับข้อมูลการบรรจุสินค้าพิเศษโดยอัตโนมัติ',
  HaveMaintainedSpecialInfo: 'ตรวจพบว่าคุณได้รับการบํารุงรักษาข้อมูลสินค้าพิเศษตามชื่อภาษาอังกฤษและรหัสHSโดยอัตโนมัติได้รับข้อมูลบรรจุภัณฑ์หรือไม่?',
  PackingInformation: 'ได ้ รับข ้ อมูลบรรจุสําเร ็ จ.',
  NoPackingInformation: 'ไม่สามารถรับข้อมูลบรรจุภัณฑ์ได้',
  Humidity: 'ความชื้น%',
  OverSize: 'ขนาดพิเศษ',
  ZYQHG: 'ซ้าย / ขวา / หน้า / หลัง / ไฮเปอร์ (CM)',
  PortOfDestinationCustomsClearance: 'พิธีการศุลกากรที่ท่าเรือปลายทาง',
  DestPortCustomsClearanceInfo: 'ข้อมูลการผ่านพิธีการศุลกากร',
  PleaseSelectData: 'โปรดเลือกข้อมูลที่ระบุ',
  PlateNumberAndBillLadingNumberCannotEmpty: 'หมายเลขทะเบียนรถ และหมายเลข B / L ไม่สามารถเว้นว่างได้',
  LineXQuantityMustGreaterThanZero: 'จำนวนแถวที่ {rowNum} ต้องมากกว่า 0',
  LineXQuantityExceedsMaxValue: 'จำนวนแถว {rowNum} {quantity} เกินค่าสูงสุด {maxValue}',
  LineXWeightMustGreaterThanZero: 'แถวที่ {rowNum} น้ำหนักรวมต้องมากกว่า 0',
  LineXWeightExceedsMaxValue: 'แถวที่ {rowNum} น้ำหนักรวม {weight} เกินค่าสูงสุด {maxValue}',
  LineXCubageMustGreaterThanZero: 'ปริมาณแถวที่ {rowNum} ต้องมากกว่า 0',
  LineXCubageExceedsMaxValue: 'แถว {rowNum} ปริมาตร {cubage} เกินค่าสูงสุด {maxValue}',
  HasExport: 'ส่งออกแล้ว',
  DelegatedAssociatedBusinessStatus: 'สถานะธุรกิจที่เกี่ยวข้อง',
  TransactionRelatedBusinessStatus: 'ติดต่อกลับ สถานะธุรกิจที่เกี่ยวโยงกัน',
  SecondarySynchronization: 'ซิงค์รอง',
  NumberOfCustomsOrders: 'ปิดเอกพจน์',
  CustomerClosingTime: 'เวลาตัดคำสั่งของลูกค้า',
  AddToMainTicket: 'ไม่ว่าจะเป็นการเข้าร่วมตั๋วหลัก',
  CustomsDeclarationRemark: 'หมายเหตุประกาศศุลกากร',
  OperationGuide: 'แนวทางการดำเนินงาน',
  ServiceInformation: 'คู่มือบริการ',
  ScopeServices: 'ขอบเขตการให้บริการ',
  DeletionGuide: 'คู่มือการลบและแก้ไขท่าเรือเซี่ยงไฮ้',
  BusinessData: 'ข้อมูลธุรกิจของท่าเรือเซี่ยงไฮ้',
  SecondVesselInformation: 'ข้อมูลการเดินทางที่สอง',
  vesselText: 'ได้รับผ่านข้อมูลการขนส่งสินค้ากล่องในพื้นที่ท่าเรือไปยังชื่อเรือ: $ {1}, การเดินทาง: $ {2} กับหน้าการจองชื่อเรือ: $ {3}, การเดินทาง: $ {4} ไม่สอดคล้องกันจะเขียนชื่อเรือที่ได้รับจากใบเบิกและล้างข้อมูลการจัดส่งที่ได้รับ?',
  textiles: 'สิ่งทอ',
  nonTextiles: 'ผ้าไม่ทอ',
  importEmpty: 'นำเข้าและล้าง',
  importNotEmpty: 'การนำเข้าไม่ว่างเปล่า',
  ignore: 'ไม่สนใจ',
  empty: 'ว่างเปล่า',
  salveNoDcToKeepMaster: 'หน่วยงานต้นสังกัดนี้ยังไม่มีการรักษาเอกสารที่เกี่ยวข้องและจะรักษาเอกสารหลักไว้หรือไม่?',
  CustomersCollectByBubble: 'การแยกฟองเก็บจากลูกค้า',
  CollectionBySupplier: 'ผู้จัดจำหน่ายแยกเก็บฟอง',
  Slac: 'จำนวนชิ้นเล็ก ๆ ของสินค้า',
  BookingShutOut: 'การจองห้องพักและผ่านด่านศุลกากร',
  tip: 'เคล็ดลับ',
  ShippingCompanyDialogModifyText: 'คุณแก้ไข บริษัท เรือเพื่อล้างข้อมูลท่าเรือปลายทางที่มีอยู่แล้วหรือไม่? หากคุณเปิดบริการติดตามสินค้าของบริษัทเรือ คุณจะสมัครรับข้อมูลเขตท่าเรือที่ลงนามในหน้าการจองอีกครั้ง',
  ShippingCompanyDialogDeleteText: 'คุณได้ลบบริษัทเรือแล้ว คุณลบข้อมูลพื้นที่ท่าเรือปลายทางที่มีอยู่แล้วหรือไม่',
  emptyDestinationInformation: 'ล้าง',
  noEmptyDestinationInformation: 'ไม่ ว่างเปล่า',
  BatchModifyBusiness: 'ธุรกิจปรับเปลี่ยนแบทช์',
  DataAdjustment: 'การปรับข้อมูล',
  OriginalData: 'ข้อมูลเดิม:',
  AfterAdjustment: 'หลังจากปรับ:',
  inputContainerNo: 'กรุณากรอกหมายเลขกล่อง',
  inputSealNo: 'กรุณากรอกหมายเลขซีล',
  BoxType: 'ประเภทกล่อง ประเภทกล่อง',
  BusinessPeopleType: 'พนักงานธุรกิจ',
  clearConfirm: 'ธุรกิจที่ถูกเลือก 【{0}】 【{1}】 ข้อมูลจะถูกล้างได้รับการยืนยันหรือไม่?',
  clearCategoryConfirm: 'ธุรกิจที่ถูกเลือก 【{0}】 ข้อมูลจะถูกล้างได้รับการยืนยันหรือไม่?',
  changeTwoConfirm: 'ข้อมูลที่ถูกเลือก 【{0}】 【{1}】 จะถูกแทนที่ คุณยืนยันหรือไม่?',
  changeOneConfirm: 'ข้อมูลธุรกิจที่ถูกเลือก 【{0}】 จะถูกแทนที่ คุณยืนยันหรือไม่?',
  hasRefreshCharge: 'ตัวแทนจองเรือมีค่าใช้จ่ายอยู่แล้ว จะรีเฟรชค่าใช้จ่ายหรือไม่?',
  SuccessTip: 'สำเร็จ {0} รายการ',
  successTipAlreadyNotEditCharge: 'สำเร็จ {0} รายการ, <br/>คำอธิบาย: <br/> {1} มีค่าใช้จ่ายที่ไม่สามารถแก้ไขได้อยู่แล้ว, กรุณาดำเนินการทันที!',
  hasOneAtleast: 'โปรดลองอีกครั้งหลังจากเลือกอย่างน้อยหนึ่งตัวเลือก!',
  hasOneNoAtleast: 'โปรดลองอีกครั้งหลังจากกรอกข้อมูลอย่างน้อยหนึ่งคอลัมน์!',
  maxSelectBusiness: 'ธุรกิจที่ถูกเลือกมากกว่าแถบ {0} โปรดลองใหม่หลังจากเลือก!',
  requireAllSelect: 'โปรดเลือก {0} และ {1} ที่แก้ไขแล้วลองอีกครั้ง',
  hasOneCategoryAtleast: 'โปรดเลือกข้อมูลที่คุณต้องการเขียน!',
  adjustedDestinationAgent: 'ป้อนตัวแทนท่าเรือปลายทางที่ปรับแล้ว!',
  whetherCoverMBLReceiver: 'ข้อมูลตัวแทนท่าเรือปลายทางที่เลือกจะถูกแทนที่ ให้เขียนทับข้อมูลผู้รับ MBL ด้วยข้อมูลตัวแทนใหม่หรือไม่?',
  lclSlavesJobCannotModify: 'คุณไม่สามารถแก้ไขฟิลด์สำหรับตั๋วขนาดเล็กได้！',
  BusinessNotSameOpAndSalesOffice: 'ธุรกิจ {0} สาขาการดำเนินงานไม่สอดคล้องกับสาขาการขาย',
  SuccessfullyClearXPieces: 'ล้างข้อมูล {0} แถบ {1} เรียบร้อยแล้ว',
  PartSuccessClearXPieces: 'ล้างข้อมูล {0} แถบ {1} สำเร็จ แถบ {2} ล้มเหลว สาเหตุของความล้มเหลว:',
  DataAdjustmentSame: '{0} ข้อมูลก่อนและหลังการปรับมีความสอดคล้องกันและไม่มีการเปลี่ยนแปลงใด ๆ ในเวลานี้',
  DataAdjustmentAgainConfirm: 'ข้อมูลธุรกิจที่ถูกเลือก {0} จะถูกแทนที่ คุณยืนยันหรือไม่?',
  SuccessfullyReplacedXPieces: 'แทนที่ข้อมูล {0} แถบ {1} เรียบร้อยแล้ว',
  NotReplacedXPieces: 'ไม่พบ {0} ที่มีสิทธิ์ 0 รายการถูกแทนที่ในครั้งนี้',
  PartSuccessReplacedXPieces: 'แทนที่ข้อมูล {0} แถบ {1} สำเร็จ, แถบ {2} ล้มเหลว, สาเหตุของความล้มเหลว:',
  BusinessisNotPositiveOperation: 'ธุรกิจ {0} ไม่ใช่การดำเนินงานในเชิงบวก',
  BusinessisBlocked: 'ธุรกิจ {0} ถูกล็อค',
  BusinessisHblLock: 'ธุรกิจ {0}HBL ล็อคแผ่น',
  BusinessisInvalidLoadType: 'ประเภทธุรกิจ {0} ประเภทการรวมทั้งหมดไม่ใช่ LCL ที่ได้รับมอบหมาย',
  BusinessisContainerExist: 'ธุรกิจ {0} มีการปรับเปลี่ยนประเภทของกล่องแล้ว',
  BusinessPicecNotMatch: 'ธุรกิจ {0} ไม่มีกล่องประเภทกล่องที่สอดคล้องกับข้อมูลดิบ',
  BusinessisMblHblContainerExist: 'ธุรกิจ {0} เข้าร่วม MBL รื้อถอน แยกเดี่ยว / HBL แยกเดี่ยว / แบบฟอร์ม',
  BusinessisContainerSealNoExist: 'ธุรกิจ {0} กรอกหมายเลขกล่องแล้ว',
  BusinessisTruckingContainerExist: 'ธุรกิจ {0} ข้อมูล Gatepoint ที่เกี่ยวข้อง',
  BusinessisDischarginTruckingExist: 'ธุรกิจ {0} การจัดส่งไปยังท่าเรือปลายทางที่เกี่ยวข้อง',
  BusinessisAmsContainerExist: 'Business {0} รายการต่อต้านการก่อการร้ายที่เกี่ยวข้อง',
  CopyFailedBusinessNumber: 'คัดลอกหมายเลขธุรกิจที่ล้มเหลวในคลิกเดียว',
  PackagingCategoryOfDangerousGoods: 'ประเภทบรรจุภัณฑ์สินค้าอันตราย',
  CargoReleaseWay: 'วิธีการวางสินค้า',
  WarehouseLoadingRemarks: 'หมายเหตุอุปกรณ์ในคลังสินค้า',
  CheckStatuses: 'สถานะติ๊ก:',
  ClearStatuses: 'ล้างติ๊ก:',
  SelectAtLeastOneAdjustment: 'โปรดเลือกอย่างน้อยหนึ่งรายการหลังจากปรับเนื้อหาแล้วลองอีกครั้ง!',
  ClearStateComfirm: 'สถานะ Tick Business {0} จะถูกล้าง ยืนยันหรือไม่?',
  CheckStateComfirm: 'สถานะติ๊กของธุรกิจ {0} จะถูกติ๊ก คุณยืนยันหรือไม่?',
  SuccessfullyCancelXPieces: 'ยกเลิกข้อมูลแถบ {0} เรียบร้อยแล้ว',
  SuccessfullyCheckXPieces: 'ทำการติ๊กข้อมูลแถบ {0} เรียบร้อยแล้ว',
  PartSuccessClearXThePieces: 'ล้างข้อมูลแถบ {0} สำเร็จ, แถบ {0} ล้มเหลว, สาเหตุของความล้มเหลว:',
  PartSuccessCheckXThePieces: 'ทำการติ๊กข้อมูล {0} รายการได้สำเร็จ, ล้มเหลว {1} รายการ, สาเหตุของความล้มเหลว:',
  BusinessisCargoDocLock: 'ธุรกิจ {0} ล็อคแผ่น',
  DataCategoryProcessingFailed: 'การประมวลผลหมวดหมู่ข้อมูลล้มเหลว',
  PleaseSelectATemplate: 'โปรดเลือกแม่แบบ',
  PleaseSelectANode: 'โปรดเลือกโหนด',
  PleaseSelectAState: 'กรุณาเลือกสถานะ',
  SuccessModifiedXBusinessState: 'แก้ไขสถานะธุรกิจแถบ {0} เรียบร้อยแล้ว',
  SuccessWithdraw: 'ถอนไปแล้ว {0} รายการ',
  PleaseSpecificTemplateFilePreview: 'กรุณาเลือกไฟล์แม่แบบที่เฉพาะเจาะจงสำหรับตัวอย่าง!!!',
  CopyLast: 'คัดลอกล่าสุด',
  WaybillNumberCopy: 'สำเนาหมายเลขเดียว',
  CargoInformation: 'ข้อมูลสินค้า',
  BillOfLadingQuantity: 'จำนวนชิ้น B / L',
  Packing: 'การบรรจุ',
  PleaseChoose: '-- กรุณาเลือก --',
  CustomerType: 'ประเภทลูกค้า',
  HTSCode: 'หมายเลข HTS',
  EnglishCommodityName: 'ชื่อภาษาอังกฤษ',
  TransportationInformation: 'ข้อมูลการขนส่ง',
  MBLNumber: 'หมายเลข MB/L',
  HBLNumber: 'หมายเลข HB / L',
  CCNNumber: 'หมายเลข CCN',
  ShipName: 'ชื่อเรือ',
  ShipNumber: 'หมายเลขเรือ',
  PortArrivalDate: 'วันที่มาถึงท่าเรือ',
  CountryOfOrigin: 'ประเทศต้นกำเนิด',
  BillLadingPlaceOfDispatch: 'สถานที่จัดส่ง B / L',
  BillLadingPortOfDeparture: 'ท่าเรือเริ่มต้นของ B / L',
  BillLadingPortOfDischarge: 'ท่าเรือขนส่งสินค้า B / L',
  BillLadingPlaceOfDelivery: 'สถานที่จัดส่ง B / L',
  LastOverseasPort: 'ท่าเรือนอกประเทศล่าสุด',
  FirstPortOfCall: 'ท่าเทียบเรือแห่งแรก',
  SynchronizeHBLInformation: 'ซิงค์ข้อมูล HBL',
  addHbl: 'เพิ่มรายการคะแนน',
  NonVesselCarrierSCAC: 'ผู้ให้บริการเรือ SCAC',
  DeclarationAccount: 'บัญชีประกาศ',
  DeclarationType: 'ประเภทการประกาศ',
  DirectToTheUnitedStates: 'ส่งตรงไปยังสหรัฐอเมริกา',
  ToTheInlandWarehouse: 'ไปยังคลังสินค้าต่างจังหวัด',
  TransferClearancePullToStates: 'ส่งต่อในแคนาดาโดยไม่ต้องผ่านพิธีการศุลกากรดึงไปยังสหรัฐอเมริกา',
  CargoThroughTheUnitedStates: 'เส้นทางขนส่งสินค้า สหรัฐอเมริกา',
  ContainerInformation: 'ข้อมูลการบรรจุ',
  AddContainerInformation: 'เพิ่มข้อมูลการบรรจุ',
  RemoveContainerInformation: 'ลบข้อมูลบรรจุภัณฑ์',
  BoxSpecies: 'ชนิดของกล่อง',
  BoxHeight: 'ความสูงของกล่อง',
  ContainerNumber: 'หมายเลขกล่อง',
  SealNumber: 'หมายเลขซีล',
  CommodityName: 'ชื่อสินค้า',
  PleaseEnterTheCommodityNameOrHSCode: 'กรุณากรอกชื่อสินค้าหรือรหัส HS',
  ShippingCompanyContractNoRequired: 'เลขที่สัญญาบริษัทเรือไม่สามารถเว้นว่างได้',
  ApplicableRoutesNoRequired: 'เส้นทางที่ใช้บังคับไม่สามารถว่างได้',
  ShippingCompanyNoRequired: 'บริษัทเรือห้ามเว้นว่าง',
  ValidityNoRequired: 'ระยะเวลาที่มีผลห้ามเว้นว่าง',
  ShippingCompanyAndBaseDifferent: 'บริษัทเรือในสัญญานี้ไม่ตรงกับข้อมูลที่กรอกในแท็บพื้นฐาน ยืนยันการเขียนทับหรือไม่?',
  GiveUp: 'ยกเลิก',
  BackFillToRoute: 'หมายเลขสัญญานี้มีเส้นทางที่ใช้ได้หลายเส้นทาง โปรดเลือกเส้นทางที่จะเติมกลับไปยังแท็บพื้นฐาน',
  MultipleApplicableRoutesDifferent: 'หมายเลขสัญญานี้มีเส้นทางที่ใช้ได้หลายเส้นทางและทั้งหมดแตกต่างจากข้อมูลในแท็บพื้นฐาน โปรดเลือกเส้นทางที่จะเติมกลับไปยังแท็บพื้นฐาน',
  ApplicableRoutesDifferent: 'เส้นทางที่ใช้ได้ทั้งหมดของหมายเลขสัญญานี้แตกต่างจากข้อมูลในแท็บพื้นฐาน ยืนยันการเขียนทับหรือไม่?',
  ShippingCompanyDifferent: 'บริษัทเรือที่คุณเลือกไม่ตรงกับบริษัทเรือที่ใช้ได้ของสัญญาที่เลือก ยืนยันการเขียนทับหรือไม่?<br/><span style=\'color:red\'>{0}</span>',
  AirlineDifferent: 'เส้นทางท่าเรือที่คุณเลือกไม่ตรงกับเส้นทางที่ใช้ได้ของสัญญาที่เลือก ยืนยันการเขียนทับหรือไม่?<br/><span style=\'color:red\'>{0}</span>',
  EtdDifferentValidityPeriod: 'ETD ที่คุณเลือกไม่สอดคล้องกับระยะเวลาที่มีผลของสัญญา ยืนยันการเขียนทับหรือไม่?<br/><span style=\'color:red\'>{0}</span>',
  ValidityPeriodCannotCoverETD: 'ระยะเวลาที่มีผลของสัญญาที่เลือกไม่ครอบคลุม ETD ยืนยันการเขียนทับหรือไม่?<br/><span style=\'color:red\'>{0}</span>',
  DoNotBackFill: 'ไม่เติมกลับ',
  ValidPeriodMessage: 'ระยะเวลาที่มีผลของสัญญา: {0}',
  ValidPeriodEtdMessage: 'ระยะเวลาที่มีผลของสัญญา: {0}, ETD: {1}',
  NumberApplicableToShippingCompany: 'บริษัทเรือที่ใช้ได้ของสัญญา: {0}',
  NumberApplicableToAirline: 'เส้นทางที่ใช้ได้ของสัญญา: {0}',
  PleaseToDeleteTheContract: 'คุณแน่ใจหรือไม่ที่จะลบหมายเลขสัญญาที่เลือกไว้ {0} รายการ? การดำเนินการนี้ไม่สามารถยกเลิกได้',
  ScNoIsUsed: 'หมายเลขนัดหมายนี้ถูกใช้งานแล้ว ไม่สามารถลบได้',
  BeginDateNotLessThanEndDate: 'วันที่เริ่มต้นมีผลไม่สามารถเป็นหลังวันที่สิ้นสุดได้',
  ConfirmEnableTips: 'เมื่อเปิดใช้งานแล้ว ผู้ใช้จะสามารถเลือกหมายเลขสัญญานี้ในหน้ารายละเอียดออร์เดอร์ได้ ยืนยันการเปิดใช้งาน?',
  EnableTips: 'สามารถเปิดใช้งานได้ก็ต่อเมื่อหมายเลขสัญญาทั้งหมดที่เลือกอยู่ในสถานะปิดใช้งาน',
  DisEnableTips: 'เมื่อปิดใช้งานแล้ว หมายเลขสัญญานี้จะไม่สามารถเลือกได้ในรายละเอียดออร์เดอร์ ยืนยันการปิดใช้งาน?',
  ConfirmDisEnableTips: 'สามารถปิดใช้งานได้ก็ต่อเมื่อหมายเลขสัญญาทั้งหมดที่เลือกอยู่ในสถานะเปิดใช้งาน',
  ContractRatePropertyRequired: 'คุณลักษณะอัตราสัญญาไม่สามารถเว้นว่างได้',
  NACRequired: 'ไม่สามารถเว้นว่างได้',
  CommodityNameRequired: 'ชื่อสินค้าไม่สามารถเว้นว่างได้',
  ContractNumberRequired: 'หมายเลขสัญญาของบริษัทเรือมีอยู่แล้ว',
  PleaseSelectAirLine: 'กรุณาเลือกเส้นทางเดินเรือ (สามารถเลือกได้หลายรายการ)',
  PleaseInputNumber: 'กรุณากรอกตัวเลข',
  CargoInsuranceQuantityRequired: 'จำนวนประกันสินค้าไม่สามารถเว้นว่างได้',
  CargoInsuranceUnitRequired: 'หน่วยประกันสินค้าไม่สามารถเว้นว่างได้',
  SendingStatus: 'สถานะการส่ง',
  SendingStatusUpdateTime: 'ส่งเวลาอัปเดตสถานะ',
  CancellationStatus: 'สถานะการยกเลิก',
  Notifier: 'แจ้งโดย',
  SecondNotifier: 'ประกาศฉบับที่ 2',
  ShippingAndReceivingInformation: 'การรับ-ส่งข้อมูล',
  ShipperName: 'ชื่อผู้จัดส่ง',
  CompanyTitle: 'เงยหน้าขึ้น',
  Address: 'ที่อยู่',
  Phone: 'โทรศัพท์',
  Optional: 'ไม่จำเป็น',
  ConsigneeName: 'ชื่อผู้รับ',
  NotifierName: 'ชื่อผู้แจ้ง',
  SecondNotifierName: 'ชื่อผู้แจ้งที่สอง',
  BatchModifyDestinationPortInformation: 'แก้ไขข้อมูลท่าเรือปลายทางเป็นชุด',
  OverseasWarehouseNonAmazonWarehouse: 'คลังโอนต่างประเทศไม่ใช่คลัง Amazon',
  SelectedBePositivePleaseSelect: 'ธุรกิจที่เลือกจะต้องดำเนินการในเชิงบวกโปรดเลือกใหม่!',
  DomesticWarehouse: 'คลังสินค้าในประเทศ',
  OverseasWarehouse: 'คลังสินค้าต่างประเทศ',
  ContainerNumber2: 'หมายเลขกล่อง:',
  ContainerNumberContainerNoNull: 'หมายเลขกล่อง: containerNoNull',
  Exceeded: 'เกิน',
  CancelCustomsReturn: 'การยกเลิกพิธีการศุลกากร',
  AttachmentContentTooLarge: 'เนื้อหาอุปกรณ์เสริมมีขนาดใหญ่เกินไป',
  LockedPleaseContactSupervisorUnlock: 'ถูกล็อคและไม่สามารถพิมพ์ได้ติดต่อผู้บังคับบัญชาระดับสูงเพื่อปลดล็อค!',
  FCLProfitPrinting: 'การพิมพ์กำไร FCL',
  LCLProfitPrinting: 'การพิมพ์กำไร LCL',
  DueToPrintOrUnlock: 'แคชเชียร์เช็คถูกล็อคเนื่องจากไม่มีการควบคุมเครดิตและไม่สามารถพิมพ์หรือ EDI ได้ โปรดติดต่อผู้บังคับบัญชาเพื่อปลดล็อคเมื่อจำเป็น!',
  FeeName: 'ชื่อค่าธรรมเนียม',
  BatchFeeScheme: 'โปรแกรมค่าธรรมเนียมจำนวนมาก',
  NoCostCanBeTranscribed: 'ไม่มีค่าใช้จ่ายในการคัดลอก',
  ThisBeenSentEDIAllowed: 'ข้อมูลรายการสินค้าถูกส่งไปยัง EDI แล้วและไม่ได้รับอนุญาตให้ลบ',
  TheVoidedAndCannotAgain: 'รายการนี้เป็นโมฆะและไม่สามารถเป็นโมฆะได้อีก',
  ShanghaiManifestShippingCompany: 'Shanghai Manifold บริษัท เรือ:',
  NoResultsFound: 'ยังไม่มีการสอบถามถึงผลลัพธ์',
  ExportClearanceNewRegulation: 'กฎระเบียบใหม่สำหรับการปล่อยการส่งออก',
  ShanghaiAfterClearanceManifestContinuing: 'คำสั่งของศุลกากรเซี่ยงไฮ้ 172 เปลี่ยนเงื่อนไขการปล่อยการส่งข้อมูลการปล่อยทะเลไปยังท่าเทียบเรือพร้อมกับ "รายการสินค้าโหลด" โปรดติดตามสถานะของรายการโหลดด้วยตนเองหลังจากประกาศศุลกากรเสร็จสิ้น ความผิดปกติติดต่อฝ่ายบริการลูกค้าเพื่อยืนยันทันที เมื่อถึงเวลานั้นรายการซ้ำซ้อนใน LCL ไม่ถูกลบออกในเวลาตกสินค้าไม่ทันเวลาการประกอบที่ไม่ได้มาตรฐานหลังจากการปล่อยการปรับเปลี่ยนข้อมูลรายการสินค้าไม่ประสบความสำเร็จการผสมและการใช้ซ้ำของหมายเลข B / L ภายในสองปีจะมีผลต่อการโหลด ประการที่สอง หลังจากรายการโหลดได้รับการตอบกลับตามปกติแล้ว หากพบสถานการณ์ใด ๆ ที่รายการโหลดล่วงหน้าจําเป็นต้องแก้ไข ลบหรือเพิ่มรายการใหม่ คุณต้องติดต่อตัวแทนเรือเพื่อลบรายการโหลดก่อนแล้วจึงดําเนินการต่อไป',
  YangshanDistrictNovember152021: 'เขตกวนหยางซาน: 15 พฤศจิกายน 2021',
  WaigaoqiaoDistrictNovember222021: 'เขตหว้ากังวาน 22 พฤศจิกายน 2564',
  GarbageManifest: 'รายการถังขยะ',
  N1YourGoodsAreManifest: '1. รายการขยะศุลกากรห้ามอย่างเคร่งครัด! ตามระเบียบของศุลกากร ตั๋วแต่ละใบที่ประกอบไว้ล่วงหน้าจะต้องสอดคล้องกับหนึ่งตั๋วสําหรับสินค้าที่จัดส่งจริง หลังจากส่งรายการสินค้าแล้ว หากสินค้าของคุณไม่ได้รับการจัดส่ง (ไม่ทันเรือ เปลี่ยนแปลงกำหนดการจัดส่ง เป็นต้น) รายการตั๋วดังกล่าวจะถือเป็นรายการถังขยะ!',
  N2StowManifestMustSent: '2. ตัวอย่างกรณีของรายการขยะ: หลังจากเรือเปลี่ยนรายการล่วงหน้าเดิมจะต้องถูกลบออกและหลังจากลบรายการล่วงหน้าใหม่จะถูกส่ง!',
  N3OnTheFreightManifest: '3. ผลที่ตามมาของการไม่ได้ลบรายการขยะ: ไม่เพียง แต่จะส่งผลกระทบต่อการโหลดศุลกากรสูงสุดยังสามารถปรับ 50,000 หยวนสำหรับผู้ส่งและตัดสิทธิ์การประกาศศุลกากร! หลังจากรายการถังขยะปรากฏขึ้นโปรดติดต่อฝ่ายบริการลูกค้าเพื่อช่วยในการลบรายการถังขยะ!',
  BusinessNotSelected: 'ธุรกิจไม่ได้เลือก',
  DoNotImportAndSend: 'นำเข้าไม่ส่ง',
  ViewReceipt: 'ดูการตอบกลับ',
  ImportEXCEL: 'นำเข้า EXCEL',
  Receipt: 'ตอบกลับ',
  ReceiptNumber: 'หมายเลขการตอบกลับ',
  Time: 'เวลา',
  PleaseSelectAccount: 'กรุณาเลือกบัญชี',
  MappingValueNotEmpty: '{0} ไม่สามารถว่างได้โปรดกำหนดค่ารหัสแผนที่สำหรับ {0} ในการจัดการแผนที่',
  AfrFieldNotEmpty: '{0} ไม่สามารถว่างได้',
  AfrEfreightDgTip: 'สินค้าอันตรายไม่สามารถใช้โหมดการจัดส่งโดยตรงได้ โปรดเปลี่ยนกลับไปใช้โหมดการจัดส่งแบบอ้อมแทน และกรุณาเพิ่มเติมข้อมูลสินค้าอันตรายใน YiFei',
  AfrFieldNotAccess: 'ไม่เกิน {0} ตัวอักษร',
  CustomerNumberCannotBeEmpty: '【ข้อมูลลูกค้า】 หมายเลขย่อย AMS ไม่สามารถว่างได้',
  CustomerNOCannotBeEmpty: '【ข้อมูลลูกค้า】 MB/L NO ไม่สามารถว่างได้',
  CustomerPortCannotBeEmpty: '【ข้อมูลลูกค้า】 พอร์ตขนถ่ายสินค้าต้องไม่ว่างเปล่า',
  CustomerDeliveryCannotBeEmpty: '【ข้อมูลลูกค้า】 สถานที่จัดส่งต้องไม่ว่างเปล่า',
  AMSNumber: 'หมายเลข AMS',
  AFRNumber: 'หมายเลข AFR',
  ACINumber: 'หมายเลข ACI',
  EManifestNumber: 'หมายเลข eManifest',
  SendSucceeded: 'ส่งเรียบร้อยแล้ว',
  NotSent: 'ยังไม่ได้ส่ง',
  ServiceChannel: 'ช่องทางการให้บริการ',
  ExpectedAmazonWarehouseEntryTime: 'คาดว่าจะเข้าสู่ Amazon Position Time',
  DestinationDeliveryMethod: 'วิธีการจัดส่งปลายทาง',
  CourierCompany: 'บริษัท เอ็กซ์เพรส',
  TrackingNumber: 'หมายเลขเอกสารด่วน',
  POoriginalNumber: 'PO (เดิมหมายเลขเดียว)',
  CustomsDeclarationMethod: 'วิธีการประกาศศุลกากร',
  CustomsClearanceMethod: 'วิธีการพิธีการศุลกากร',
  EORIEnterpriseNumber: 'หมายเลขธุรกิจ EORI',
  VATTaxNumber: 'เลขประจำตัวผู้เสียภาษี',
  VATRegistrationCountry: 'ประเทศที่ลงทะเบียน VAT',
  VATRegistrationAddress: 'ที่อยู่ลงทะเบียน VAT',
  VATCompanyEnglishName: 'บริษัท VAT ชื่อภาษาอังกฤษ',
  WithPower: 'ไฟฟ้า',
  WithMagnet: 'ด้วยแม่เหล็ก',
  Powder: 'ผง',
  Liquid: 'ของเหลว',
  EstimatedWarehouseEntrygoodArrivalTime: 'คาดว่าจะเข้าคลังสินค้า / เวลาการจัดส่งที่ดี',
  RemoteWarehouse: 'โพซิชั่นที่ห่างไกล',
  OceanFreight: 'ค่าขนส่งทางทะเล',
  ServiceChannel2: 'ช่องทางการให้บริการ:',
  FeeType: 'ประเภทค่าธรรมเนียม:',
  EstimatedAmount: 'จำนวนเงินโดยประมาณ:',
  Equivalent: 'พับ',
  FreightRateLevel: 'ระดับค่าจัดส่ง:',
  BillingWeight: 'น้ำหนักการเรียกเก็บเงิน:',
  CalculationMethod: 'วิธีการคำนวณ:',
  EstimatedTimeCannotBeEmpty: 'คาดว่าจะเข้าสู่ตำแหน่ง / การจัดส่งที่ดีไม่สามารถว่างเปล่า!',
  DestinationCannotBeEmpty: 'ปลายทางต้องไม่ว่างเปล่า!',
  DestinationCountryCannotBeEmpty: 'ประเทศปลายทางต้องไม่ว่างเปล่า!',
  ZipCodeCannotBeEmpty: 'รหัสไปรษณีย์ไม่สามารถว่างเปล่า!',
  CannotBeEmpty: 'ว่างเปล่าไม่ได้!',
  PleaseTheConsignorUnitFirst: 'โปรดเลือกหน่วยที่รับผิดชอบก่อน',
  DearAndThenCarryOperation: 'โปรโปรดบันทึกธุรกิจก่อนแล้วจึงดำเนินการจัดส่งอัตโนมัติ',
  ClearanceMethod: 'วิธีการพิธีการศุลกากร',
  EstimatedStorageReadyGoodsTime: 'คาดว่าจะเข้าคลังสินค้า / เวลาการจัดส่งที่ดี',
  ForeignWarehouse: 'คลังสินค้าต่างประเทศ',
  WithElectricity: 'ไฟฟ้า',
  WithMagnetism: 'ด้วยแม่เหล็ก',
  YourPieceWeightAndTo: 'สินค้าของคุณมีส่วนร่วมในการเปรียบเทียบข้อมูลและ Autocartoning จะอัปเดตข้อมูลเกี่ยวกับแคชเชียร์เช็คและตั๋วหลักที่อยู่',
  Prompt: 'เคล็ดลับ',
  GotIt: 'รู้แล้ว',
  DocumentNumber: 'หมายเลขเอกสาร',
  Origin: 'สถานที่กำเนิด',
  AreaCode: 'รหัสพื้นที่',
  BoxAndCargoInformationFunction: 'ข้อมูลการจัดส่งกล่องไม่สอดคล้องกันโปรดยืนยันข้อมูลถูกต้องหรือไม่? ข้อมูลการจัดส่งกล่องสามารถแก้ไขได้โดยไปที่ป้ายหน้าพื้นฐานหรือจับคู่ข้อมูลการจัดส่งกล่องผ่านฟังก์ชั่น 【ปรับปรุงข้อมูลพื้นที่ท่าเรือ】',
  InconsistencyBetweenPortAreaDataAndPackingInformationTips: 'ข้อควรระวัง: เมื่อข้อมูลของเขตท่าเรือไม่สอดคล้องกับข้อมูลการบรรจุหีบห่ออาจทำให้การแจ้งเตือนการเตือนภัยล่วงหน้าการแจ้งเตือนที่เกี่ยวข้องกับการตั้งค่า SOP ไม่สามารถผลักดันได้',
  TheComparisonFunctionToPossible: 'ได้รับข้อมูลการจัดส่งล่าสุดของ Harbour Area โปรดเลือกข้อมูลการจัดส่งที่คุณต้องการโดยเร็วที่สุดโดยใช้ 【ปรับปรุงข้อมูลพื้นที่ท่าเรือ】',
  DetectionOfBasicTab: 'ตรวจพบลายเซ็นหน้าเบื้องต้น',
  InconsistentThePortAreaReturn: 'เดินทางกลับจาก อ.ท่าเรือ',
  PleaseTheOperationIsCorrect: 'ไม่สอดคล้องกัน',
  YouBoxAndCargoTab: 'กรุณาไปที่ 【ข้อมูลการบรรจุ】 เพื่อตรวจสอบทันที',
  BoxNum: 'หนึ่งกล่อง',
  GoCheck: 'ไปตรวจสอบ',
  BoxQuantity: 'ปริมาณกล่อง',
  BoxModel: 'ประเภทกล่อง',
  CutOffDate: 'วันที่ตัดตอน',
  PortOpeningTime: 'เวลาเปิดท่าเรือ',
  PortOpeningDate: 'วันที่เปิดท่าเรือ',
  ScheduledBerthingTime: 'วางแผนเวลาเทียบท่า',
  ScheduledDepartureTime: 'กำหนดเวลาเดินเรือ',
  ActualUnloadingTime: 'เวลาขนถ่ายจริง',
  ActualHeavyLiftingTime: 'เวลายกจริง',
  ActualEmptyReturnTime: 'เวลาคืนพื้นที่จริง',
  PleasePackingInformationToRemoved: 'โปรดเลือกข้อมูลบรรจุภัณฑ์ที่คุณต้องการลบ!',
  BillOfLadingType: 'ประเภท B / L',
  ArrivalDate: 'วันที่มาถึงท่าเรือ',
  ShippingType: 'ประเภทการจัดส่ง',
  DischargingPort: 'ท่าเรือขนถ่ายสินค้า',
  DeliveryPlace: 'สถานที่จัดส่ง',
  CustomerShippingInformation: 'ข้อมูลการจัดส่งลูกค้า',
  CargoReceiver: 'ผู้รับสินค้า',
  Buyer: 'ผู้ซื้อ',
  Modify: 'การปรับเปลี่ยน',
  PleaseSelectABox: 'กรุณาเลือกกล่อง',
  ReleaseOrderNumber: 'ใส่หมายเลขแผ่น:',
  ExportReleaseNewRegulation: 'กฎระเบียบใหม่สำหรับการปล่อยการส่งออก',
  WechatPrompt: 'ขอให้ผู้ใช้แต่ละคนที่ต้องการเปิดไปที่การตั้งค่าและเครื่องมือ-ข้อมูลส่วนบุคคล เปิดการอนุญาตผลักดันข้อความ WeChat และติดตามบัญชีทางการ',
  YangshanAreaNovember152021: 'เขตกวนหยางซาน: 15 พฤศจิกายน 2021',
  WaigaoqiaoAreaNovember222021: 'เขตหว้ากังวาน 22 พฤศจิกายน 2564',
  GarbageCargoManifest: 'รายการถังขยะ',
  N1ActuallyShippedIfGarbage: '1. รายการขยะศุลกากรห้ามอย่างเคร่งครัด! ตามระเบียบของศุลกากร ตั๋วแต่ละใบที่ประกอบไว้ล่วงหน้าจะต้องสอดคล้องกับหนึ่งตั๋วสําหรับสินค้าที่จัดส่งจริง หลังจากส่งรายการสินค้าแล้ว หากสินค้าของคุณไม่ได้รับการจัดส่ง (ไม่ทันเรือ เปลี่ยนแปลงกำหนดการจัดส่ง เป็นต้น) รายการตั๋วดังกล่าวจะถือเป็นรายการถังขยะ!',
  N2ManifestMustBeDeletion: '2. ตัวอย่างกรณีของรายการขยะ: หลังจากเรือเปลี่ยนรายการล่วงหน้าเดิมจะต้องถูกลบออกและหลังจากลบรายการล่วงหน้าใหม่จะถูกส่ง!',
  N3YuanOnTheManifest: '3. ผลที่ตามมาของการไม่ได้ลบรายการขยะ: ไม่เพียง แต่จะส่งผลกระทบต่อการโหลดศุลกากรสูงสุดยังสามารถปรับ 50,000 หยวนสำหรับผู้ส่งและตัดสิทธิ์การประกาศศุลกากร! หลังจากรายการถังขยะปรากฏขึ้นโปรดติดต่อฝ่ายบริการลูกค้าเพื่อช่วยในการลบรายการถังขยะ!',
  DetailsOfSeaExportGoods: 'รายละเอียดของสินค้าส่งออกทางทะเล',
  PleaseSelectTheSpecifiedData: 'โปรดเลือกข้อมูลที่ระบุ',
  LicenseOfLadingNumberEmpty: 'หมายเลขทะเบียนรถ และหมายเลข B / L ไม่สามารถเว้นว่างได้',
  NoRelevantInformation: 'ขณะนี้ยังไม่มีข้อมูลที่เกี่ยวข้อง',
  EstimatedDeliveryTime: 'คาดว่าเวลาจัดส่ง',
  ActualDeliveryTime: 'เวลาจัดส่งจริง',
  ObtainedContainerAndGoodsData: 'ชื่อเรือที่คุณป้อน',
  Sailing: 'การเดินทาง:',
  WithBookingTab: 'การเดินทางกับชื่อเรือที่ได้รับจากเขตท่าเรือ',
  InconsistentFromTheBillData: 'ไม่สอดคล้องกันนำเข้าเส้นทางชื่อเรือที่ได้จากเขตท่าเรือและล้างข้อมูลระยะเวลาเรือที่จะได้รับหรือไม่',
  InconsistentFromTheBillDataTips: 'หมายเหตุ: หากการเดินทางที่ไม่ถูกต้องของชื่อเรืออาจนำไปสู่การได้รับเวลาที่ไม่ถูกต้องที่สอดคล้องกัน (เวลาออกเดินทางที่วางแผนไว้เวลาเปิดท่าเรือและเวลาออกเดินทางจริง)',
  TheTicketIsNotImport: 'ตั๋ว MBL สำหรับสถานะเดียวไม่ได้เริ่มต้นและไม่สามารถนำเข้าได้',
  Correction: 'การแก้ไข',
  ThisItIs1Again: 'งานนี้ {0} ได้ส่ง EDI จองเรียบร้อยแล้ว << br>การส่งครั้งนี้คือ {1}- {2}, <br> กรุณายืนยันหากคุณต้องการส่งอีกครั้ง?',
  PleaseOnePieceOfData: 'กรุณาเลือกข้อมูล!',
  BatchImport: 'นำเข้า-มาก',
  GoodsInformationImport: 'นำเข้า-สินค้า',
  SeaFreight: 'ค่าขนส่งทางทะเล',
  AirFreight: 'ค่าธรรมเนียมการขนส่งทางอากาศ',
  Freight: 'ค่าจัดส่ง',
  BatchCostScheme: 'โปรแกรมค่าธรรมเนียมจำนวนมาก',
  Shanghai: 'เซี่ยงไฮ้',
  Qingdao: 'ชิงเต่า',
  SeaguardianSupportsSM2WeighingMethod: 'ช่อง Sea Butler รองรับวิธีการชั่งน้ำหนัก SM2 เท่านั้น',
  ContainerNumberSealNumber: 'หมายเลขกล่อง - หมายเลขซีล',
  DueCannotBePrintedNeeded: 'แคชเชียร์เช็คถูกล็อคเนื่องจากไม่มีการควบคุมเครดิตและไม่สามารถพิมพ์หรือ EDI ได้ โปรดติดต่อผู้บังคับบัญชาเพื่อปลดล็อคเมื่อจำเป็น!',
  LockedContactTheSuperiorUnlock: 'ถูกล็อคและไม่สามารถพิมพ์ได้ติดต่อผู้บังคับบัญชาระดับสูงเพื่อปลดล็อค!',
  ModificationSuccessful: 'แก้ไขสำเร็จ',
  StatusConversionSuccessful: 'เปลี่ยนสถานะสำเร็จ',
  NoDeclarationFormCreated: 'ไม่มีการสร้างใบศุลกากร',
  Cleared: 'รวบรวมแล้ว',
  Uncleared: 'ไม่เก็บ',
  SentOut: 'ส่งแล้ว',
  TakenOver: 'รายการที่ได้รับ',
  Filed: 'ยื่นแล้ว',
  TaxRefunded: 'ขอคืนภาษี',
  ReturnedbyOurCompany: 'เรียกคืน (สาขาของเรา)',
  ReturnedtoTheCustomer: 'คืนเงิน (ลูกค้า)',
  WithdrawalOfDocumentStatus: 'การถอนสถานะเอกสาร',
  DocumentStatus: 'สถานะเอกสาร',
  SendOut: 'ส่งออก',
  Archive: 'แฟ้มจัดเก็บ',
  RefundTax: 'การขอคืนภาษี',
  RetrieveourCompany: 'การรับคืน (สาขาของเรา)',
  Returncustomer: 'การคืนเงิน (ลูกค้า)',
  StateNotSelected: 'ยังไม่ได้เลือกสถานะ',
  DateNotSelected: 'ยังไม่มีการเลือกวันที่',
  WithdrawalSuccessful: 'การถอนเงินสำเร็จ',
  NoDataSelected: 'ยังไม่มีการเลือกข้อมูล',
  PleaseANewDeclarationForm: 'กรุณาสร้างใบศุลกากรใหม่',
  NoDataModified: 'ไม่มีการแก้ไขข้อมูล',
  SavedSuccessfully: 'บันทึกความสำเร็จ',
  BatchIsInconsistentPleaseSelect: 'สถานะการพิมพ์แบทช์ไม่สอดคล้องกันโปรดเลือกใหม่',
  NoDataAvailableForPrinting: 'ไม่มีข้อมูลให้พิมพ์',
  Document: 'เอกสารประกอบ',
  Date: 'วันที่',
  NoFilesAvailable: 'ไม่มีเอกสาร',
  Takeover: 'เชื่อมต่อเดี่ยว',
  Retrieve: 'การรับคืน',
  FileNotSelected: 'ยังไม่มีการเลือกแฟ้ม',
  NoTemplateFound: 'ไม่พบ',
  ForTheCorrespondingPrint: 'แม่แบบการพิมพ์ที่สอดคล้องกัน',
  BookingAPI: 'จองห้องพัก API',
  BillOfLadingAPI: 'API ของ B / L',
  PleaseTheBusinessToSend: 'โปรดเลือกธุรกิจที่คุณต้องการส่ง!',
  ContainerQuantity: 'จำนวนกล่อง',
  BookingEdiSendingChannel: 'ช่องจอง EDI',
  BookingEdiSendingTime: 'จองเวลา EDI',
  EdiStateQuery: 'สอบถามสถานะ EDI',
  JiLianStar: 'Jilian ใหม่',
  NotBeSent: '(หมายเหตุ: ไม่มีการส่งในบรรทัดนี้)',
  FullyStored: 'เข้าคลังอย่างสมบูรณ์',
  CancelFullWarehousing: 'ยกเลิกการเข้าคลังเต็มรูปแบบ',
  StoredTipOne: 'รายการ Position ที่ หมายเลขธุรกิจ {0} รวม {1} รายการ',
  StoredTipTwo: 'ยืนยันการดำเนินการ {0}?',
  StoredTipThree: 'โปรดเลือกข้อมูลที่มีสถานะเป็น 【{0}】',
  StoredTipFour: 'รายการสินค้าขาเข้าของธุรกิจตั๋วนี้ถูกเก็บไว้ในคลังสินค้าอย่างสมบูรณ์!',
  SelectedRightData: 'โปรดเลือกข้อมูลที่มีคุณสมบัติเหมาะสม',
  EmptyContainerNotificationTime: 'เวลาแจ้งตู้เปล่า',
  WaitBookingVerifyBatch: 'ในการตรวจสอบจำนวนมากโปรดรอสักครู่และจะแจ้งเตือนคุณเมื่อการตรวจสอบประสบความสำเร็จ',
  BookingVerifyBatch: 'ธุรกิจการตรวจสอบจำนวนมากต้องไม่เกิน 500 รายการ!',
  Roles: 'บทบาท',
  ZipForCountry: 'US, CA จำเป็น',
  PleaseZipForSend: 'โปรดเลือกไปรษณีย์เพื่อส่ง!',
  BL_EDI_SendChannel: 'B/L EDI ส่งช่อง',
  BL_EDI_SendTime: 'B/L EDI เวลาส่ง',
  VGM_EDI_SendChannel: 'ช่องส่ง VGM EDI',
  VGM_EDI_EDISendTime: 'VGM EDI ส่งเวลา',
  CleanManifest_EDI_SendChannel: 'ทำความสะอาด Manifests EDI ส่งช่อง',
  CleanManifest_EDI_SendTime: 'ทำความสะอาด Manifests EDI เวลาส่ง',
  Way99_EDI_SendChannel: 'ช่องส่ง EDI แบบเดี่ยว 99 ช่อง',
  Way99_EDI_SendTime: '99 Way Carry-on Single EDI เวลาในการส่ง',
  AMS_EDI_SendChannel: 'ช่องส่ง AMS EDI',
  AFR_EDI_SendChannel: 'ช่องส่ง AFR EDI',
  ACI_EDI_SendChannel: 'ช่องส่ง ACI EDI (CW)',
  ACI_EDI_SendTime: 'ACI EDI เวลาส่ง (CW)',
  AMS_JS_STATE: 'สถานะการส่ง AMS',
  ACI_JS_STATE: 'สถานะการส่ง ACI',
  AFR_JS_STATE: 'สถานะการส่ง AFR',
  AMS_EDI_SendTime: 'เวลาส่ง AMS EDI',
  AHR_EDI_SendTime: 'เวลาส่ง AHR EDI',
  ENS_EDI_SendTime: 'ENS เวลาส่ง',
  PreShippingBill_EDI_SendChannel: 'ช่องส่ง EDI',
  PreShippingBill_EDI_SendTime: 'รายการสินค้าล่วงหน้า EDI เวลาส่ง',
  OverseaAgent_EDI_SendChannel: 'ช่องทางการส่ง EDI สำหรับตัวแทนในต่างประเทศ',
  OverseaAgent_EDI_SendTime: 'ตัวแทนในต่างประเทศ EDI เวลาส่ง',
  PortOfHubSecond: 'ท่าเรือฮับ - เส้นทางที่สอง',
  PortOfHubThird: 'ท่าเรือฮับ - สามทาง',
  ProvisioningStatus: 'สถานะการประกอบล่วงหน้า',
  ArrivalInformation: 'ข้อมูลการเดินทาง',
  QuantityConsign: 'จำนวนชิ้น (คณะกรรมการ)',
  QuantityActual: 'จำนวนชิ้น (จริง)',
  WeightConsign: 'น้ำหนักรวม (คณะกรรมการ)',
  WeightActual: 'น้ำหนักรวม (ของแข็ง)',
  CubageConsign: 'ปริมาณ (คณะกรรมการ)',
  CubageActual: 'ปริมาณ (ของแข็ง)',
  VolumetricWeightConsign: 'วัสดุ (คณะกรรมการ)',
  VolumetricWeightActual: 'วัสดุ (ของแข็ง)',
  ChargeWeightConsign: 'น้ำหนักการเรียกเก็บเงิน (คณะกรรมการ)',
  ChargeWeightActual: 'น้ำหนักการเรียกเก็บเงิน (จริง)',
  CategoryOfGoodsName: 'ชื่อกลุ่มสินค้าขนาดใหญ่',
  ShipperLine2: 'บรรทัดที่สองของผู้จัดส่ง',
  ConsigneeLine2: 'บรรทัดที่สองของผู้รับ',
  NotifyPartyLine2: 'สายที่ 2',
  ShipperLine3: 'บรรทัดที่สามของผู้จัดส่ง',
  ConsigneeLine3: 'บรรทัดที่สามของผู้รับ',
  NotifyPartyLine3: 'สายที่ 3',
  ShipperLine4: 'บรรทัดที่ 4 ของผู้จัดส่ง',
  ConsigneeLine4: 'บรรทัดที่ 4 ของผู้รับ',
  NotifyPartyLine4: 'สายที่ 4',
  ShipperLine5: 'บรรทัดที่ 5 ของผู้จัดส่ง',
  ConsigneeLine5: 'บรรทัดที่ 5 ของผู้รับ',
  NotifyPartyLine5: 'สายที่ 5',
  ShipperLine6: 'บรรทัดที่ 6 ของผู้จัดส่ง',
  ConsigneeLine6: 'บรรทัดที่ 6 ของผู้รับ',
  NotifyPartyLine6: 'สายที่ 6',
  ShipperLine7: 'สายการจัดส่งที่ 7',
  ConsigneeLine7: 'บรรทัดที่ 7 ของผู้รับ',
  NotifyPartyLine7: 'สายที่ 7',
  OperationLog: 'บันทึกการทำงาน',
  DimensionLength: 'ขนาด CM (L)',
  DimensionWidth: 'ขนาด CM (W)',
  DimensionHeight: 'ขนาด CM (สูง)',
  SystemAdd: 'แพลตฟอร์มใหม่',
  FreeContainerEndTime: 'เวลาหมดอายุของตู้ฟรี',
  FreeStorageEndTime: 'ระยะเวลาหมดอายุของกองฟรี',
  QuantityConsign2: 'จำนวนชิ้น (มอบหมาย)',
  QuantityBooking: 'จำนวนชิ้น (จองห้องพัก)',
  QuantityActual2: 'จำนวนชิ้น (จริง)',
  QuantityDocumentation: 'จำนวนชิ้น (ทำแผ่น)',
  WeightConsign2: 'น้ำหนักรวม KGS (มอบหมาย)',
  WeightBooking: 'น้ำหนักรวม KGS (จองห้องโดยสาร)',
  WeightActual2: 'น้ำหนักรวม KGS (จริง)',
  WeightDocumentation: 'น้ำหนักรวม KGS (ใบสั่ง)',
  CubageConsign2: 'ปริมาณ CBM (มอบหมาย)',
  CubageBooking: 'ปริมาณ CBM (จองห้องโดยสาร)',
  CubageActual2: 'ปริมาณ CBM (จริง)',
  CubageDocumentation: 'ปริมาณ CBM (ใบสั่ง)',
  ChargeWeightConsign2: 'น้ำหนักการเรียกเก็บเงิน M / T (มอบหมาย)',
  ChargeWeightBooking: 'น้ำหนักการเรียกเก็บเงิน M/T (จองห้องโดยสาร)',
  ChargeWeightActual2: 'น้ำหนักการเรียกเก็บเงิน M/T (จริง)',
  ChargeWeightDocumentation: 'น้ำหนักการเรียกเก็บเงิน M / T (ทำใบสั่ง)',
  DensityConsign: 'ความหนาแน่น kg / m³ (ค่าคอมมิชชั่น)',
  DensityBooking: 'ความหนาแน่น kg / m³ (จองห้องโดยสาร)',
  DensityActual: 'ความหนาแน่น kg / m³ (จริง)',
  DensityDocumentation: 'ความหนาแน่น kg / m³ (ใบสั่ง)',
  ConsignationCompany2: 'หน่วยงานที่ได้รับมอบหมาย/ผู้แจ้งจริง',
  ConsignationCompanyHeader2: 'หัวหน้าหน่วย / หัวหน้าหน่วยรับแจ้งจริง',
  WarehouseSupplier2: 'คลังสินค้า ซัพพลายเออร์ / คลังสินค้า',
  ShipperDetail: 'รายละเอียดผู้จัดส่ง',
  ConsigneeDetail: 'รายละเอียดผู้รับ',
  NotifyDetail: 'รายละเอียดผู้แจ้ง',
  MasterBillNo2: 'หมายเลขเดี่ยวหลัก / MBL',
  SynchroniseBooking: 'ข้อมูลการจองห้องโดยสารแบบซิงโครนัส',
  HBLNoRepeat: 'มี HB / L NO ซ้ำ, หมายเลขเดียว:"{0}"',
  ConfirmSynchronizeHBL: 'ล้างข้อมูลใหม่ด้วยตนเองเมื่อใช้ Synchronise HBL จะดำเนินการต่อหรือไม่',
  GetFiles: 'รับไฟล์',
  UploadCustomerFiles: 'อัปโหลดชิ้นส่วนของลูกค้า',
  CustomerSelfIssuedFiles: 'เอกสารที่ลูกค้าออกให้ตนเอง',
  CheckTheBLLog: 'บันทึกคู่',
  Surrendered: 'ปล่อยแผ่น',
  InterfaceName: 'ชื่ออินเทอร์เฟซ',
  DataFlowDirection: 'การไหลของข้อมูล',
  CheckTheBLCenterApiLog: 'บันทึกศูนย์คู่เดียว',
  PleaseMaintainTheCorresponding: 'โปรดรักษาบุคลากร {0} ที่สอดคล้องกัน',
  PleaseMaintainThePhoneNumberOfTheCorrespondingPersonnel: 'โปรดรักษาหมายเลขโทรศัพท์มือถือของคู่กรณี',
  XhqCsrMsg: 'Signal Flag ฝ่ายบริการลูกค้า',
  copyLink: 'คัดลอกลิงค์',
  openLink: 'เปิดลิงค์',
  BillNotCfm: 'B / L ไม่ได้รับการยืนยันโปรดยืนยันก่อน',
  ATDIsNull: 'ยังไม่ได้ออกจากท่าเรือโปรดปล่อยแผ่นหลังจากออกจากท่าเรือ',
  BillNotRelease: 'สถานะการเปิดตัว B / L ไม่ใช่"สามารถใส่แผ่นได้"',
  CfmBillFirst: 'ยังไม่มี คลิกก่อน"ยืนยันใบสั่งคู่"',
  IsReleased: 'ใส่แผ่นแล้ว ไม่สามารถอัพโหลดต้นฉบับของลูกค้าซ้ำได้ที่นี่',
  IsReleased2: 'ใส่แผ่นโดยไม่ต้องทำซ้ำ',
  UnStartOrUnConfirmCanUpload: 'สามารถอัปโหลดไฟล์ได้เฉพาะสถานะ BL 【ยังไม่เริ่ม】 หรือ 【ยังไม่ได้รับการยืนยัน】',
  LinkIsNull: 'ลิงก์ว่างเปล่า',
  OnlySurrenderedSupport: 'วิธี B / L เท่านั้น "SURRENDERED" สนับสนุนแผ่นปล่อยไฟฟ้า',
  SynchronizePackingInfo: 'อัปเดตข้อมูลการบรรจุกล่องแบบซิงโครนัส',
  ManifestNotConfirmed: 'รายการยังไม่ยืนยัน!',
  AreYouSureSynchronizePackingInfo: 'แน่ใจนะว่าคุณต้องการซิงค์ข้อมูลการบรรจุหีบห่อ?',
  NoDataSynced: 'ไม่มีการซิงค์ข้อมูลใด ๆ โปรดยืนยันชนิดของกล่องชนิด ~',
  VirtualBillType: 'แบบฟอร์ม แยกประเภทเดียว',
  DestinationPortAgentIsNotEqualToDesignatedFreightAgent: 'ตัวแทนท่าเรือปลายทางไม่เท่ากับตัวแทนจัดส่งสินค้าที่ระบุ',
  MultipleCustomsDeclarationInaccurate: 'มีฉากที่ 1 จ๊อบ ได้รับมอบหมายจากศุลกากรหลายครั้งและข้อมูลจะคลาดเคลื่อน กรุณาติดต่อตัวแทนออกของเพื่อแจ้งรายละเอียดพิธีการศุลกากร',
  OnlySupportOneCustomsDeclaration: 'ฟังก์ชันนี้สามารถใช้ได้เฉพาะกับการสร้างสถานการณ์การมอบหมายศุลกากรเพียง 1 สถานการณ์ใน 1 ธุรกิจเท่านั้น',
  OnlySupportOneCustomsCommission: 'โปรดเลือกหนึ่งประกาศศุลกากรมอบหมายและขอตรวจสอบต้นฉบับ',
  hblRefNo: 'การถอดแผ่น hbl อ้าง',
  HBLRefNo2: 'HBL Ref No. ',
  BatchPushCharges: 'ค่าธรรมเนียมการผลักดันจำนวนมาก (Cross Commission)',
  ChargeConfirmed: 'ค่าธรรมเนียมที่จะได้รับการยืนยัน',
  ViewReception: 'ดูการรับ',
  ViewSending: 'ดู ส่ง',
  branchTransactions: 'ติดต่อสาขา',
  OurJobNo: 'หมายเลขธุรกิจของเรา',
  TheirJobNo: 'หมายเลขธุรกิจของฝ่ายตรงข้าม',
  firstSendTime: 'เวลาส่งครั้งแรก',
  ConfirmReceiveTheseCharges: 'ยืนยันจะรับค่าใช้จ่ายเหล่านี้หรือไม่',
  AuditOperator: 'ตรวจสอบผู้ประกอบการ',
  Dimensions: 'ขนาด สเปค (L * W * H หน่วย M)',
  DoorRemarks: 'Door Point หมายเหตุเพิ่มเติม',
  BillOfLadingDesignatedFreightAgentFeedback: 'B / L - ข้อเสนอแนะของตัวแทนที่ได้รับการแต่งตั้ง',
  ChangeValue: 'แก้ไขค่า',
  AcceptChange: 'ยอมรับการปรับเปลี่ยน',
  Rejected: 'ไม่ยอมรับ',
  AgentFeedbackRemarks1: 'ความคิดเห็นเกี่ยวกับการแก้ไขของสายตัวแทนการจัดส่งที่ได้รับการยอมรับ',
  AgentFeedbackRemarks2: 'ความคิดเห็นเกี่ยวกับการแก้ไขของสายตัวแทนการจัดส่งที่ได้รับการแต่งตั้งถูกปฏิเสธ,',
  AgentFeedbackRemarks3: 'โปรดออฟไลน์เพื่อยืนยันการแก้ไขขั้นสุดท้ายกับผู้จัดส่งและตัวแทนที่ได้รับการแต่งตั้ง',
  AgentEmailSend: 'การส่งจดหมายไปยังใบสั่งตัวแทนจัดส่งที่ระบุ',
  ETAFirstPortOfCall: 'วันที่จอดเทียบท่าครั้งแรก',
  ETAFirstPortOfCallNotNull: 'ในโหมดบนกระดาน"ETA First Port of Call"ไม่สามารถว่างได้',
  DocumentOffice: 'บริษัทเอกสาร',
  CustomerOffice: 'บริษัท บริการลูกค้า',
  PleaseReferToTheEmailForSpecificErrorInformation: 'ดูรายละเอียด จดหมายแจ้งข้อผิดพลาด',
  AMSDeleteTips: 'AMS นี้ไม่ส่ง AMS สำเร็จในระบบและไม่สามารถลบได้',
  MultipleMode: 'โหมดเดี่ยวหลายโหมด',
  NumberExchange: 'แลกเปลี่ยนหมายเลขเดียว',
  ReturnMode: 'กลับไปที่โหมดเดียว',
  OcrTip: '* เคล็ดลับ: มีอยู่ใน "การกำหนดค่าพื้นฐาน - การตั้งค่าการจดจำเอกสาร", การตั้งค่าฟิลด์บันทึกการแสดงเพิ่มเติม',
  OcrOtherInfo: 'ข้อมูลแผ่นบันทึกอื่น ๆ:',
  DocumentRecognitionSettings: 'การตั้งค่าการจดจำเอกสาร',
  SeOcr: 'การรับรองการส่งออกทางทะเล',
  ocrOtherField: 'โปรดเลือกช่องบันทึกเพิ่มเติม',
  ocrTextMapper: 'ระบุแผนที่คำ',
  IdentifyingText: 'จดจำคำ',
  mappedValue: 'ค่าแผนที่',
  addMapper: 'เพิ่มแผนที่',
  editMapper: 'แก้ไขแผนที่',
  supplierCharge: 'ค่าธรรมเนียมผู้ขาย',
  supplierOrderNo: 'หมายเลขผู้จัดจำหน่ายเดี่ยว',
  supplierName: 'ชื่อผู้ให้บริการ',
  supplierMatchName: 'ชื่อที่ตรงกับผู้ขาย',
  chargeItemLocal: 'ชื่อค่าธรรมเนียมท้องถิ่น',
  refMsg1: 'ข้อมูลอ้างอิง (I)',
  refMsg2: 'ข้อมูลอ้างอิง (2)',
  supportNo: 'หมายเลขเดี่ยวเสริม',
  pushTime: 'เวลาผลักดัน',
  confirmCharge: 'ค่าธรรมเนียมการยืนยัน',
  selectBeConfirmedCharge: 'โปรดเลือกค่าธรรมเนียมที่จะยืนยัน',
  RefreshSuccessfulRows: 'รีเฟรชแถบสำเร็จ {0}',
  SupplierFeesToBeProcessed: 'บาร์ค่าใช้จ่ายซัพพลายเออร์ที่จะดำเนินการ',
  ReceivingBranch: 'รับสาขา',
  ReceivingMatchBranch: 'รับชื่อสาขาที่ตรงกัน',
  PleaseRefreshThePage: 'ไม่พบรหัสแผนที่ โปรดรักษาแผนที่ หากได้รับการบำรุงรักษาโปรดรีเฟรช',
  BusinessDateIsNull: 'วันที่ประกอบธุรกิจตรงกันว่างเปล่า',
  NoJobMatch: 'ไม่มีธุรกิจจับคู่ รีเฟรช',
  ReleaseGoodsJY: 'ปล่อยสินค้า JY',
  ReleaseJY: 'ใส่ JY เดี่ยว',
  TakeContainerJY: 'ยกกระเป๋า JY',
  ContainerPreloadJY: 'บรรจุภัณฑ์ JY',
  CancelContainerPreloadJY: 'ยกเลิกการบรรจุ JY',
  ReleaseGoodsPhotos: 'ใส่รูปถ่ายของสินค้า',
  ReleaseGoodsStatus: 'สถานะการเปิดตัว',
  NoticeTime: 'เวลาแจ้งเตือน',
  ReleaseGoods: 'วางสินค้า',
  warehouseNoNotNull: 'หมายเลขโพซิชั่นขาเข้าไม่สามารถว่างได้',
  warehouseNotNull: 'ชื่อคลังสินค้าต้องไม่ว่างเปล่าโปรดเลือกคลังสินค้าหรือผู้จัดจำหน่ายคลังสินค้าที่ลงนามในหน้าพื้นฐาน',
  consignerNotNull: 'ผู้รับงานไม่สามารถว่างได้',
  ReleaseRemarks: 'ใส่หมายเหตุแผ่น',
  RequireDate: 'วันที่ต้องการ',
  TakeContRemarks: 'หมายเหตุการยกกล่อง',
  ConfirmSendPackingInstructions: 'แน่ใจที่จะส่งคำสั่งบรรจุ?',
  AlreadySentReleaseGoods: 'ส่งแผ่นวางจำหน่ายแล้วไม่ผลักดันหลายครั้ง',
  PleaseSelectWarehouseNo: 'กรุณาเลือกหมายเลขโพซิชั่นขาเข้า',
  TheWarehouseNoHasBeenReleased: 'หมายเลขเข้าโพซิชั่นเคยส่งแล้วยังส่งอยู่หรือไม่',
  ViewReleaseGoodsPhotos: 'ดูรูปถ่ายของการวางสินค้า',
  JyWarehouseInterfaceLog: 'บันทึกการเชื่อมต่อคลังสินค้า Oracle',
  JyWarehouseApiLog: 'บันทึกการเชื่อมต่อคลังสินค้า Oracle',
  LclDynamic: 'LCL แบบไดนามิก',
  TakeContainerNotice: 'แจ้งยกกระเป๋าเดินทาง',
  TakeContainerDone: 'การยกกล่องเสร็จสิ้น',
  PreloadContainerOrder: 'คำแนะนำการบรรจุ',
  PreloadContainerDone: 'บรรจุเสร็จแล้ว',
  SendPort: 'ส่งรถ',
  SendPortStart: 'ออกเดินทางจากฮ่องกง',
  ArrivalPort: 'ขาเข้า (รายงานคลังสินค้า)',
  ExistEmptyContainer: 'กล่องที่ติ๊ก หน่วยความจำในกล่องที่มีข้อมูลการบรรจุว่างเปล่า',
  docLink: 'ลิงค์เดี่ยว',
  Field: 'เขตข้อมูล',
  ErrorDescription: 'คำอธิบายข้อผิดพลาด',
  VerificationPrompt: 'เคล็ดลับการตรวจสอบ',
  InformationSavingOnly: 'บันทึกข้อมูลเท่านั้น',
  Required: 'จำเป็น',
  InputTwoAbove: 'กรุณากรอกมากกว่า 2 หลัก',
  SendError: 'ส่งล้มเหลว',
  CounterTerrorismManifestConfiguration: 'การกำหนดค่า Manifold ต่อต้านการก่อการร้าย',
  AfrAccount: 'บัญชี AFR',
  AfrPassword: 'รหัสผ่าน AFR',
  ApplicantEORI: 'แถลงการณ์ EORI',
  AccountIsNotNull: 'โปรดเลือกหมายเลขบัญชีที่ส่ง',
  PasswordIsNotNull: 'กรุณารักษารหัสผ่านที่ส่งไป',
  Notification: 'ประกาศ',
  Error: 'ข้อมูลที่ไม่ถูกต้อง',
  NoSendingRecord: 'ไม่มีประวัติการส่ง',
  GetExceptions: 'รับข้อยกเว้น',
  WaitingReceipt: 'การปรากฏตัวของชื่อเรือเดียวกันเที่ยวบินเดียวกัน Nvocc SCAC เดียวกันยังไม่ได้รับการตอบสนองศุลกากรในขณะนี้ไม่สามารถส่งโปรดอดทน',
  NotOperable: 'หากไม่ได้รับการตอบกลับหรือส่งไม่สำเร็จไม่สามารถส่งต้นฉบับแก้ไขลบ',
  AmsVgm: 'รายการสินค้า / VGM',
  AmsReceipt: 'AMS ตอบกลับ',
  AciReceipt: 'ACI ตอบกลับ',
  AfrReceipt: 'AFR ตอบกลับ',
  VgmReceipt: 'VGM ตอบกลับ',
  ManifestReceipt: 'การจัดส่งสินค้าล่วงหน้า',
  UserDefinedRole1: 'โพสต์ที่กำหนดเอง 1',
  UserDefinedRole2: 'โพสต์ที่กำหนดเอง 2',
  AmsReceiptRemind: 'การแจ้งเตือนการตอบกลับรายการต่อต้านการก่อการร้าย',
  DangerousCargoCode: 'ประเภทของสินค้า - สินค้าอันตราย',
  CustomerToOrder: 'แบบฟอร์มลูกค้า',
  DesignatedGoodsToBillOfLading: 'ระบุคู่สินค้า',
  OverwriteOriginalRemark: 'ครอบคลุมต้นฉบับ 【หมายเหตุสำหรับการจองระยะไกล】',
  DownloadPortServiceScope: 'ดาวน์โหลดขอบเขตการให้บริการท่าเรือ',
  AllowSaleProduct: 'ผลิตภัณฑ์ที่สามารถขายได้',
  FullOrInside: 'การเดินทางทั้งหมด / ในประเทศ',
  Commissioned: 'ได้รับมอบหมาย',
  weightVolumeBillWeightConsolidated: 'น้ำหนัก / ปริมาณ / น้ำหนักการเรียกเก็บเงินที่มีและเดี่ยว',
  weightVolumeBillWeightConsolidatedTip: 'ธุรกิจที่เลือกมีอยู่และสั่งจะนับและสั่งน้ำหนัก / ปริมาตร / น้ำหนักการเรียกเก็บเงิน สถิติปริยายของน้ำหนัก / ปริมาตร / น้ำหนักการเรียกเก็บเงินของป้ายหน้าพื้นฐาน',
  AttentionForSynchronizedContainer: 'หมายเหตุ: การตั้งค่านี้มีผลเมื่อกรอกหมายเลขกล่อง หากไม่ครบก็จะไม่มีผล',
  BatchFillGpExplain: 'คำแนะนำในการเติม GP เป็นกลุ่ม',
  AiDocRecognition: 'การระบุเอกสาร AI',
  AiRecognition: 'การรับรู้ AI',
  SupportMultipleFiles: 'รองรับการระบุ B / L ของผู้ส่งต่อการยืนยัน B / L เอกสารสนับสนุนและอื่น ๆ อีกมากมาย!',
  DragOrClick: 'ลากไฟล์มาที่นี่หรือ',
  ClickUpload: 'คลิกเพื่ออัพโหลด',
  FileSizeLimit: 'สามารถอัพโหลดได้เพียง 1 ไฟล์ต่อครั้ง ไม่เกิน 4 MB ต่อไฟล์',
  InvalidFileType: 'ประเภทแฟ้มไม่ถูกต้อง',
  FileTooLarge: 'ขนาดไฟล์ไม่เกิน 4MB',
  Reupload: 'อัพโหลดใหม่',
  StartRecognition: 'เริ่มระบุ',
  RecognitionInProgress: 'การระบุตัวตน ... กรุณาในภายหลังใช้เวลาประมาณ 15 วินาที',
  RecognitionTextTip: 'กรุณาคลิกที่ปุ่มระบุหลังจากคัดลอกและวางเนื้อหาโดยตรงระบบจะระบุและเติมเนื้อหาลงในฟิลด์ที่สอดคล้องกันโดยอัตโนมัติ',
  EstimatedTime: 'คาดว่าจะใช้เวลา {time}',
  RecognitionSuccess: 'ระบุความสำเร็จ',
  RecognitionFailed: 'การระบุล้มเหลว',
  AiRecognitionWarn: 'การระบุ AI อาจมีข้อผิดพลาดโปรดตรวจสอบอย่างรอบคอบก่อนส่ง',
  SupportsShanghaiPortShipAgent: 'สนับสนุนเฉพาะการตรวจสอบเรือที่สอดคล้องกับท่าเรือเซี่ยงไฮ้',
  ServiceNotActivated: 'คุณไม่ได้เปิดบริการ',
  updateOrderContent: 'อัปเดตเนื้อหาการสั่งซื้อ',
  CheckCustomsBrokerComfirm: 'เลือก 【ตัวแทนออกของ】 ฟิลด์ 【ตัวแทนออกของ】 ของธุรกิจที่เกี่ยวข้องจะได้รับการอัปเดตเป็นกลุ่ม ยืนยันหรือไม่?',
  CheckCustomsBrokerComfirm2: 'เลือก 【บริการพิธีการศุลกากร】 แต่ไม่ได้เลือก 【บริการพิธีการศุลกากร】 ฟิลด์ 【บริการพิธีการศุลกากร】 ของธุรกิจของคุณจะว่างเปล่าเป็นกลุ่มได้รับการยืนยันหรือไม่?',
  ClearCustomsBrokerComfirm: 'ทำเครื่องหมายเพื่อล้างธุรกิจบริการท้องถิ่น 【ประกาศศุลกากร】 และล้างฟิลด์ 【ประกาศศุลกากร】 ของธุรกิจที่เลือกเป็นชุด ๆ ยืนยันหรือไม่?',
  EdiEuBolInfo: 'ข้อมูลเพิ่มเติมเกี่ยวกับ BL ของสายยุโรป',
  EuroLineENSDeclaration: 'เครื่องหมายประกาศ ENS ของสายยุโรป',
  SelectEuroLineENSDeclaration: 'กรุณาเลือก"เครื่องหมายประกาศ ENS ของสายยุโรป"',
  ManifestType: 'ประเภทของรายการสินค้า',
  SelectManifestType: 'กรุณาเลือกประเภทของรายการสินค้า',
  SupplementaryDeclarant: 'เอกสารเพิ่มเติม',
  ChemicalIdentifier: 'การระบุสารเคมี',
  ChemicalProduct: 'เคมีภัณฑ์',
  NonChemicalProduct: 'ไม่ใช่สารเคมี',
  ChemicalCUSCODE: 'สารเคมี CUS CODE',
  PostalInformation: 'ข้อมูลไปรษณีย์',
  PostalInformation2: 'ไปรษณีย์ <br> (เลือกอย่างใดอย่างหนึ่งกับชื่อถนน, หมายเลข)',
  EORICode: 'รหัส EORI',
  ShipperStreetNumber: 'หมายเลขถนนของผู้จัดส่ง',
  ShipperStreetName: 'ชื่อถนนของผู้จัดส่ง',
  ActualShipperStreetNumber: 'หมายเลขถนนของผู้จัดส่งจริง',
  ActualShipperStreetName: 'ชื่อถนนของผู้จัดส่งจริง',
  ShipperZipCode: 'รหัสไปรษณีย์ของผู้จัดส่ง',
  ShipperAddress: 'ที่อยู่ของผู้จัดส่ง',
  ConsigneeStreetNumber: 'หมายเลขถนนของผู้รับ',
  ConsigneeStreetName: 'ชื่อถนนของผู้รับ',
  ActualConsigneeStreetNumber: 'หมายเลขถนนของผู้รับจริง',
  ActualConsigneeStreetName: 'ชื่อถนนของผู้รับจริง',
  ConsigneeZipCode: 'รหัสไปรษณีย์ของผู้รับ',
  ConsigneeAddress: 'ที่อยู่ผู้รับ',
  NotifyStreetNumber: 'แจ้งหมายเลขถนน',
  NotifyStreetName: 'แจ้งชื่อถนน',
  NotifyZipCode: 'รหัสไปรษณีย์',
  ActualShipper: 'ผู้ส่งจริง',
  ActualShipperName: 'ชื่อผู้จัดส่งจริง',
  ActualConsignee: 'ผู้รับสินค้าจริง',
  ActualConsigneeName: 'ชื่อผู้รับจริง',
  ByBillingDate: 'ตามวันที่สร้างบิล',
  ByBusinessDate: 'ตามวันที่ประกอบธุรกิจ',
  CostRateValue: 'มูลค่าของอัตราแลกเปลี่ยนค่าธรรมเนียม',
  CopyBusiness: 'คัดลอกธุรกิจ',
  CopyActualShipper: 'คัดลอกผู้ส่ง',
  CopyActualConsignee: 'คัดลอกผู้รับ',
  SelectEORICode: 'โปรดป้อนข้อมูลรหัส EORI ในคอลัมน์ {0}',
  TOOrderRequired: 'สั่งการให้',
  EORICodeExample: 'ประเภทรหัส + หมายเลขรหัส',
  PlsInputParameter: 'กรุณากรอก {0}',
  PlsSelectUnLCL: 'โปรดเลือกประเภทธุรกิจที่ไม่ใช่แบบ LCL',
  StreetInfo: 'หมายเลขถนน ชื่อถนน หรือข้อมูลไปรษณีย์',
  ImportingLater: 'กำลังนำเข้า โปรดดำเนินการภายหลัง',
  BusinessSeq: 'หมายเลขลำดับธุรกิจ',
  Yard: 'สถานีสนาม',
  PleaseSelectCarrier: 'โปรดเลือกผู้ให้บริการที่สอดคล้องกับหมายเลข B / L',
  ModifyStatus: 'แก้ไขสถานะ',
  ModifyManifestStatusTip: 'รองรับสถานะการแก้ไขหมายเลขศุลกากรที่ส่งรายการศุลกากรเท่านั้น',
  AllSoNos: 'หมายเลขปิดทั้งหมด',
  PlsSelectSoNo: 'โปรดเลือกหมายเลขรหัสที่ต้องการแก้ไข',
  FclOrderType: 'รายละเอียดการสั่งซื้อ FCL',
  LclOrderType: 'รายละเอียดการสั่งซื้อ LCL',
  ConsoleOrderType: 'รายละเอียดการสั่งซื้อ Console',
  CopyBusinessSendConsigneeNotify: 'สำเนาจดหมายเวียนธุรกิจ',
  DeclarationInformation: 'ข้อมูลการประกาศ',
  RelatedInformation: 'ข้อมูลบุคคลที่เกี่ยวข้อง',
  SubstratumDeclarant: 'ประกาศระดับล่าง',
  PortInformation: 'ข้อมูลท่าเรือ',
  BuyerName: 'ชื่อผู้ซื้อ',
  BuyerAddress: 'ที่อยู่ของผู้ซื้อ',
  BuyerEORICode: 'รหัส EORI ของผู้ซื้อ',
  BuyerPostalCode: 'รหัสไปรษณีย์ของผู้ซื้อ',
  BuyerCountry: 'ประเทศผู้ซื้อ',
  BuyerCity: 'เมืองของผู้ซื้อ',
  SellerName: 'ชื่อผู้ขาย',
  SellerAddress: 'ที่อยู่ผู้ขาย',
  SellerEORICode: 'รหัส EORI ของผู้ขาย',
  SellerPostalCode: 'รหัสไปรษณีย์ของผู้ขาย',
  SellerCountry: 'ประเทศผู้ขาย',
  SellerCity: 'เมืองของผู้ขาย',
  UCRNO: 'UCR NO',
  ShipperEORI: 'ผู้ส่ง EORI',
  ConsigneeEORI: 'ผู้รับ EORI',
  NotifyEORI: 'แจ้งเตือนโดย EORI',
  FactoryEORI: 'โรงงาน EORI',
  WarehouseEORI: 'คลังสินค้า EORI',
  LCLPersonEORI: 'LCL คน EORI',
  ActualShipperCountry: 'ประเทศผู้ส่ง',
  ActualShipperCity: 'เมืองของผู้จัดส่ง',
  ActualRecipientCountry: 'ประเทศผู้รับ',
  ActualRecipientCity: 'เมืองของผู้รับ',
  NotifyPhone: 'แจ้งทางโทรศัพท์',
  NotificationCountry: 'แจ้งประเทศ',
  NotifyPersonCity: 'แจ้งเตือนประชาชน เมือง',
  BuyerStreetNumber: 'หมายเลขถนนของผู้ซื้อ',
  BuyerStreetName: 'ชื่อถนนของผู้ซื้อ',
  SellerStreetNumber: 'หมายเลขถนนของผู้ขาย',
  SellerStreetName: 'ชื่อถนนของผู้ขาย',
  CopyActualRecipient: 'คัดลอกผู้รับจริง',
  CopyActualShip: 'คัดลอกผู้ส่งจริง',
  LinkSendAmsError: 'ไม่อนุญาตให้ส่งซ้ำขณะกำลังส่ง',
  DangerousCode: 'รหัสสินค้าอันตราย',
  PleaseEnterHeader: 'กรุณาระบุหัวเรื่อง',
  PleaseEnterAddress: 'กรุณาระบุที่อยู่ 1',
  PleaseEnterAddress2: 'กรุณาระบุที่อยู่ 2',
  PleaseSelectCountry: 'กรุณาเลือกประเทศ',
  PhoneFormat: 'กรอกเฉพาะตัวเลข',
  PleaseEnterState: 'กรุณาระบุรัฐ/จังหวัด',
  PleaseEnterCity: 'กรุณาระบุเมือง',
  PleaseEnterPostalCode: 'กรุณาระบุรหัสไปรษณีย์',
  PleaseEnterMbl: 'กรุณาระบุหมายเลขใบตราส่งหลัก ไม่รวม SCAC code',
  VesselCallSignCheck: 'เฉพาะตัวพิมพ์ใหญ่และตัวเลข 1-9 ตัว',
  MarksFormat: 'เฉพาะตัวอักษรภาษาอังกฤษใหญ่/เล็ก, ตัวเลข, ขีดกลาง, ทับ, จุลภาค, ช่องว่าง, ทวิภาค, อัญประกาศ, บวก, ขีดล่าง',
  MustBe3: 'ต้องมี 3 อักขระเท่านั้น',
  OneCargoInfo: 'เพิ่มข้อมูลสินค้ารวมเพียง 1 รายการ',
  Instructions: 'อธิบายเหตุผลโดยละเอียด',
  ExplanationRequired: 'เลือก “อื่นๆ” ต้องกรอกช่องนี้',
  ConfirmDeletion: 'ยืนยันการลบ',
  HblCheck: 'อนุญาตเฉพาะตัวพิมพ์ใหญ่, ตัวเลข, ขีดกลาง และทับ',
  MustBe2: 'ต้องมี 2 อักขระเท่านั้น',
  MustBe11: 'ต้องมี 11 อักขระ ตัวอักษรหรือตัวเลข อักขระที่ 4 ต้องเป็น U',
  MustBeU: 'อักขระที่สี่ต้องเป็น U',
  MustBe4: 'ต้องมี 4 อักขระเท่านั้น',
  VesselNotNull: 'กรุณาระบุชื่อเรือในแท็บการจอง',
  VoyageNotNull: 'กรุณาระบุเลขที่เที่ยวเรือในแท็บการจอง',
  EtaNotNull: 'กรุณาระบุ ETA ในแท็บข้อมูลพื้นฐาน',
  StreetName: 'ชื่อถนน',
  ExampleIllustrateEORI: 'ตัวอย่าง EORI12828',
  CycleTwoHundredTimesNotUseMbl: 'ได้รับการขยาย 200 ครั้งและไม่พบรายการศุลกากรที่ใช้',
  GenerateMblButLessThan: 'สร้างแถบ 【{0}】 และไม่มีหมายเลขปิดที่เหลืออยู่',
  selectedRowCount: 'เลือก: {0} รายการ',
  specialOperationCode: 'รหัสปฏิบัติการพิเศษ',
  doubleClickToAddSpecialOperationCode: 'เพิ่มรหัสปฏิบัติการพิเศษด้วยการคลิกสองครั้ง',
  selectSpecialOperationCode: 'คลิกสองครั้งเพื่อเลือกรหัสปฏิบัติการพิเศษ',
  selectOperationRequirement: 'คลิกสองครั้งเพื่อเลือกข้อกำหนดการดำเนินการ',
  TransshipmentTransportationMethod: 'วิธีการโอน',
  specialHandlingCodes: 'รหัสปฏิบัติการพิเศษ',
  AddApproximateSymbolToItemColumn: 'เพิ่มหมายเลขโดยประมาณไปยังแถบชื่อ',
  BusinessLockedStatus: 'สถานะล็อคธุรกิจ',
  ImportChargeAllBusiness: 'เมื่อหมายเลขธุรกิจหนึ่งมีอยู่ในหลายประเภทธุรกิจพร้อมกันจะถูกประมวลผลทั้งหมด นั่นคือหมายเลขมีอยู่ในทะเลออกและนำเข้าในธุรกิจทะเลออกและนำเข้าในธุรกิจทะเลออกในเวลาเดียวกัน',
  OriginBillOfLading: 'ต้นฉบับ B / L',
  ShippingOrder: 'เอกสารฝากหนังสือ',
  EmptyOut: 'กล่องเปล่า (Empty Out)',
  GateIn: 'เวลาเข้าตู้คอนเทนเนอร์ (ประตูใน)',
  VesselDeparturePOL: 'เรือออกจากท่า (Vessel Departure POL)',
  SendAll: 'ส่งทั้งหมดในครั้งเดียว',
  PendingPickingOrder: 'คำสั่งซื้อที่รอรับ',
  PickingList: 'รายการหยิบสินค้า',
  WarehouseReleaseReceipt: 'รายการออกจากตำแหน่ง',
  QuickSearchMBL: 'ดึงข้อมูลได้อย่างรวดเร็ว: หมายเลขเดี่ยวหลัก',
  QuickSearchPickingOrderNo: 'ดึงข้อมูลได้อย่างรวดเร็ว: หมายเลขใบสั่งซื้อ',
  DeliveryStation: 'สถานีขนส่งสินค้า',
  AssemblyPlanNumber: 'หมายเลขแผนการประกอบ',
  FlightDateRange: 'ช่วงวันเดินทาง',
  OutboundInstruction: 'มีคำสั่งออกจากตำแหน่งหรือไม่',
  WarehouseEntryNumber: 'หมายเลขรายการเข้า',
  BoardNumber: 'หมายเลขกระดาษบอร์ด',
  GenerateAPickingList: 'สร้างใบรับสินค้า',
  GenerateAndIssueOrders: 'สร้างและออกเอกสาร',
  PickingOrderNumber: 'หมายเลขใบสั่งซื้อ',
  PickingStatus: 'สถานะการหยิบสินค้า',
  ThisPickingOrderNoIs: 'หมายเลขใบรับสินค้านี้คือ',
  SuccessfullyGenerated: 'สร้างความสำเร็จ',
  CloseAndCopyPickingOrderNo: 'ปิดและคัดลอกหมายเลขใบรับสินค้า',
  PleaseCheckSameDataWareHouse: 'สินค้าจากคลังสินค้าที่แตกต่างกันไม่สามารถอยู่ในรายการหยิบสินค้าเดียว',
  DifferentGoodsCannotSamePickingList: 'สินค้าจากสถานีจัดส่งที่แตกต่างกันไม่สามารถอยู่ในใบหยิบสินค้าเดียว',
  PickingCompleted: 'เลือกสินค้าเสร็จสมบูรณ์',
  CancelPickingCompleted: 'การยกเลิกการหยิบสินค้าเสร็จสิ้น',
  OutboundStatus: 'สถานะออกจากตำแหน่ง',
  OutboundConfirmation: 'ยืนยันการออกจากตำแหน่ง',
  CancelWarehouseConfirmation: 'ยกเลิกการยืนยันการออกจากตำแหน่ง',
  WarehouseConfirmationSuccessful: 'ออกจากตำแหน่งยืนยันความสำเร็จ',
  CancelWarehouseConfirmationSuccessfully: 'ยกเลิกการออกจากโพซิชั่น ยืนยันความสำเร็จ',
  PleaseSelectCorrespondPickingList: 'กรุณาระบุใบรับสินค้า',
  PleaseCheckDataPickingCompletionUnOutBound: 'กรุณาเลือกข้อมูลที่ Picking เสร็จสมบูรณ์และยังไม่ได้ออกจากตำแหน่ง',
  PleaseCheckDataPickingCompletionOutBound: 'กรุณาเลือกข้อมูลที่ Pick up เสร็จสมบูรณ์และออกจาก Position แล้ว',
  NotAllowEditPickingCompletion: 'ไม่อนุญาตให้แก้ไขข้อมูลที่เสร็จสิ้นการหยิบสินค้า',
  NotAllowDeletePickingCompletion: 'ข้อมูลที่หยิบเสร็จแล้วไม่อนุญาตให้ลบ',
  PleaseCheckDataRemoved: 'กรุณาเลือกข้อมูลที่ต้องการลบ',
  KeepLeastOneDetail: 'เก็บรายละเอียดอย่างน้อยหนึ่งรายการ',
  CargoVehicle: 'เรนจ์คาร์',
  OutboundRemarks: 'หมายเหตุออกจากตำแหน่ง',
  DeliveryTime3: 'เวลารับสินค้า',
  OutboundUser: 'ผู้ส่งออก',
  QueryThreeMonths: 'หมายเหตุ: ข้อมูลการสอบถามคือข้อมูลภายในสามเดือน',
  operationTrajectory: 'เส้นทางการดำเนินงาน',
  pickupEmptyContainer: 'รับตู้คอนเทนเนอร์เปล่า',
  arrivalFactory: 'ถึงโรงงาน',
  departureFactory: 'ออกจากโรงงาน',
  enterTerminal: 'เข้าสู่ท่าเรือ',
  customsRelease: 'ปล่อยศุลกากร',
  terminalRelease: 'ปล่อยจากท่าเรือ',
  loadedOnVessel: 'ขนถ่ายขึ้นเรือ',
  departurePort: 'ออกจากท่าเรือ',
  arrivalPort: 'ถึงท่าเรือ',
  destinationCustomsClearance: 'ผ่านศุลกากรที่ปลายทาง',
  deliveryGoods: 'การจัดส่ง',
  returnContainer: 'คืนตู้คอนเทนเนอร์',
  driver: 'คนขับ',
  contactInfo: 'ข้อมูลติดต่อ',
  licensePlate: 'ป้ายทะเบียน',
  jobNumber: 'เลขที่งาน',
  vesselVoyage: 'เรือและเที่ยวบิน',
  customsDeclarationNo: 'เลขที่ประกาศศุลกากร',
  sailingDate: 'วันที่ออกเรือ',
  closingTime: 'เวลาปิดศุลกากร',
  PreWarehouseNumberOfPackages: 'จำนวนชิ้นในคลังสินค้าหน้า',
  PreWarehouseGrossWeight: 'น้ำหนักรวมในคลังสินค้าหน้า',
  PreWarehouseVolume: 'ปริมาตรในคลังสินค้าหน้า',
  PreWarehouseChargeableWeight: 'น้ำหนักคิดค่าขนส่งในคลังสินค้าหน้า',
  CargoTerminalNumberOfPackages: 'จำนวนชิ้นในสถานีขนส่ง',
  CargoTerminalGrossWeight: 'น้ำหนักรวมในสถานีขนส่ง',
  CargoTerminalVolume: 'ปริมาตรในสถานีขนส่ง',
  CargoTerminalChargeableWeight: 'น้ำหนักคิดค่าขนส่งในสถานีขนส่ง',
  DocumentationChargeableWeight: 'น้ำหนักคิดค่าขนส่งในเอกสาร',
  SignedDocumentNumberOfPackages: 'จำนวนชิ้นในเอกสารที่เซ็นแล้ว',
  SignedDocumentGrossWeight: 'น้ำหนักรวมในเอกสารที่เซ็นแล้ว',
  SignedDocumentVolume: 'ปริมาตรในเอกสารที่เซ็นแล้ว',
  SignedDocumentChargeableWeight: 'น้ำหนักคิดค่าขนส่งในเอกสารที่เซ็นแล้ว',
  WarehouseEntrySerialNumber: 'สถานะการไหล',
  DeadlineForDeclaringHazards: 'กำหนดเวลาแจ้งความเสี่ยง',
  BookingManagementListPage: 'หน้ารายการการจัดการที่นั่ง',
  PrintByFleet: 'พิมพ์ตามฝูงรถ',
  BoxContents: 'รายละเอียดสินค้าในกล่อง',
  BatchAssignMasterOrderNumbers: 'จัดสรรหมายเลขใบสั่งซื้อหลักแบบเป็นกลุ่ม',
  PleaseForThePositiveAssign: 'โปรดเลือกธุรกิจที่ดำเนินการตามบวกเพื่อจัดสรร',
  SuccessfullyItemsFailed1Items: 'จัดสรรสำเร็จ {0} รายการ ล้มเหลว {1} รายการ!',
  ReasonForFailure: 'สาเหตุของการล้มเหลว:',
  MBLNOAlreadyExists: 'เลขที่ MB/L ถูกใช้งานแล้ว',
  NonOperational: 'ไม่ใช้งาน',
  UnableTheMainTrackingNumber: 'ไม่สามารถจับคู่หมายเลขหลักได้',
  WarehouseEntryInformation: 'ข้อมูลการเข้าคลังสินค้า',
  NumberOfItemsReceived: 'จำนวนชิ้นที่เข้าคลัง',
  GrossWeightUponEntry: 'น้ำหนักรวมเมื่อเข้าคลัง',
  WarehouseVolume: 'ปริมาตรคลังสินค้า'
}
